// WHITE MAGE MUSIC CRM — Frontend App
// Session 2B: Year selector, competitions, deliver-by dates, design status, composition fields

const API = '/api/v1';

// ── Access role (admin | viewer) ────────────────────────────────────────────
window.WMM_ROLE = 'admin'; // default until /auth/me resolves

function maskForViewer(value, type = 'text') {
  if (window.WMM_ROLE !== 'viewer' || !value) return value;
  const masks = {
    name:  '●●●●● ●●●●●',
    email: '●●●●●@●●●●●.●●●',
    phone: '(●●●) ●●●-●●●●',
    money: '—',
    notes: '',
  };
  return masks[type] !== undefined ? masks[type] : '●●●●●';
}

async function initRole() {
  try {
    const r = await fetch('/api/v1/auth/me');
    const d = await r.json();
    window.WMM_ROLE = d.role || 'admin';

    if (!d.role) {
      // Unauthenticated — send to login
      window.location.href = '/login';
      return;
    }

    if (window.WMM_ROLE === 'viewer') {
      document.body.classList.add('viewer-mode');
      const badge = document.createElement('div');
      badge.className = 'viewer-badge';
      badge.textContent = 'View Only';
      document.body.appendChild(badge);
    } else {
      // Show sign-out button for admin
      const logoutBtn = document.getElementById('btn-logout');
      if (logoutBtn) {
        logoutBtn.style.display = 'inline-flex';
        logoutBtn.addEventListener('click', async () => {
          await fetch('/logout', { method: 'POST' });
          window.location.href = '/login';
        });
      }
    }
  } catch (e) { /* stay as admin default */ }
}

// ── Undo stack (last destructive action) ────────────────────────────────────
let _undoStack = null; // { type, data } — only one level deep
let _undoTimer = null;

function pushUndo(type, data) {
  _undoStack = { type, data };
  const btn = document.getElementById('btn-undo');
  if (btn) { btn.style.display = 'inline-flex'; }
  clearTimeout(_undoTimer);
  _undoTimer = setTimeout(() => {
    _undoStack = null;
    const b = document.getElementById('btn-undo');
    if (b) b.style.display = 'none';
  }, 30000); // auto-dismiss after 30 seconds
}

async function applyUndo() {
  if (!_undoStack) return;
  const { type, data } = _undoStack;
  _undoStack = null;
  clearTimeout(_undoTimer);
  const btn = document.getElementById('btn-undo');
  if (btn) btn.style.display = 'none';

  if (type === 'delete_collaborator') {
    await api('/collaborators', {
      method: 'POST',
      body: JSON.stringify({
        client_id: data.client_id,
        name: data.name,
        role: data.role,
        phone: data.phone,
        email: data.email,
        season_year: data.season_year
      })
    });
    // Reload the collaborators tab if the client card is still open
    if (state.currentClientId === data.client_id) {
      loadCollaboratorsTab(data.client_id, data.season_year);
    }
  }
}

// ── Logo preload for PDF generation ────────────────────────────────────────
let _wmmLogoData = null;
(function() {
  const img = new Image();
  img.onload = function() {
    try {
      const c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      _wmmLogoData = { url: c.toDataURL('image/png'), w: img.width, h: img.height };
    } catch(e) {}
  };
  img.src = '/WMM_ReW.png';
})();

let _rwmLogoData = null;
(function() {
  const img = new Image();
  img.onload = function() {
    try {
      const c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      _rwmLogoData = { url: c.toDataURL('image/png'), w: img.width, h: img.height };
    } catch(e) {}
  };
  img.src = '/RWM_Final_Logo.png';
})();

let _wmmBlwLogoData = null;
(function() {
  const img = new Image();
  img.onload = function() {
    try {
      const c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      _wmmBlwLogoData = { url: c.toDataURL('image/png'), w: img.width, h: img.height };
    } catch(e) {}
  };
  img.src = '/WMM_BlW.png';
})();

// ── State ──────────────────────────────────────────────────────────────────
const state = {
  clients: [],
  allShows: [],
  currentClientId: null,
  currentTab: 'shows',
  previousView: 'dashboard',
  selectedYear: new Date().getFullYear(),
  clientDetailYear: null,
  inboxItemsById: {},
  highlightNoteId: null
};

// ── API Helpers ────────────────────────────────────────────────────────────
async function api(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined
  });
  if (!res.ok) {
    if (res.status === 401) {
      window.location.href = '/login';
      return;
    }
    const text = await res.text();
    // If the server returned HTML (wrong route), give a useful message
    throw new Error(text.startsWith('<') ? `Server error (${res.status}) — check API route` : text);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}

// ── View Router ────────────────────────────────────────────────────────────
const views = ['dashboard', 'contacts', 'client-detail', 'calendar', 'inbox', 'copyright', 'invoices', 'intake', 'competition', 'business', 'staff-bus', 'portal-admin'];

function showView(name) {
  views.forEach(v => {
    const el = document.getElementById(`view-${v}`);
    if (el) el.classList.remove('active');
  });
  document.querySelectorAll('.nav-btn').forEach(b => b.classList.remove('active'));
  const target = document.getElementById(`view-${name}`);
  if (target) target.classList.add('active');
  const navBtn = document.querySelector(`[data-view="${name}"]`);
  if (navBtn) navBtn.classList.add('active');
  // Persist non-client views so refresh restores the right screen
  if (name !== 'client-detail') {
    sessionStorage.setItem('wmmNavState', JSON.stringify({ view: name }));
  }
  // Update topbar title
  const titleMap = {
    dashboard: 'Dashboard', inbox: 'Email', intake: 'Intake',
    contacts: 'Contacts', calendar: 'Calendar', invoices: 'Invoices',
    copyright: 'Copyright', competition: 'Competition', business: 'Business',
    'staff-bus': 'Staff Bus', 'portal-admin': 'Portal', 'client-detail': 'Client',
  };
  const titleEl = document.getElementById('topbar-title');
  if (titleEl) titleEl.textContent = titleMap[name] || name;
  const seasonTag = document.getElementById('topbar-season');
  if (seasonTag) seasonTag.style.display = name === 'dashboard' ? '' : 'none';
}

// ── Format Helpers ─────────────────────────────────────────────────────────
function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function dueDateClass(dateStr) {
  if (!dateStr) return '';
  const days = (new Date(dateStr) - new Date()) / (1000 * 60 * 60 * 24);
  if (days < 0) return 'due-date-late';
  if (days <= 14) return 'due-date-soon';
  return 'due-date-on-track';
}

function typeIcon(type) {
  const icons = { youtube: '▶', spotify: '♪', pdf: '📄', url: '🔗', other: '🔗' };
  return icons[type] || '🔗';
}

function showTypeLabel(t) {
  const map = { marching_band: 'Marching Band', concert_band: 'Concert Band', indoor: 'Indoor', drum_corps: 'Drum Corps', composition: 'Composition', other: 'Other' };
  return map[t] || t || '';
}

function secsToMMSS(s) {
  if (!s) return '0:00';
  const m = Math.floor(s / 60);
  const sec = String(s % 60).padStart(2, '0');
  return `${m}:${sec}`;
}

function mmssToSecs(str) {
  if (!str) return 0;
  const parts = str.split(':');
  if (parts.length === 2) return parseInt(parts[0]) * 60 + parseInt(parts[1] || 0);
  return parseInt(parts[0]) || 0;
}

function lastNameSort(name) {
  if (!name) return '';
  const parts = name.trim().split(' ');
  return parts.length > 1 ? parts[parts.length - 1] + ' ' + parts.slice(0, -1).join(' ') : name;
}

function escapeHTML(str) {
  return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

// ── Year Helpers ───────────────────────────────────────────────────────────
function availableYears() {
  const years = [...new Set(state.allShows.map(s => parseInt(s.season_year)).filter(Boolean))].sort();
  if (!years.length) return [new Date().getFullYear(), new Date().getFullYear() + 1];
  const max = years[years.length - 1];
  if (!years.includes(max + 1)) years.push(max + 1);
  return years;
}

function showsForClientYear(clientId, year) {
  return state.allShows.filter(s => s.client_id === clientId && parseInt(s.season_year) === year);
}

// ── Show Save Helper ───────────────────────────────────────────────────────
async function saveShow(show) {
  return api(`/shows/${show.id}`, { method: 'PUT', body: show });
}

function patchClientCard(clientId, updates) {
  const idx = state.clients.findIndex(c => c.id === clientId);
  if (idx >= 0) Object.assign(state.clients[idx], updates);
  renderDashboard();
}

async function refreshCardFace() {
  state.clients = await api('/clients');
  renderDashboard();
}

// ── Progress Color ─────────────────────────────────────────────────────────
function progressColor(pct) {
  const hue = Math.round(pct * 1.1);
  return `hsl(${hue}, 100%, 52%)`;
}

function applyProgressColor(barEl, pct) {
  barEl.style.backgroundColor = progressColor(pct);
}

// ── Master Progress Bar ────────────────────────────────────────────────────
function updateMasterBar() {
  const marchingShows = state.allShows.filter(s => (s.ensemble_type === 'marching' || s.ensemble_type === 'university_band')
    && parseInt(s.season_year) === state.selectedYear);

  const wrap = document.getElementById('master-progress-wrap');
  if (!marchingShows.length) {
    if (wrap) wrap.style.display = 'none';
    return;
  }

  const totalDur = marchingShows.reduce((n, s) => n + (parseInt(s.duration_seconds) || 420), 0);
  const totalWritten = marchingShows.reduce((n, s) => n + parseInt(s.written_seconds || 0), 0);
  const pct = totalDur > 0 ? Math.round((totalWritten / totalDur) * 100) : 0;

  if (wrap) wrap.style.display = 'block';
  document.getElementById('master-progress-time').textContent =
    `${secsToMMSS(totalWritten)} / ${secsToMMSS(totalDur)} — ${pct}%`;

  const fill = document.getElementById('master-bar-fill');
  fill.style.width = `${pct}%`;
  applyProgressColor(fill, pct);
}

// ── Dashboard ──────────────────────────────────────────────────────────────
function renderDashboard() {
  const years = availableYears();

  initDavidButton();

  // Year selector
  const yearSelectorEl = document.getElementById('year-selector-row');
  if (yearSelectorEl) {
    yearSelectorEl.innerHTML = `
      <span class="year-selector-label">Season:</span>
      <div class="year-pill-scroller" id="year-pill-scroller">
        ${years.map(y => `
          <button class="year-btn ${y === state.selectedYear ? 'active' : ''}" data-year="${y}">${y}</button>
        `).join('')}
      </div>
    `;
    yearSelectorEl.querySelectorAll('.year-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        state.selectedYear = parseInt(btn.dataset.year);
        renderDashboard();
        updateMasterBar();
      });
    });

    const scroller = document.getElementById('year-pill-scroller');
    if (scroller) {
      // Scroll active year into view
      const activeBtn = scroller.querySelector('.year-btn.active');
      if (activeBtn) activeBtn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });

      // Drag-to-scroll
      let isDragging = false, startX = 0, scrollLeft = 0;
      scroller.addEventListener('mousedown', e => {
        isDragging = true; startX = e.pageX - scroller.offsetLeft;
        scrollLeft = scroller.scrollLeft;
      });
      scroller.addEventListener('mouseleave', () => { isDragging = false; });
      scroller.addEventListener('mouseup', () => { isDragging = false; });
      scroller.addEventListener('mousemove', e => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scroller.offsetLeft;
        scroller.scrollLeft = scrollLeft - (x - startX);
      });
    }
  }

  const clientsThisYear = state.clients.filter(c =>
    state.allShows.some(s => s.client_id === c.id && parseInt(s.season_year) === state.selectedYear)
  );
  const marching    = clientsThisYear.filter(c => c.ensemble_type === 'marching');
  const university  = clientsThisYear.filter(c => c.ensemble_type === 'university_band');
  const drumCorps   = clientsThisYear.filter(c => c.ensemble_type === 'drum_corps');
  // Composition: native composition clients + any client with a show explicitly typed 'composition'
  const comp        = clientsThisYear.filter(c =>
    c.ensemble_type === 'composition' ||
    state.allShows.some(s => s.client_id === c.id && parseInt(s.season_year) === state.selectedYear && s.show_type === 'composition')
  );
  const allClients = state.clients.length;
  const yearShows  = state.allShows.filter(s => parseInt(s.season_year) === state.selectedYear);
  const totalRevCents = yearShows.reduce((sum, s) => sum + (parseInt(s.fee_cents) || 0), 0);
  const revenueDisplay = totalRevCents > 0 ? `$${(totalRevCents / 100).toLocaleString()}` : '—';

  // Marching-only revenue breakdown
  const marchingClientIds = new Set(marching.map(c => c.id));
  const marchingShows = yearShows.filter(s => marchingClientIds.has(s.client_id));
  const marchingTotalCents = marchingShows.reduce((sum, s) => sum + (parseInt(s.fee_cents) || 0), 0);
  const marchingPaidCents  = marchingShows
    .filter(s => s.paid || s.payment_date || s.paid_at)
    .reduce((sum, s) => sum + (parseInt(s.fee_cents) || 0), 0);
  const marchingOwedCents  = marchingTotalCents - marchingPaidCents;
  const fmt = cents => `$${(cents / 100).toLocaleString()}`;
  const marchingTotalDisplay = marchingTotalCents > 0 ? fmt(marchingTotalCents) : '—';

  const statsEl = document.getElementById('stats-row');
  if (statsEl) statsEl.innerHTML = `
    <div class="stat-card">
      <div class="stat-label">${state.selectedYear} Clients</div>
      <div class="stat-value">${clientsThisYear.length}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">Marching</div>
      <div class="stat-value" style="color:var(--marching-secondary)">${marching.length}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">Composition</div>
      <div class="stat-value" style="color:var(--comp-secondary)">${comp.length}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">All-Time</div>
      <div class="stat-value">${allClients}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">Marching Revenue</div>
      <div class="stat-value" style="color:#2ecc71;font-size:${marchingTotalCents >= 1000000 ? '18px' : '22px'}">${maskForViewer(marchingTotalDisplay, 'money')}</div>
      ${marchingTotalCents > 0 ? `
        <div style="font-size:0.68rem;margin-top:0.3rem;display:flex;gap:0.5rem;flex-wrap:wrap;justify-content:center;">
          <span style="color:#2ecc71;" title="Paid">${maskForViewer(fmt(marchingPaidCents), 'money')} paid</span>
          ${marchingOwedCents > 0 ? `<span style="color:#f59e0b;" title="Outstanding">${maskForViewer(fmt(marchingOwedCents), 'money')} owed</span>` : ''}
        </div>` : ''}
    </div>
  `;

  document.getElementById('grid-marching').innerHTML = marching.length
    ? marching.map(c => clientCardHTML(c)).join('')
    : davidEmpty('clients');

  const univSection = document.getElementById('section-university');
  if (univSection) {
    univSection.style.display = university.length ? '' : 'none';
    document.getElementById('grid-university').innerHTML = university.length
      ? university.map(c => clientCardHTML(c)).join('')
      : '';
  }

  const corpsSection = document.getElementById('section-drum-corps');
  if (corpsSection) {
    corpsSection.style.display = drumCorps.length ? '' : 'none';
    document.getElementById('grid-drum-corps').innerHTML = drumCorps.length
      ? drumCorps.map(c => clientCardHTML(c)).join('')
      : '';
  }

  document.getElementById('grid-comp').innerHTML = comp.length
    ? comp.map(c => clientCardHTML(c)).join('')
    : davidEmpty('clients');

  document.querySelectorAll('.client-card').forEach(card => {
    card.addEventListener('click', () => openClient(parseInt(card.dataset.id)));
  });
}

// ── Top 3 Priorities ────────────────────────────────────────────────────────
async function loadTopPriorities(forceRefresh = false) {
  const content  = document.getElementById('priorities-content');
  const footer   = document.getElementById('priorities-footer');
  if (!content) return;

  if (forceRefresh) {
    content.innerHTML = davidLoading('schedule');
    try {
      const agenda = await api('/agent/scheduling/run', { method: 'POST' });
      renderTopPriorities(agenda, content, footer);
    } catch (err) {
      content.innerHTML = davidError(err.message);
    }
    return;
  }

  // Load latest cached run
  try {
    const run = await api('/agent/scheduling/latest');
    if (run?.agenda_json) {
      renderTopPriorities(run.agenda_json, content, footer, run.run_at);
    } else {
      content.innerHTML = davidEmpty('priorities');
    }
  } catch {
    content.innerHTML = davidError();
  }
}

function renderTopPriorities(agenda, content, footer, runAt) {
  const priorities = agenda?.top_priorities || [];
  const status = agenda?.overall_status || 'on_track';
  const statusLabel = { on_track: 'On Track', attention_needed: 'Attention Needed', behind: 'Behind' }[status] || status;
  const statusCls   = { on_track: 'status-on-track', attention_needed: 'status-attention', behind: 'status-behind' }[status] || 'status-on-track';

  if (!priorities.length) {
    content.innerHTML = davidEmpty('priorities');
  } else {
    content.innerHTML = priorities.map((p, i) => `
      <div class="priority-item">
        <div class="priority-num">Priority ${i + 1}</div>
        <div class="priority-desc">${escapeHTML(p.description || '')}</div>
        ${p.rationale ? `<div class="priority-rationale">${escapeHTML(p.rationale)}</div>` : ''}
        ${p.client_id ? `<span class="priority-client-link" data-client-id="${p.client_id}">${escapeHTML(p.client_name || 'View Client →')}</span>` : ''}
      </div>`).join('');

    // Bind client links
    content.querySelectorAll('.priority-client-link').forEach(link => {
      link.addEventListener('click', () => openClient(parseInt(link.dataset.clientId)));
    });
  }

  if (footer) {
    const timeStr = runAt ? `Last run: ${new Date(runAt).toLocaleString('en-US', { month:'short', day:'numeric', hour:'numeric', minute:'2-digit' })}` : '';
    footer.innerHTML = `
      <span>${timeStr}</span>
      <span class="priorities-status-badge ${statusCls}">${statusLabel}</span>`;
  }
}

// ── Upcoming Writing ─────────────────────────────────────────────────────────
async function loadUpcomingWriting() {
  const list = document.getElementById('upcoming-writing-list');
  if (!list) return;
  try {
    const items = await api('/calendar/upcoming?limit=8');
    if (!items.length) {
      list.innerHTML = davidEmpty('milestones');
      return;
    }
    list.innerHTML = items.map(m => {
      const d = m.due_date ? new Date(m.due_date) : null;
      const dateStr = d ? d.toLocaleDateString('en-US', { month:'short', day:'numeric' }) : '—';
      const cls = d ? dueDateClass(m.due_date) : '';
      return `
        <div class="writing-item" data-client-id="${m.client_id}" style="cursor:pointer" title="Open ${escapeHTML(m.client_name)}">
          <span class="writing-item-date ${cls}">${dateStr}</span>
          <div>
            <span class="writing-item-school">${escapeHTML(m.client_name)}</span>
            <span class="writing-item-step"> — ${escapeHTML(m.milestone_name)}</span>
          </div>
        </div>`;
    }).join('');

    list.querySelectorAll('.writing-item').forEach(row => {
      row.addEventListener('click', () => openClient(parseInt(row.dataset.clientId), 'shows'));
    });
  } catch (err) {
    list.innerHTML = davidError();
  }
}

// ── Portfolio Analytics Widget ────────────────────────────────────────────────
async function loadPortfolioWidget() {
  const panel = document.getElementById('portfolio-content');
  if (!panel) return;
  try {
    const [headline, captions, growth, prospects] = await Promise.allSettled([
      api('/analytics/portfolio/headline'),
      api('/analytics/portfolio/caption-signature'),
      api('/analytics/portfolio/growth-story'),
      api('/analytics/portfolio/prospects'),
    ]);

    const h = headline.status === 'fulfilled' ? headline.value : null;
    const c = captions.status === 'fulfilled' ? captions.value : null;
    const g = growth.status === 'fulfilled' ? growth.value : null;
    const p = prospects.status === 'fulfilled' ? prospects.value : null;

    let html = '';

    // ── Headline stats ────────────────────────────────────────────────────────
    html += `<div class="portfolio-stats">`;
    if (h && h.events_tracked > 0) {
      html += `
        <div class="pstat">
          <div class="pstat-value">${h.events_tracked}</div>
          <div class="pstat-label">Events tracked</div>
        </div>
        <div class="pstat">
          <div class="pstat-value">${h.avg_percentile != null ? 'Top ' + Math.round(100 - parseFloat(h.avg_percentile)) + '%' : '—'}</div>
          <div class="pstat-label">Avg class percentile</div>
        </div>
        <div class="pstat">
          <div class="pstat-value">${h.clients_tracked}</div>
          <div class="pstat-label">Clients with data</div>
        </div>
        <div class="pstat">
          <div class="pstat-value">${g?.aggregate?.avg_year1_impact != null ? (g.aggregate.avg_year1_impact > 0 ? '+' : '') + g.aggregate.avg_year1_impact.toFixed(1) : '—'}</div>
          <div class="pstat-label">Avg Y1 score impact</div>
        </div>`;
    } else {
      html += `<div class="portfolio-no-data" style="grid-column:1/-1">No competition results in the database yet — run the scrapers or parse a recap PDF to populate this widget.</div>`;
    }
    html += `</div>`;

    // ── Caption signature ─────────────────────────────────────────────────────
    if (c?.captions?.length) {
      const maxDelta = Math.max(...c.captions.map(r => Math.abs(parseFloat(r.content_delta_vs_class))));
      html += `<div>
        <div class="portfolio-section-label">Caption Signature — Content delta vs class mean</div>
        <div class="portfolio-captions">`;
      for (const r of c.captions.slice(0, 6)) {
        const delta = parseFloat(r.content_delta_vs_class);
        const pct = maxDelta > 0 ? Math.abs(delta / maxDelta) * 100 : 0;
        const pos = delta >= 0;
        const label = CAPTION_LABELS[r.caption_key] || r.caption_key;
        html += `
          <div class="pcaption-row">
            <span class="pcaption-name">${escapeHTML(label)}</span>
            <div class="pcaption-bar-wrap">
              <div class="pcaption-bar${pos ? '' : ' negative'}" style="width:${pct.toFixed(1)}%"></div>
            </div>
            <span class="pcaption-delta${pos ? ' positive' : ' negative'}">${pos ? '+' : ''}${delta.toFixed(3)}</span>
          </div>`;
      }
      html += `</div></div>`;
    }

    // ── Prospect radar ────────────────────────────────────────────────────────
    if (p?.prospects?.length) {
      html += `<div>
        <div class="portfolio-section-label">Prospect Radar — Cavalcade Yankee/Liberty bands below 45th percentile (2+ seasons)</div>
        <div class="portfolio-prospects">`;
      for (const band of p.prospects.slice(0, 8)) {
        const pctStr = band.avg_percentile != null ? Math.round(parseFloat(band.avg_percentile)) + 'th%ile' : '';
        html += `<div class="prospect-chip"><strong>${escapeHTML(band.band_name)}</strong>${pctStr ? ' · ' + pctStr : ''} · ${band.seasons} season${band.seasons > 1 ? 's' : ''}</div>`;
      }
      html += `</div></div>`;
    }

    panel.innerHTML = html || `<div class="portfolio-no-data">No competition data yet.</div>`;
  } catch (err) {
    panel.innerHTML = `<div class="portfolio-no-data">Could not load competitive intelligence data.</div>`;
  }
}

// ── Calendar View ────────────────────────────────────────────────────────────
async function loadCalendarView() {
  const container = document.getElementById('calendar-list-content');
  if (!container) return;
  container.innerHTML = davidLoading('calendar');
  try {
    const showCompleted = document.getElementById('cal-show-completed')?.checked;
    let items = await api('/calendar/all');
    if (!showCompleted) items = items.filter(i => !i.completed);

    if (!items.length) {
      container.innerHTML = davidEmpty('calendar');
      return;
    }

    // Group by month
    const groups = {};
    for (const item of items) {
      const d = new Date(item.date);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      const label = d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      if (!groups[key]) groups[key] = { label, items: [] };
      groups[key].items.push(item);
    }

    const typeLabel = { milestone: 'Writing', competition: 'Competition', task: 'Task', schedule_event: 'Event' };
    const typeCls   = { milestone: 'cal-type-milestone', competition: 'cal-type-competition', task: 'cal-type-task', schedule_event: 'cal-type-event' };

    container.innerHTML = Object.values(groups).map(g => `
      <div class="calendar-month-group">
        <div class="calendar-month-label">${g.label}</div>
        ${g.items.map(item => {
          const d = new Date(item.date);
          const dayStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          const clientId = item.client_id;
          return `
            <div class="calendar-row ${item.completed ? 'cal-completed' : ''}"
                 ${clientId ? `data-client-id="${clientId}" style="cursor:pointer"` : ''}>
              <span class="cal-date">${dayStr}</span>
              <span class="cal-detail">
                <span class="cal-type-badge ${typeCls[item.item_type] || ''}">${typeLabel[item.item_type] || item.item_type}</span>
                ${item.client_name ? `<span class="cal-client">${escapeHTML(item.client_name)}</span>` : ''}
                <span class="cal-title">${item.item_type === 'schedule_event' ? escapeHTML(EVENT_TYPE_LABELS?.[item.event_subtype] || item.event_subtype || '') : escapeHTML(item.title || '')}</span>
                ${item.item_type === 'schedule_event' && item.time_start ? `<span class="cal-time">${item.time_start.slice(0,5)}${item.time_end ? '–'+item.time_end.slice(0,5) : ''}</span>` : ''}
                ${item.item_type === 'schedule_event' && item.location ? `<span class="cal-loc">${escapeHTML(item.location)}</span>` : ''}
                ${item.item_type === 'competition' && item.circuit ? `<span class="cal-loc">${escapeHTML(item.circuit.toUpperCase())}${item.class ? ' · ' + escapeHTML(item.class) : ''}</span>` : ''}
                ${item.item_type === 'competition' && item.location ? `<span class="cal-loc">${escapeHTML(item.location)}</span>` : ''}
              </span>
            </div>`;
        }).join('')}
      </div>`).join('');

    container.querySelectorAll('[data-client-id]').forEach(row => {
      row.addEventListener('click', () => openClient(parseInt(row.dataset.clientId)));
    });
  } catch (err) {
    container.innerHTML = davidError(err.message);
  }
}

// ── Overnight Activity ───────────────────────────────────────────────────────
function getOvernightDismissed() {
  const today = new Date().toISOString().split('T')[0];
  try { return new Set(JSON.parse(localStorage.getItem(`overnight_${today}`) || '[]')); }
  catch { return new Set(); }
}
function addOvernightDismissed(id) {
  const today = new Date().toISOString().split('T')[0];
  const set = getOvernightDismissed();
  set.add(id);
  localStorage.setItem(`overnight_${today}`, JSON.stringify([...set]));
  // Prune keys older than today
  Object.keys(localStorage).forEach(k => { if (k.startsWith('overnight_') && k !== `overnight_${today}`) localStorage.removeItem(k); });
}

async function loadOvernightActivity() {
  try {
    const allItems = await api('/agent/overnight');
    const dismissed = getOvernightDismissed();
    // Use holding_id as the unique key (new schema)
    const items = allItems.filter(i => !dismissed.has(i.holding_id));

    const panel   = document.getElementById('overnight-panel');
    const countEl = document.getElementById('overnight-count');
    const listEl  = document.getElementById('overnight-items');
    if (!panel || !listEl) return;

    // No panel at all if nothing needs attention
    if (!items.length) {
      panel.style.display = 'none';
      return;
    }

    panel.style.display = 'block';
    if (countEl) countEl.textContent = items.length;

    listEl.innerHTML = items.map(item => {
      const extracted = item.extracted_data || {};
      const preview = extracted.summary || extracted.inquiry_summary || item.raw_content?.slice(0, 120) || '';
      const timeStr = item.created_at
        ? new Date(item.created_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
        : '';
      const hasPreview = preview.trim().length > 0;
      const isText = item.source_type === 'text';
      const typeBadge = isText
        ? `<span class="overnight-type-badge overnight-type-text">Text</span>`
        : `<span class="overnight-type-badge overnight-type-email">Email</span>`;
      const subject = isText
        ? (item.from_email || 'Text Message')   // from_email is contact_name for texts
        : (item.subject || '(no subject)');
      const meta = isText
        ? timeStr
        : `${escapeHTML(item.from_email || '')}${timeStr ? ` · ${timeStr}` : ''}`;
      return `
        <div class="overnight-item" data-id="${item.holding_id}">
          <div class="overnight-item-info">
            <div class="overnight-item-subject">${typeBadge} ${escapeHTML(subject)}</div>
            <div class="overnight-item-meta">${escapeHTML(meta)}</div>
            ${hasPreview ? `<div class="overnight-item-body" style="display:none">${escapeHTML(preview)}</div>` : ''}
          </div>
          <div class="overnight-item-actions">
            <span class="overnight-status overnight-holding">Needs Assignment</span>
            ${hasPreview ? `<button class="btn btn-ghost btn-sm overnight-btn-expand">Read</button>` : ''}
            <button class="btn btn-ghost btn-sm overnight-btn-assign" data-holding-id="${item.holding_id}">Assign →</button>
            <button class="btn btn-ghost btn-sm overnight-btn-dismiss" title="Dismiss">✕</button>
          </div>
        </div>`;
    }).join('');

    listEl.querySelectorAll('.overnight-btn-expand').forEach(btn => {
      btn.addEventListener('click', () => {
        const row    = btn.closest('.overnight-item');
        const bodyEl = row.querySelector('.overnight-item-body');
        const isOpen = bodyEl.style.display !== 'none';
        bodyEl.style.display = isOpen ? 'none' : 'block';
        btn.textContent = isOpen ? 'Read' : 'Close';
      });
    });

    listEl.querySelectorAll('.overnight-btn-assign').forEach(btn => {
      btn.addEventListener('click', async () => {
        const holdingId = btn.dataset.holdingId;
        // Navigate to inbox and scroll to the specific holding queue item
        const navBtn = document.querySelector('.nav-btn[data-view="inbox"]');
        if (navBtn) navBtn.click();
        // Wait for inbox to render then scroll to the item
        await new Promise(r => setTimeout(r, 400));
        const el = document.querySelector(`.holding-item[data-id="${holdingId}"]`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          el.style.outline = '2px solid var(--warning)';
          setTimeout(() => el.style.outline = '', 2500);
        }
      });
    });

    listEl.querySelectorAll('.overnight-btn-dismiss').forEach(btn => {
      btn.addEventListener('click', () => {
        const row = btn.closest('.overnight-item');
        const id  = parseInt(row.dataset.id);
        addOvernightDismissed(id);
        row.remove();
        const remaining = listEl.querySelectorAll('.overnight-item').length;
        if (remaining === 0) {
          panel.style.display = 'none';
          if (badge) { badge.classList.remove('inbox-badge-breathing'); badge.style.display = 'none'; }
        } else {
          if (countEl) countEl.textContent = remaining;
          if (badge) badge.textContent = remaining;
        }
      });
    });

  } catch { /* overnight is best-effort */ }
}

function clientCardHTML(c) {
  const isMarching = c.ensemble_type === 'marching' || c.ensemble_type === 'university_band' || c.ensemble_type === 'drum_corps';
  const isUniversity = c.ensemble_type === 'university_band';
  const isDrumCorps = c.ensemble_type === 'drum_corps';

  // Get this year's show for the client
  const yearShow = showsForClientYear(c.id, state.selectedYear)[0];

  if (!isMarching) {
    const design = yearShow?.design_status || null;
    const designLabels = { not_started: 'Not Started', in_progress: 'In Progress', ready: 'Ready to Write' };
    const designColors = { not_started: 'badge-neutral', in_progress: 'badge-inprogress', ready: 'badge-ready' };
    return `
      <div class="client-card composition" data-id="${c.id}">
        <div class="card-name">${escapeHTML(c.org_name || c.name || '—')}</div>
        <div class="card-org">${escapeHTML(yearShow?.director_name || c.name || '')}</div>
        ${yearShow ? `<div class="card-show-title">${state.selectedYear}${yearShow.title ? ': ' + escapeHTML(yearShow.title) : ''}</div>` : ''}
        ${yearShow?.project_description ? `<div class="card-project-desc">${escapeHTML(yearShow.project_description)}</div>` : ''}
        <div class="card-meta" style="margin-top:8px">
          <span class="badge badge-comp">Composition</span>
          ${design ? `<span class="badge ${designColors[design] || 'badge-neutral'}">${designLabels[design] || design}</span>` : ''}
          ${c.state ? `<span class="badge badge-neutral">${c.state}</span>` : ''}
        </div>
        ${yearShow?.deliver_by_date ? `<div class="card-deliver-by ${dueDateClass(yearShow.deliver_by_date)}">Deliver: ${formatDate(yearShow.deliver_by_date)}</div>` : ''}
      </div>`;
  }

  // Marching card
  const parts = yearShow
    ? (Array.isArray(yearShow.ensemble_parts) ? yearShow.ensemble_parts
        : (yearShow.ensemble_parts ? JSON.parse(yearShow.ensemble_parts) : []))
    : [];
  const fee = yearShow?.fee_cents ? (maskForViewer(`$${(yearShow.fee_cents / 100).toLocaleString()}`, 'money') || '—') : null;
  const design = yearShow?.design_status || null;
  const status = yearShow?.status || null;
  const statusLabels = { prospect: 'Prospect', in_progress: 'In Progress', ready: 'Ready to Write', complete: 'Complete' };
  const statusColors = { prospect: 'badge-prospect', in_progress: 'badge-inprogress', ready: 'badge-ready', complete: 'badge-complete' };
  const designLabels = { not_started: 'Not Started', in_progress: 'In Progress', ready: 'Ready to Write' };
  const designColors = { not_started: 'badge-neutral', in_progress: 'badge-inprogress', ready: 'badge-ready' };

  let nextMovement = null;
  if (design === 'ready') {
    nextMovement = yearShow?.next_movement || c.next_movement || 'Intro';
  }

  const partLabels = { winds: 'Winds', battery: 'Battery', front_ensemble: 'Front', sound_design: 'Sound' };

  const cardDirectorName = yearShow?.director_name || c.name || '';

  return `
    <div class="client-card marching" data-id="${c.id}">
      <div class="card-name">${escapeHTML(c.org_name || c.name || '—')}${isUniversity ? ' <span class="univ-badge">UNIV</span>' : ''}${isDrumCorps ? ' <span class="corps-badge">CORPS</span>' : ''}</div>
      <div class="card-org">${escapeHTML(cardDirectorName)}</div>
      ${yearShow?.title ? `<div class="card-show-title">${escapeHTML(yearShow.title)}</div>` : ''}

      <div class="card-status-row">
        <span class="status-pip ${yearShow?.contract_sent ? 'pip-on' : 'pip-off'}" title="Contract Sent">Sent</span>
        <span class="status-pip ${yearShow?.contract_signed ? 'pip-on' : 'pip-off'}" title="Contract Signed">Signed</span>
        <span class="status-pip ${yearShow?.invoiced ? 'pip-on' : 'pip-off'}" title="Invoiced">Invoiced</span>
        <span class="status-pip ${yearShow?.paid ? 'pip-on pip-paid' : 'pip-off'}" title="Paid">Paid</span>
        ${fee ? `<span class="card-fee">${fee}</span>` : ''}
      </div>

      ${parts.length ? `
      <div class="card-parts-row">
        ${parts.map(p => `<span class="part-chip">${partLabels[p] || p}</span>`).join('')}
      </div>` : ''}

      <div class="card-meta" style="margin-top:8px">
        ${design ? `<span class="badge ${designColors[design] || 'badge-neutral'}">${designLabels[design] || design}</span>` : ''}
        ${nextMovement ? `<span class="badge badge-comp next-movement-badge">▶ ${nextMovement}</span>` : ''}
        ${c.state ? `<span class="badge badge-neutral">${c.state}</span>` : ''}
      </div>
      ${yearShow?.deliver_by_date ? `<div class="card-deliver-by ${dueDateClass(yearShow.deliver_by_date)}">Deliver: ${formatDate(yearShow.deliver_by_date)}</div>` : ''}
    </div>`;
}

// ── Contacts View ──────────────────────────────────────────────────────────
let _contactPeople = []; // cached person-first data

async function renderContacts(filter = '') {
  const panel = document.getElementById('contact-detail-panel');
  const list = document.getElementById('contacts-list');
  panel.style.display = 'none';
  list.style.display = 'block';

  if (!_contactPeople.length) {
    list.innerHTML = '<div class="empty-state">Loading contacts…</div>';
    try {
      _contactPeople = await api('/contacts/people');
    } catch (e) {
      list.innerHTML = '<div class="empty-state">Failed to load contacts.</div>';
      return;
    }
  }

  const lf = filter.toLowerCase();
  const visible = _contactPeople.filter(p => !lf ||
    (p.name || '').toLowerCase().includes(lf) ||
    (p.email || '').toLowerCase().includes(lf) ||
    p.programs.some(prog => (prog.org_name || '').toLowerCase().includes(lf) || (prog.role || '').toLowerCase().includes(lf))
  );

  if (!visible.length) {
    list.innerHTML = '<div class="empty-state">No contacts found.</div>';
    return;
  }

  list.innerHTML = `
    <div class="contacts-list-table">
      ${visible.map(p => {
        // Deduplicate by client_id + role + source_type
        const seen = new Set();
        const uniqueProgs = p.programs.filter(pr => {
          const key = `${pr.client_id}-${pr.role}-${pr.source_type}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        // Sort programs by season_year descending (most recent first)
        uniqueProgs.sort((a, b) => (b.season_year || 0) - (a.season_year || 0));
        const phone = (p.all_phones || [])[0] || null;
        const firstCollab = uniqueProgs.find(pr => pr.collab_id)?.collab_id || null;
        const clientIds = [...new Set(uniqueProgs.map(pr => pr.client_id))];
        return `
          <div class="contact-list-row">
            <div class="contact-col-name">
              <button class="btn-contact-name btn-link-plain" data-person-name="${escapeHTML(p.name || '')}" data-person-id="${p.person_id || ''}" data-client-ids="${clientIds.join(',')}">${escapeHTML(maskForViewer(p.name, 'name') || '—')}</button>
              ${p.person_id && window.WMM_ROLE !== 'viewer' ? '<span class="person-linked-badge" title="Identity linked">⚭</span>' : ''}
              ${firstCollab && window.WMM_ROLE !== 'viewer' ? `<button class="btn btn-ghost btn-xs btn-link-person" data-collab-id="${firstCollab}" data-current-person-id="${p.person_id || ''}" data-person-name="${escapeHTML(p.name || '')}">⚭ Link</button>` : ''}
            </div>
            <div class="contact-col-phone">
              ${phone && window.WMM_ROLE !== 'viewer' ? `<a href="tel:${escapeHTML(phone)}">${escapeHTML(formatPhone(phone))}</a>` : (phone ? escapeHTML(maskForViewer(formatPhone(phone), 'phone')) : '<span class="text-muted">—</span>')}
            </div>
            <div class="contact-col-programs">
              ${uniqueProgs.map(pr => {
                const roleLabel = pr.role || '—';
                const colorClass = pr.ensemble_type === 'marching' ? 'prog-marching' : 'prog-comp';
                const emailStr = pr.email && window.WMM_ROLE !== 'viewer' ? `<a href="mailto:${escapeHTML(pr.email)}" class="contact-prog-email">${escapeHTML(pr.email)}</a>` : '';
                const orgStr = escapeHTML(pr.org_name || '—');
                const yearStr = pr.season_year ? ` (${pr.season_year})` : '';
                return `<div class="contact-prog-line ${colorClass}">
                  <span class="contact-prog-role">${escapeHTML(roleLabel)}</span>
                  <span class="contact-prog-sep">·</span>
                  <button class="btn-prog-org btn-link-plain" data-client-id="${pr.client_id}">${orgStr}${yearStr}</button>
                  ${emailStr ? `<span class="contact-prog-sep">·</span>${emailStr}` : ''}
                </div>`;
              }).join('')}
            </div>
          </div>`;
      }).join('')}
    </div>`;

  list.querySelectorAll('.btn-prog-org').forEach(btn => {
    btn.addEventListener('click', () => openClient(parseInt(btn.dataset.clientId)));
  });

  list.querySelectorAll('.btn-link-person').forEach(btn => {
    btn.addEventListener('click', () => openLinkPersonModal(
      parseInt(btn.dataset.collabId),
      btn.dataset.currentPersonId ? parseInt(btn.dataset.currentPersonId) : null,
      btn.dataset.personName
    ));
  });

  list.querySelectorAll('.btn-contact-name').forEach(btn => {
    btn.addEventListener('click', () => {
      const personId = btn.dataset.personId ? parseInt(btn.dataset.personId) : null;
      const clientIds = btn.dataset.clientIds ? btn.dataset.clientIds.split(',').map(Number).filter(Boolean) : [];
      const personObj = _contactPeople.find(p =>
        personId ? p.person_id === personId : (p.name || '').toLowerCase() === (btn.dataset.personName || '').toLowerCase()
      ) || null;
      openContactPersonModal(btn.dataset.personName, personId, clientIds, personObj);
    });
  });
}

async function openContactPersonModal(name, personId, clientIds, personData = null) {
  // Load full people record if linked
  let rec = null;
  let resolvedPersonId = personId;
  if (personId) {
    try {
      const people = await api('/people');
      rec = people.find(p => p.id === personId) || null;
    } catch { /* skip */ }
  }

  // Pre-populate from people record first, fall back to collab data
  const currentName  = rec?.canonical_name || name;
  const currentPhone = rec?.phone || personData?.all_phones?.[0] || '';
  const currentEmail = rec?.email || personData?.all_emails?.[0] || personData?.email || '';
  const existingNotes = rec?.notes || '';
  const addr1  = rec?.mailing_address_line1 || '';
  const addr2  = rec?.mailing_address_line2 || '';
  const city   = rec?.mailing_city || '';
  const pstate = rec?.mailing_state || '';
  const zip    = rec?.mailing_zip || '';
  const hasAddress = !!(addr1 || city || zip);

  document.getElementById('modal-contact-person')?.remove();
  const overlay = document.createElement('div');
  overlay.id = 'modal-contact-person';
  overlay.className = 'modal-overlay';
  overlay.style.display = 'flex';
  overlay.innerHTML = `
    <div class="modal" style="max-width:540px">
      <div class="modal-header">
        <h3 class="modal-title">${escapeHTML(currentName)}</h3>
        <button class="modal-close" id="cp-modal-close">&times;</button>
      </div>
      <div style="padding:16px 20px;display:flex;flex-direction:column;gap:14px">

        <!-- Contact Info -->
        <div style="display:flex;flex-direction:column;gap:10px">
          <div class="form-group" style="margin:0">
            <label style="font-size:12px;color:var(--text-muted)">Name</label>
            <input type="text" id="cp-name" style="width:100%;box-sizing:border-box" value="${escapeHTML(currentName)}" />
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">
            <div class="form-group" style="margin:0">
              <label style="font-size:12px;color:var(--text-muted)">Phone</label>
              <input type="tel" id="cp-phone" style="width:100%;box-sizing:border-box" value="${escapeHTML(currentPhone)}" placeholder="(555) 555-5555" />
            </div>
            <div class="form-group" style="margin:0">
              <label style="font-size:12px;color:var(--text-muted)">Email</label>
              <input type="email" id="cp-email" style="width:100%;box-sizing:border-box" value="${escapeHTML(currentEmail)}" placeholder="email@example.com" />
            </div>
          </div>

          <!-- Mailing Address (collapsible) -->
          <div>
            <button class="btn btn-ghost btn-sm" id="cp-toggle-address" style="padding:2px 4px;font-size:12px;color:var(--text-muted)">
              ${hasAddress ? '▼' : '▶'} Mailing Address
            </button>
            <div id="cp-address-fields" style="${hasAddress ? '' : 'display:none'};display:${hasAddress ? 'flex' : 'none'};flex-direction:column;gap:8px;margin-top:8px">
              <input type="text" id="cp-addr1" placeholder="Street address" style="width:100%;box-sizing:border-box" value="${escapeHTML(addr1)}" />
              <input type="text" id="cp-addr2" placeholder="Apt, Suite, etc. (optional)" style="width:100%;box-sizing:border-box" value="${escapeHTML(addr2)}" />
              <div style="display:grid;grid-template-columns:2fr 1fr 1.2fr;gap:8px">
                <input type="text" id="cp-city" placeholder="City" style="box-sizing:border-box" value="${escapeHTML(city)}" />
                <input type="text" id="cp-state" placeholder="State" style="box-sizing:border-box" value="${escapeHTML(pstate)}" />
                <input type="text" id="cp-zip" placeholder="ZIP" style="box-sizing:border-box" value="${escapeHTML(zip)}" />
              </div>
            </div>
          </div>

          <div style="display:flex;gap:8px;justify-content:flex-end">
            <button class="btn btn-primary btn-sm" id="cp-save-contact">Save</button>
            <span id="cp-contact-status" style="font-size:12px;color:var(--text-muted);align-self:center"></span>
          </div>
        </div>

        <hr style="border:none;border-top:1px solid var(--border-light);margin:0">

        <!-- Notes -->
        <div class="form-group" style="margin:0">
          <label style="font-size:12px;color:var(--text-muted)">Notes</label>
          <textarea id="cp-notes" rows="3" style="width:100%;resize:vertical;font-size:13px;box-sizing:border-box" placeholder="Add any notes about this person…">${escapeHTML(existingNotes)}</textarea>
        </div>
        <div style="display:flex;gap:8px;justify-content:flex-end">
          <button class="btn btn-secondary btn-sm" id="cp-save-notes">Save Notes</button>
        </div>

        <hr style="border:none;border-top:1px solid var(--border-light);margin:0">

        <!-- David Thorne -->
        <div>
          <button class="btn btn-primary btn-sm" id="cp-briefing-btn">Ask David Thorne</button>
          <span id="cp-briefing-status" style="font-size:12px;color:var(--text-muted);margin-left:10px"></span>
        </div>
        <div id="cp-briefing-output" style="display:none;background:var(--surface-card);border-radius:8px;padding:14px;font-size:13px;line-height:1.6;color:var(--text-primary)"></div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
  document.getElementById('cp-modal-close').addEventListener('click', () => overlay.remove());

  // Toggle mailing address section
  document.getElementById('cp-toggle-address').addEventListener('click', () => {
    const fields = document.getElementById('cp-address-fields');
    const btn = document.getElementById('cp-toggle-address');
    const open = fields.style.display !== 'none';
    fields.style.display = open ? 'none' : 'flex';
    btn.textContent = (open ? '▶' : '▼') + ' Mailing Address';
  });

  // Save contact info (name, phone, email, address)
  document.getElementById('cp-save-contact').addEventListener('click', async () => {
    const btn = document.getElementById('cp-save-contact');
    const status = document.getElementById('cp-contact-status');
    btn.disabled = true;
    status.textContent = '';
    try {
      const payload = {
        canonical_name: document.getElementById('cp-name').value.trim(),
        phone:    document.getElementById('cp-phone').value.trim(),
        email:    document.getElementById('cp-email').value.trim(),
        mailing_address_line1: document.getElementById('cp-addr1').value.trim(),
        mailing_address_line2: document.getElementById('cp-addr2').value.trim(),
        mailing_city:  document.getElementById('cp-city').value.trim(),
        mailing_state: document.getElementById('cp-state').value.trim(),
        mailing_zip:   document.getElementById('cp-zip').value.trim()
      };
      if (resolvedPersonId) {
        await api(`/people/${resolvedPersonId}`, { method: 'PATCH', body: payload });
      } else {
        // Auto-create people record and link to all collab rows
        const newRec = await api('/people', { method: 'POST', body: { canonical_name: payload.canonical_name } });
        resolvedPersonId = newRec.id;
        await api(`/people/${resolvedPersonId}`, { method: 'PATCH', body: payload });
        // Link collab rows
        const collabIds = (personData?.programs || []).map(p => p.collab_id).filter(Boolean);
        for (const cid of collabIds) {
          await api(`/collaborators/${cid}`, { method: 'PATCH', body: {
            name: payload.canonical_name, phone: payload.phone, email: payload.email, person_id: resolvedPersonId
          }});
        }
      }
      // Update modal title
      document.querySelector('#modal-contact-person .modal-title').textContent = payload.canonical_name || name;
      status.textContent = 'Saved ✓';
      _contactPeople = [];
      setTimeout(() => { status.textContent = ''; }, 2000);
    } catch (err) {
      status.textContent = 'Error';
    } finally {
      btn.disabled = false;
    }
  });

  // Save notes
  document.getElementById('cp-save-notes').addEventListener('click', async () => {
    const notes = document.getElementById('cp-notes').value.trim();
    const btn = document.getElementById('cp-save-notes');
    btn.disabled = true;
    try {
      if (resolvedPersonId) {
        await api(`/people/${resolvedPersonId}`, { method: 'PATCH', body: { notes } });
      } else {
        const newRec = await api('/people', { method: 'POST', body: { canonical_name: name, notes } });
        resolvedPersonId = newRec.id;
      }
      btn.textContent = 'Saved ✓';
      _contactPeople = [];
      setTimeout(() => { btn.textContent = 'Save Notes'; btn.disabled = false; }, 1500);
    } catch {
      btn.textContent = 'Error'; btn.disabled = false;
    }
  });

  // David Thorne briefing
  document.getElementById('cp-briefing-btn').addEventListener('click', async () => {
    if (!clientIds.length) {
      document.getElementById('cp-briefing-status').textContent = 'No associated programs found.';
      return;
    }
    const btn = document.getElementById('cp-briefing-btn');
    const status = document.getElementById('cp-briefing-status');
    const output = document.getElementById('cp-briefing-output');
    btn.disabled = true;
    status.textContent = 'Thinking…';
    output.style.display = 'none';
    try {
      const data = await api('/people/briefing', {
        method: 'POST',
        body: { name: document.getElementById('cp-name').value.trim() || name, client_ids: clientIds, person_id: resolvedPersonId }
      });
      output.textContent = data.briefing || 'No briefing returned.';
      output.style.display = 'block';
      status.textContent = '';
    } catch {
      status.textContent = 'Error generating briefing.';
    } finally {
      btn.disabled = false;
    }
  });
}

async function openLinkPersonModal(collabId, currentPersonId, personName) {
  // Fetch all people for the picker
  let people = [];
  try { people = await api('/people'); } catch { people = []; }

  // Remove existing modal if any
  document.getElementById('modal-link-person')?.remove();

  const overlay = document.createElement('div');
  overlay.id = 'modal-link-person';
  overlay.className = 'modal-overlay';
  overlay.style.display = 'flex';
  overlay.innerHTML = `
    <div class="modal" style="max-width:440px">
      <div class="modal-header">
        <h3 class="modal-title">Link Identity — ${escapeHTML(personName)}</h3>
        <button class="modal-close" id="link-person-close">&times;</button>
      </div>
      <div style="padding:16px 20px">
        <p style="font-size:13px;color:var(--text-secondary);margin-bottom:16px">
          Link this person to an existing identity record (same person, different school/email), or create a new one to start tracking them across programs.
        </p>
        ${currentPersonId ? `<div style="margin-bottom:12px;font-size:13px;color:var(--text-muted)">Currently linked to identity #${currentPersonId}. <button class="btn btn-ghost btn-sm" id="btn-unlink-person">Unlink</button></div>` : ''}
        <div class="form-group" style="margin-bottom:12px">
          <label>Link to existing person</label>
          <select id="link-person-select" style="width:100%">
            <option value="">— Pick existing person —</option>
            ${people.filter(p => p.id !== currentPersonId).map(p => `<option value="${p.id}">${escapeHTML(p.canonical_name)} (${p.linked_count} linked)</option>`).join('')}
          </select>
        </div>
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px">
          <hr style="flex:1;border:none;border-top:1px solid var(--border-light)">
          <span style="font-size:12px;color:var(--text-muted)">or</span>
          <hr style="flex:1;border:none;border-top:1px solid var(--border-light)">
        </div>
        <div class="form-group" style="margin-bottom:0">
          <label>Create new identity record</label>
          <div style="display:flex;gap:8px">
            <input type="text" id="link-person-new-name" placeholder="Canonical name (e.g. Jimmy Fernandez)" style="flex:1" value="${escapeHTML(personName)}" />
            <button class="btn btn-primary btn-sm" id="btn-create-link-person">Create & Link</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-ghost" id="link-person-cancel">Cancel</button>
        <button class="btn btn-primary" id="btn-save-link-person">Link Selected</button>
      </div>
    </div>`;

  document.body.appendChild(overlay);

  const close = () => overlay.remove();
  overlay.querySelector('#link-person-close').addEventListener('click', close);
  overlay.querySelector('#link-person-cancel').addEventListener('click', close);

  // Unlink
  overlay.querySelector('#btn-unlink-person')?.addEventListener('click', async () => {
    await api(`/collaborators/${collabId}`, { method: 'PATCH', body: { person_id: null } });
    _contactPeople = []; // invalidate cache
    close();
    renderContacts();
  });

  // Link to existing
  overlay.querySelector('#btn-save-link-person').addEventListener('click', async () => {
    const pid = parseInt(overlay.querySelector('#link-person-select').value);
    if (!pid) return;
    await api(`/collaborators/${collabId}`, { method: 'PATCH', body: { person_id: pid } });
    _contactPeople = [];
    close();
    renderContacts();
  });

  // Create new + link
  overlay.querySelector('#btn-create-link-person').addEventListener('click', async () => {
    const name = overlay.querySelector('#link-person-new-name').value.trim();
    if (!name) return;
    const person = await api('/people', { method: 'POST', body: { canonical_name: name } });
    await api(`/collaborators/${collabId}`, { method: 'PATCH', body: { person_id: person.id } });
    _contactPeople = [];
    close();
    renderContacts();
  });
}

async function openContactDetail(id) {
  const client = state.clients.find(c => c.id === id);
  if (!client) return;
  const shows = await api(`/clients/${id}/shows`);
  const list = document.getElementById('contacts-list');
  const panel = document.getElementById('contact-detail-panel');
  list.style.display = 'none';
  panel.style.display = 'block';

  document.getElementById('contact-detail-content').innerHTML = `
    <div class="client-detail-header">
      <div>
        <div class="client-detail-name">${escapeHTML(client.name || '—')}</div>
        <div class="client-detail-org">${escapeHTML(client.org_name || '')}</div>
        <div class="client-contact" style="margin-top:10px">
          ${client.email ? `<a href="mailto:${client.email}">✉ ${escapeHTML(maskForViewer(client.email, 'email'))}</a>` : ''}
          ${client.phone ? `<a href="#" data-phone="${escapeHTML(client.phone)}">📞 ${escapeHTML(maskForViewer(formatPhone(client.phone), 'phone'))}</a>` : ''}
        </div>
      </div>
      <button class="btn btn-ghost btn-sm" onclick="openClient(${client.id})">Open Full Card</button>
    </div>
    <h3 style="font-size:15px;font-weight:700;margin-bottom:12px;color:var(--text-secondary)">Show History</h3>
    ${shows.length ? `
      <table class="client-table">
        <thead><tr><th>Show</th><th>Year</th><th>Type</th><th>Status</th><th>Deliver By</th><th>Progress</th></tr></thead>
        <tbody>
          ${shows.map(s => `
            <tr>
              <td>${escapeHTML(s.title || `${s.season_year} Season`)}</td>
              <td>${s.season_year || '—'}</td>
              <td>${showTypeLabel(s.show_type)}</td>
              <td><span class="badge badge-neutral">${s.status || '—'}</span></td>
              <td>${formatDate(s.deliver_by_date || s.due_date)}</td>
              <td>${s.duration_seconds > 0
                ? `${secsToMMSS(s.written_seconds || 0)} / ${secsToMMSS(s.duration_seconds)} (${s.percent_complete || 0}%)`
                : `${s.percent_complete || 0}%`}</td>
            </tr>`).join('')}
        </tbody>
      </table>` : '<div class="empty-state">No shows on record.</div>'}
  `;
}

// ── Client Detail ──────────────────────────────────────────────────────────
async function openClient(id, tab = null) {
  state.currentClientId = id;
  const active = document.querySelector('.view.active');
  state.previousView = active ? active.id.replace('view-', '') : 'dashboard';
  // Default detail year to selectedYear or latest
  const clientShows = state.allShows.filter(s => s.client_id === id);
  const years = [...new Set(clientShows.map(s => parseInt(s.season_year)))].sort();
  if (years.includes(state.selectedYear)) {
    state.clientDetailYear = state.selectedYear;
  } else {
    state.clientDetailYear = years[years.length - 1] || state.selectedYear;
  }
  showView('client-detail');
  state.currentTab = tab || 'production';
  sessionStorage.setItem('wmmNavState', JSON.stringify({ view: 'client-detail', clientId: id, tab: state.currentTab }));
  // V4 client card takes over if available; fall back to V3 renderClientDetail
  if (window.renderClientCard) {
    await window.renderClientCard(id);
    return;
  }
  await renderClientDetail();
}

// ── Yeet Modal ─────────────────────────────────────────────────────────────
function openYeetModal(client, year) {
  // Remove any existing yeet modal
  document.getElementById('yeet-modal')?.remove();

  const clientName = client.org_name || client.name || 'this client';
  const overlay = document.createElement('div');
  overlay.id = 'yeet-modal';
  overlay.className = 'modal-overlay';
  overlay.style.display = 'flex';
  overlay.innerHTML = `
    <div class="modal-box yeet-modal-box">
      <div class="yeet-modal-title">⚠ CHOOSE YOUR FATE</div>
      <div class="yeet-modal-client">${escapeHTML(clientName)}</div>
      <div class="yeet-modal-desc">What exactly are we yeeting?</div>

      <button class="btn btn-yeet-season" id="yeet-unsummon">
        UNSUMMON CURRENT SEASON
        <span class="yeet-sub">${year} season data only — client stays in Contacts</span>
      </button>

      <div class="yeet-divider">— or go further —</div>

      <button class="btn btn-yeet-full" id="yeet-finish-him">
        FINISH HIM!
      </button>
      <div id="yeet-permadeath-wrap" style="display:none">
        <div class="yeet-permadeath-warn">This will permanently erase <strong>${escapeHTML(clientName)}</strong> and ALL associated data from the database. There is no undo.</div>
        <button class="btn btn-permadeath" id="yeet-permadeath">☠ PERMADEATH ☠</button>
      </div>

      <button class="btn btn-ghost btn-sm" id="yeet-cancel" style="margin-top:20px;width:100%">Never mind, they live another day</button>
    </div>
  `;
  document.body.appendChild(overlay);

  document.getElementById('yeet-cancel').addEventListener('click', () => overlay.remove());
  overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });

  document.getElementById('yeet-unsummon').addEventListener('click', async () => {
    const btn = document.getElementById('yeet-unsummon');
    btn.disabled = true;
    btn.textContent = `Unsummoning ${year}...`;
    try {
      await api(`/clients/${client.id}/season/${year}`, { method: 'DELETE' });
      overlay.remove();
      // Remove this year from state so detail re-renders on the previous year
      state.clientDetailYear = null;
      await renderClientDetail();
    } catch (e) {
      btn.disabled = false;
      btn.textContent = `UNSUMMON CURRENT SEASON`;
      alert('Error: ' + e.message);
    }
  });

  document.getElementById('yeet-finish-him').addEventListener('click', () => {
    document.getElementById('yeet-permadeath-wrap').style.display = 'block';
    document.getElementById('yeet-finish-him').style.display = 'none';
  });

  document.getElementById('yeet-permadeath').addEventListener('click', async () => {
    const btn = document.getElementById('yeet-permadeath');
    btn.disabled = true;
    btn.textContent = '☠ Banishing...';
    try {
      await api(`/clients/${client.id}`, { method: 'DELETE' });
      overlay.remove();
      // Remove from local state and go back to dashboard
      state.allShows = state.allShows.filter(s => s.client_id !== client.id);
      state.currentClientId = null;
      showView('dashboard');
      await refreshCardFace();
    } catch (e) {
      btn.disabled = false;
      btn.textContent = '☠ PERMADEATH ☠';
      alert('Error: ' + e.message);
    }
  });
}

async function renderClientDetail() {
  const client = state.clients.find(c => c.id === state.currentClientId);
  if (!client) return;

  const isMarching = client.ensemble_type === 'marching' || client.ensemble_type === 'university_band' || client.ensemble_type === 'drum_corps';

  // Notes are scoped to the fiscal year (Dec Y-1 → Nov Y) once clientDetailYear is known.
  // We fetch shows first to establish the year, then notes with the year param.
  const [allShows, materials] = await Promise.all([
    api(`/clients/${client.id}/shows`),
    isMarching ? api(`/clients/${client.id}/source-materials`) : Promise.resolve([])
  ]);

  // Compute available years for this client
  const clientYears = [...new Set(allShows.map(s => parseInt(s.season_year)).filter(Boolean))].sort();
  const maxYear = clientYears.length ? clientYears[clientYears.length - 1] : state.selectedYear;
  if (!clientYears.includes(maxYear + 1)) clientYears.push(maxYear + 1);

  // Filter shows to selected year
  if (!state.clientDetailYear || !clientYears.includes(state.clientDetailYear)) {
    state.clientDetailYear = clientYears.includes(state.selectedYear)
      ? state.selectedYear
      : (clientYears[clientYears.length - 2] || clientYears[0]);
  }
  const shows = allShows.filter(s => parseInt(s.season_year) === state.clientDetailYear);

  // Fetch notes scoped to fiscal year (Dec Y-1 → Nov Y)
  const notes = await api(`/clients/${client.id}/notes?season_year=${state.clientDetailYear}`);

  const marchingTabs = `
    <button class="tab-btn ${state.currentTab === 'shows' ? 'active' : ''}" data-tab="shows">Shows</button>
    <button class="tab-btn ${state.currentTab === 'collaborators' ? 'active' : ''}" data-tab="collaborators">Collaborators</button>
    <button class="tab-btn ${state.currentTab === 'client-chat' ? 'active' : ''}" data-tab="client-chat">Client Chat</button>
    <button class="tab-btn ${state.currentTab === 'notes' ? 'active' : ''}" data-tab="notes">Notes</button>
    <button class="tab-btn ${state.currentTab === 'materials' ? 'active' : ''}" data-tab="materials">Source Materials</button>
    <button class="tab-btn ${state.currentTab === 'schedule' ? 'active' : ''}" data-tab="schedule">Schedule</button>
    <button class="tab-btn ${state.currentTab === 'copyright' ? 'active' : ''}" data-tab="copyright">Copyright</button>
    <button class="tab-btn ${state.currentTab === 'results' ? 'active' : ''}" data-tab="results">Results</button>
    <button class="tab-btn ${state.currentTab === 'finances' ? 'active' : ''}" data-tab="finances">Bookkeeping</button>`;

  const compTabs = `
    <button class="tab-btn ${state.currentTab === 'shows' ? 'active' : ''}" data-tab="shows">Projects</button>
    <button class="tab-btn ${state.currentTab === 'notes' ? 'active' : ''}" data-tab="notes">Notes</button>
    <button class="tab-btn ${state.currentTab === 'copyright' ? 'active' : ''}" data-tab="copyright">Copyright</button>`;

  // Season-aware director: prefer shows[0].director_* over global clients.*
  const seasonDirectorName  = shows[0]?.director_name  || client.name  || '';
  const seasonDirectorEmail = shows[0]?.director_email || client.email || '';
  const seasonDirectorPhone = shows[0]?.director_phone || client.phone || '';

  document.getElementById('client-detail-content').innerHTML = `
    <div class="client-detail-header">
      <div>
        <div class="client-detail-name">${escapeHTML(client.org_name || client.name || '—')}</div>
        <div class="director-header-row">
          <div class="director-display" id="director-display">
            <span class="client-detail-org" id="director-name-display">${escapeHTML(seasonDirectorName)}</span>
            ${shows[0] ? `<button class="btn btn-ghost btn-xs director-change-btn" id="btn-director-change">Band Director Change?</button>` : ''}
          </div>
          <div class="director-edit-form" id="director-edit-form" style="display:none">
            <input type="text"  class="director-edit-input" id="director-edit-name"  placeholder="Director name"  value="${escapeHTML(seasonDirectorName)}" />
            <input type="email" class="director-edit-input" id="director-edit-email" placeholder="Email"          value="${escapeHTML(seasonDirectorEmail)}" />
            <input type="tel"   class="director-edit-input" id="director-edit-phone" placeholder="Phone"          value="${escapeHTML(seasonDirectorPhone)}" />
            <button class="collab-btn collab-btn-save"   id="btn-director-save"   title="Save">✓</button>
            <button class="collab-btn collab-btn-delete" id="btn-director-cancel" title="Cancel">✕</button>
          </div>
        </div>
        <div class="client-detail-meta">
          <span class="badge ${isMarching ? 'badge-marching' : 'badge-comp'}">${isMarching ? 'Marching' : 'Composition'}</span>
          ${client.state ? `<span class="badge badge-neutral">${client.state}</span>` : ''}
          ${client.band_size ? `<span class="badge badge-neutral">${client.band_size} members</span>` : ''}
        </div>
        <div class="client-contact" id="director-contact-display">
          ${seasonDirectorEmail ? `<a href="mailto:${seasonDirectorEmail}">✉ ${escapeHTML(seasonDirectorEmail)}</a>` : ''}
          ${seasonDirectorPhone ? `<a href="#" data-phone="${escapeHTML(seasonDirectorPhone)}">📞 ${escapeHTML(formatPhone(seasonDirectorPhone))}</a>` : ''}
        </div>
        <div class="client-address-website-row">
          ${(client.address_line1 || client.city) ? `<div class="client-detail-address">
            ${[client.address_line1, client.address_line2, [client.city, client.state].filter(Boolean).join(', ') + (client.zip ? ' ' + client.zip : '')].filter(Boolean).map(escapeHTML).join('<br>')}
          </div>` : ''}
          <div class="client-website-row" id="client-website-row">
            ${client.band_website
              ? `<a href="${escapeHTML(client.band_website)}" target="_blank" rel="noopener" class="band-website-link">🌐 Band Website</a>
                 <button class="btn-website-clear" title="Clear website" data-client-id="${client.id}">✕</button>`
              : `<button class="btn btn-ghost btn-xs btn-find-website" data-client-id="${client.id}">Find Band Website</button>`
            }
          </div>
        </div>
      </div>
      <div class="detail-actions">
        ${isMarching ? `
        <div class="circuit-field-row">
          <span class="circuit-label">Circuit</span>
          <input type="text" id="circuit-input" class="circuit-input"
            value="${escapeHTML(client.primary_circuit || '')}"
            placeholder="TOB, USBands, Cavalcade…">
          <button class="btn btn-ghost btn-xs" id="btn-save-circuit" title="Save circuit">✓</button>
        </div>` : ''}
        <button class="btn btn-ghost btn-sm" id="btn-edit-client">Edit Info</button>
        ${isMarching ? `<button class="btn btn-sm btn-send-contract" id="btn-open-contract" title="Generate & send contract PDF via Gmail">📄 Send Contract</button>` : ''}
        <button class="btn btn-sm btn-send-invoice" id="btn-open-invoice" title="Generate & send invoice PDF via Gmail">🧾 Send Invoice</button>
        <button class="btn btn-ghost btn-sm" id="btn-briefing">Ask David Thorne</button>
      </div>
    </div>

    <div id="briefing-panel" class="briefing-panel${client.ai_summary ? ' briefing-has-content' : ''}">
      ${client.ai_summary ? `
        <div class="david-panel-header">
          <img src="David_Thorne_2.png" class="david-avatar-sm" alt="David Thorne" />
          <span class="briefing-label">David Thorne — The Tactician</span>
        </div>
        <div class="briefing-text">${escapeHTML(client.ai_summary)}</div>
        <div class="briefing-meta">Generated ${timeAgo(client.ai_summary_at)} · <a href="#" class="briefing-refresh">Refresh</a></div>
      ` : ''}
    </div>

    <div class="detail-year-selector">
      <div class="detail-year-top-row">
        <div class="show-title-editor" id="show-title-editor">
          ${shows[0] ? `
            <span class="show-title-display" id="show-title-display">${escapeHTML(shows[0].title || '')}</span>
            <input class="show-title-input" id="show-title-input" type="text"
              placeholder="Show title…" value="${escapeHTML(shows[0].title || '')}" style="display:none">
            <button class="show-title-btn" id="btn-show-title-edit" title="Edit show title">✏</button>
            <button class="show-title-btn show-title-btn-save" id="btn-show-title-save" title="Save" style="display:none">✓</button>
            <button class="show-title-btn show-title-btn-cancel" id="btn-show-title-cancel" title="Cancel" style="display:none">✕</button>
          ` : ''}
        </div>
        <button class="btn btn-yeet" id="btn-yeet-client">Yeet</button>
      </div>
      <div class="detail-year-pills-row">
        ${clientYears.map(y => `
          <button class="year-btn ${y === state.clientDetailYear ? 'active' : ''}" data-detail-year="${y}">${y}</button>
        `).join('')}
        <button class="btn btn-ghost btn-sm" id="btn-add-year-show" style="margin-left:8px">+ Season</button>
      </div>
    </div>

    <div class="tab-bar">${isMarching ? marchingTabs : compTabs}</div>

    <div id="tab-shows" class="tab-content ${state.currentTab === 'shows' ? 'active' : ''}">
      ${renderShowsTab(shows, client)}
    </div>
    <div id="tab-notes" class="tab-content ${state.currentTab === 'notes' ? 'active' : ''}">
      ${renderNotesTab(notes)}
    </div>
    ${isMarching ? `
    <div id="tab-collaborators" class="tab-content ${state.currentTab === 'collaborators' ? 'active' : ''}">
      ${davidLoading('default')}
    </div>` : ''}
    ${isMarching ? `
    <div id="tab-client-chat" class="tab-content ${state.currentTab === 'client-chat' ? 'active' : ''}">
      <div class="client-chat-loading">${davidLoading('default')}</div>
    </div>` : ''}
    ${isMarching ? `
    <div id="tab-materials" class="tab-content ${state.currentTab === 'materials' ? 'active' : ''}">
      ${renderMaterialsTab(materials)}
    </div>
    <div id="tab-schedule" class="tab-content ${state.currentTab === 'schedule' ? 'active' : ''}">
      ${davidLoading('schedule')}
    </div>` : ''}
    <div id="tab-copyright" class="tab-content ${state.currentTab === 'copyright' ? 'active' : ''}">
      ${davidLoading('copyright')}
    </div>
    ${isMarching ? `
    <div id="tab-results" class="tab-content ${state.currentTab === 'results' ? 'active' : ''}">
      <div class="results-tab-inner" id="results-tab-inner">${davidLoading('results')}</div>
    </div>
    <div id="tab-finances" class="tab-content ${state.currentTab === 'finances' ? 'active' : ''}">
      ${davidLoading('default')}
    </div>` : ''}
  `;

  bindDetailEvents(client, shows, allShows, notes, materials, clientYears);

  // Load milestones for all show types
  shows.forEach(s => {
    const parts = Array.isArray(s.ensemble_parts) ? s.ensemble_parts
      : (s.ensemble_parts ? JSON.parse(s.ensemble_parts) : []);
    loadMilestones(s.id, parts);
  });

  if (isMarching) {
    loadScheduleTab(shows, client);
  }

  // Load persisted Drive invite state for all shows with a folder
  const showsWithDrive = shows.filter(s => s.drive_folder_id);
  if (showsWithDrive.length) loadDrivePermissions(showsWithDrive);

  loadCopyrightTab(client.id);

  if (state.currentTab === 'notes') {
    loadNotesSummary(client.id);
  }
  if (isMarching && state.currentTab === 'collaborators') {
    loadCollaboratorsTab(client.id, state.clientDetailYear);
  }
  if (state.currentTab === 'materials') {
    bindFindSourcesBtn(client.id);
  }
  if (isMarching && state.currentTab === 'finances') {
    loadFinancesTab(client, shows[0] || null);
  }
  if (isMarching && state.currentTab === 'client-chat') {
    loadClientChatTab(client, shows);
  }
  if (isMarching) {
    loadCollaboratorsTab(client.id, state.clientDetailYear); // always pre-load so tab is ready
    // Load survey status for each show
    shows.forEach(s => loadSurveyButton(s.id, client));
  }
}

// ── Ensemble Survey Button ─────────────────────────────────────────────────
async function loadSurveyButton(showId, client) {
  const wrap = document.getElementById(`survey-btn-wrap-${showId}`);
  if (!wrap) return;

  let survey = null;
  try {
    survey = await api(`/survey/show/${showId}`);
  } catch { /* not yet sent */ }

  renderSurveyButton(wrap, showId, survey, client);
}

function renderSurveyButton(wrap, showId, survey, client) {
  const status = survey?.status || 'not_sent';

  if (status === 'returned') {
    wrap.innerHTML = `
      <button class="btn-survey-returned" data-show-id="${showId}" data-survey-id="${survey.id}">
        ✓ Survey Returned
      </button>`;
    wrap.querySelector('.btn-survey-returned')?.addEventListener('click', () => {
      openSurveyResults(survey.id, client);
    });
  } else if (status === 'sent') {
    wrap.innerHTML = `
      <div class="survey-sent-state">
        <span class="survey-sent-label">Survey Sent ${survey.sent_at ? formatDate(survey.sent_at) : ''}</span>
        <button class="btn-survey-resend" data-show-id="${showId}">Resend</button>
      </div>`;
    wrap.querySelector('.btn-survey-resend')?.addEventListener('click', () => {
      sendSurvey(showId, client, wrap, survey);
    });
  } else {
    wrap.innerHTML = `
      <button class="btn-survey-send" data-show-id="${showId}">
        Send Ensemble Survey
      </button>`;
    wrap.querySelector('.btn-survey-send')?.addEventListener('click', () => {
      sendSurvey(showId, client, wrap, survey);
    });
  }
}

async function sendSurvey(showId, client, wrap, existingSurvey) {
  // Prefer season-specific director from state.allShows (updated live by "Band Director Change?")
  // Fall back to the client-level email if the show has none
  const showState = state.allShows.find(s => s.id === parseInt(showId));
  const directorEmail = showState?.director_email || client.email || '';
  const directorName  = showState?.director_name  || client.name || client.org_name;

  // Quick confirm with email prefilled
  const email = prompt(`Send ensemble survey to:`, directorEmail);
  if (email === null) return; // cancelled

  const btn = wrap.querySelector('button');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

  try {
    const result = await api('/survey/show/' + showId + '/send', {
      method: 'POST',
      body: { to_email: email, to_name: directorName }
    });
    renderSurveyButton(wrap, showId, { ...existingSurvey, status: 'sent', sent_at: new Date().toISOString(), id: result.id || existingSurvey?.id }, client);
  } catch (err) {
    if (btn) { btn.disabled = false; btn.textContent = existingSurvey?.status === 'sent' ? 'Resend' : 'Send Ensemble Survey'; }
    alert('Could not send survey: ' + err.message);
  }
}

async function openSurveyResults(surveyId, client) {
  try {
    const survey = await api(`/survey/${surveyId}/data`);
    const modal = document.getElementById('modal-survey-results');
    const content = document.getElementById('survey-results-content');
    content.innerHTML = renderSurveyDocument(survey.survey_data, survey.org_name, survey.season_year);
    modal.style.display = 'flex';
  } catch (err) {
    alert('Could not load survey: ' + err.message);
  }
}

function renderSurveyDocument(data, orgName, year) {
  if (!data) return '<div class="empty-state">No survey data.</div>';
  const d = data;

  const sectionRow = (label, countKey, notesKey) => {
    const count = d[countKey + '_count'];
    const notes = d[notesKey || (countKey + '_notes')];
    if (!count && !notes) return '';
    return `<tr>
      <td class="sv-instrument">${label}</td>
      <td class="sv-count">${count || '—'}</td>
      <td class="sv-notes">${escapeHTML(notes || '')}</td>
    </tr>`;
  };

  const section = (title, hintCols, rows) => `
    <div class="sv-section">
      <div class="sv-section-title">${title}</div>
      <table class="sv-table">
        <thead><tr><th>Instrument</th><th>#</th><th>${hintCols}</th></tr></thead>
        <tbody>${rows.filter(Boolean).join('')}</tbody>
      </table>
    </div>`;

  const wwRows = [
    sectionRow('Piccolo',       'piccolo',       'piccolo_notes'),
    sectionRow('Flute',         'flute',         'flute_notes'),
    sectionRow('Clarinet',      'clarinet',      'clarinet_notes'),
    sectionRow('Bass Clarinet', 'bass_clarinet', 'bass_clarinet_notes'),
    sectionRow('Alto Sax',      'alto_sax',      'alto_sax_notes'),
    sectionRow('Tenor Sax',     'tenor_sax',     'tenor_sax_notes'),
    sectionRow('Bari Sax',      'bari_sax',      'bari_sax_notes'),
  ];
  const brassRows = [
    sectionRow('Trumpet',    'trumpet',    'trumpet_notes'),
    sectionRow('Mellophone', 'mellophone', 'mellophone_notes'),
    sectionRow('Trombone',   'trombone',   'trombone_notes'),
    sectionRow('Baritone',   'baritone',   'baritone_notes'),
    sectionRow('Tuba',       'tuba',       'tuba_notes'),
  ];
  const batteryRows = [
    sectionRow('Snare',            'snare',    'snare_notes'),
    sectionRow('Tenor Drums',      'tenor',    'tenor_notes'),
    sectionRow('Bass Drums',       'bass_drum','bass_drum_notes'),
    sectionRow('Marching Cymbals', 'cymbals',  'cymbals_notes'),
  ];
  const frontRows = [
    sectionRow('Marimba',        'marimba',   'marimba_notes'),
    sectionRow('Vibraphone',     'vibe',      'vibe_notes'),
    sectionRow('Xylophone',      'xylo',      'xylo_notes'),
    sectionRow('Glock',          'glock',     'glock_notes'),
    sectionRow('Timpani',        'timp',      'timp_notes'),
    sectionRow('Accessory/Rack', 'accessory', 'accessory_notes'),
    sectionRow('Other',          'other_pit', 'other_pit_notes'),
  ];

  return `
    <div class="sv-doc">
      <div class="sv-doc-header">
        <div class="sv-doc-title">${escapeHTML(orgName)} — ${year} Ensemble Survey</div>
      </div>
      ${section('Woodwinds', 'Range / Technique / Soloists', wwRows)}
      ${d.brass_miking ? `<div class="sv-extra-field"><strong>Mic'ing:</strong> ${escapeHTML(d.brass_miking)}</div>` : ''}
      ${section('Brass', 'Range / Technique', brassRows)}
      ${d.sound_system ? `<div class="sv-extra-field"><strong>Sound System:</strong> ${escapeHTML(d.sound_system)}</div>` : ''}
      ${section('Battery', 'Technique Considerations', batteryRows)}
      ${section('Front Ensemble', 'Ranges / Mallets', frontRows)}
      ${(d.synth_count || d.synth_notes || d.synth_software) ? `
      <div class="sv-section">
        <div class="sv-section-title">Synthesizer</div>
        <table class="sv-table">
          <thead><tr><th>Instrument</th><th>#</th><th>Hardware / MainStage</th></tr></thead>
          <tbody><tr>
            <td class="sv-instrument">Synthesizer</td>
            <td class="sv-count">${d.synth_count || '—'}</td>
            <td class="sv-notes">${escapeHTML(d.synth_notes || '')}</td>
          </tr></tbody>
        </table>
        ${d.synth_software ? `<div class="sv-extra-field"><strong>Software / Patches:</strong> ${escapeHTML(d.synth_software)}</div>` : ''}
      </div>` : ''}
    </div>`;
}

function bindFindSourcesBtn(clientId) {
  const btn = document.getElementById('btn-find-sources');
  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = '1';
  btn.addEventListener('click', () => loadSourceSuggestions(clientId, true));
  // Auto-load cached suggestions immediately
  loadSourceSuggestions(clientId, false);
}

// ── Shows Tab ──────────────────────────────────────────────────────────────
function renderShowsTab(shows, client) {
  const isMarching = client.ensemble_type === 'marching' || client.ensemble_type === 'university_band' || client.ensemble_type === 'drum_corps';
  const addBtn = `<div style="display:flex;justify-content:flex-end;margin-bottom:14px">
    <button class="btn btn-sm ${isMarching ? 'btn-marching' : 'btn-comp'}" id="btn-add-show">+ Add ${isMarching ? 'Show' : 'Project'}</button>
  </div>`;

  if (!shows.length) return addBtn + `<div class="empty-state">No ${isMarching ? 'shows' : 'projects'} for ${state.clientDetailYear}. Add one above.</div>`;

  // Marching/standard shows first, composition projects at the bottom
  const sorted = [...shows].sort((a, b) => {
    const aComp = a.show_type === 'composition' ? 1 : 0;
    const bComp = b.show_type === 'composition' ? 1 : 0;
    return aComp - bComp;
  });

  return addBtn + sorted.map(s => {
    const dur = parseInt(s.duration_seconds) || 0;
    const written = parseInt(s.written_seconds) || 0;
    const pct = dur > 0 ? Math.round((written / dur) * 100) : (parseInt(s.percent_complete) || 0);
    const parts = Array.isArray(s.ensemble_parts) ? s.ensemble_parts
      : (s.ensemble_parts ? JSON.parse(s.ensemble_parts) : []);
    const fee = s.fee_cents ? (s.fee_cents / 100).toString() : '';
    const design = s.design_status || 'not_started';
    const allParts = ['winds', 'battery', 'front_ensemble', 'sound_design'];
    const partLabels = { winds: 'Winds', battery: 'Battery', front_ensemble: 'Front Ensemble', sound_design: 'Sound Design' };

    const deliverBy = s.deliver_by_date ? s.deliver_by_date.split('T')[0] : '';
    const readyToWrite = s.ready_to_write_date ? s.ready_to_write_date.split('T')[0] : '';

    return `
      <div class="show-card${s.show_type === 'composition' ? ' show-card--composition' : ''}" data-show-id="${s.id}">
        <div class="show-card-header">
          <div class="show-title-text">${escapeHTML(s.title || `${s.season_year} Season`)}</div>
          <span class="badge badge-neutral">${showTypeLabel(s.show_type)}</span>
        </div>

        <div class="show-fields">
          <!-- Row 1: Season Year + My Role side by side -->
          <div class="show-field">
            <label>Season Year</label>
            <input type="number" value="${s.season_year || ''}" data-show-id="${s.id}" data-field="season_year" />
          </div>
          <div class="show-field show-field-roles">
            <label>My Role</label>
            ${(() => {
              const roles = (s.role || '').split(',').map(r => r.trim()).filter(Boolean);
              return `<div class="role-checkbox-group" data-show-id="${s.id}">
                <label class="role-check"><input type="checkbox" value="composer" ${roles.includes('composer') ? 'checked' : ''}> Composer</label>
                <label class="role-check"><input type="checkbox" value="arranger" ${roles.includes('arranger') ? 'checked' : ''}> Arranger</label>
                <label class="role-check"><input type="checkbox" value="drill_writer" ${roles.includes('drill_writer') ? 'checked' : ''}> Drill Writer</label>
                <label class="role-check"><input type="checkbox" value="sound_designer" ${roles.includes('sound_designer') ? 'checked' : ''}> Sound Designer</label>
                <label class="role-check"><input type="checkbox" value="instructor" ${roles.includes('instructor') ? 'checked' : ''}> Instructor</label>
                <label class="role-check"><input type="checkbox" value="director" ${roles.includes('director') ? 'checked' : ''}> Director</label>
                <label class="role-check"><input type="checkbox" value="clinician_consultant" ${roles.includes('clinician_consultant') ? 'checked' : ''}> Clinician / Consultant</label>
              </div>`;
            })()}
          </div>
        </div>

        <!-- Row 2: Design Status + dates + Ensemble Parts + Survey all horizontal -->
        <div class="show-design-band">
          <div class="show-field show-field-compact">
            <label>Design Status</label>
            <select class="design-status-select" data-show-id="${s.id}">
              <option value="not_started" ${design === 'not_started' ? 'selected' : ''}>Not Started</option>
              <option value="in_progress" ${design === 'in_progress' ? 'selected' : ''}>In Progress</option>
              <option value="ready" ${design === 'ready' ? 'selected' : ''}>Ready to Write</option>
            </select>
          </div>
          <div class="show-field show-field-compact">
            <label>Ready to Write</label>
            <input type="date" class="ready-to-write-input" value="${readyToWrite}" data-show-id="${s.id}" />
          </div>
          <div class="show-field show-field-compact">
            <label>Deliver By</label>
            <input type="date" class="deliver-by-input" value="${deliverBy}" data-show-id="${s.id}" />
          </div>
          <div class="show-field show-field-compact show-field-schedule-btn">
            <label>&nbsp;</label>
            <button class="btn-gen-schedule-pill" data-show-id="${s.id}" data-show-type="${s.show_type || 'marching_band'}">↻ Schedule</button>
          </div>
          ${isMarching ? `
          <div class="show-field show-field-compact show-field-parts">
            <label>Ensemble Parts</label>
            <div class="show-checkrow show-checkrow-parts">
              ${allParts.map(p => `
                <label class="check-label">
                  <input type="checkbox" class="part-checkbox" data-show-id="${s.id}" value="${p}"
                    ${parts.includes(p) ? 'checked' : ''} />
                  ${partLabels[p]}
                </label>`).join('')}
            </div>
          </div>
          <div class="show-field show-field-compact show-field-survey">
            <label>&nbsp;</label>
            <div class="survey-btn-wrap" id="survey-btn-wrap-${s.id}">
              <button class="btn-survey-send" data-show-id="${s.id}">Loading…</button>
            </div>
          </div>` : ''}
        </div>

        <div class="show-section-divider">Google Drive</div>
        <div class="show-drive-row" id="drive-row-${s.id}">
          ${s.drive_folder_url
            ? `<a href="${escapeHTML(s.drive_folder_url)}" target="_blank" rel="noopener" class="show-drive-link">📁 Open Folder</a>
               <button class="btn btn-ghost btn-sm btn-invite-collabs" data-show-id="${s.id}" data-folder-id="${escapeHTML(s.drive_folder_id || '')}">👥 Invite Collaborators</button>
               <button class="btn btn-ghost btn-sm btn-drive-clear" data-show-id="${s.id}" title="Clear folder link">✕ Clear Link</button>`
            : `<button class="btn btn-ghost btn-sm btn-provision-drive" data-show-id="${s.id}">📁 Generate Drive Folder</button>
               <button class="btn btn-ghost btn-sm btn-drive-rescan" data-show-id="${s.id}" title="Search Drive for existing folder">🔍 Rescan</button>
               <span class="drive-paste-wrap">
                 <input type="text" class="drive-paste-input" data-show-id="${s.id}" placeholder="Or paste Drive folder URL…" />
                 <button class="btn btn-ghost btn-sm btn-drive-paste-save" data-show-id="${s.id}">Save</button>
               </span>`
          }
        </div>
        <div class="show-drive-access" id="drive-access-${s.id}" style="display:none"></div>

        ${isMarching ? `
        <div class="show-section-divider">Show Duration — <span class="duration-display-${s.id}">${secsToMMSS(dur > 0 ? dur : 420)}</span></div>
        <input type="range" class="duration-input progress-range"
          min="270" max="570" step="15"
          value="${dur > 0 ? dur : 420}"
          data-show-id="${s.id}" data-is-duration="true"
          style="width:100%;accent-color:var(--marching-primary);margin-bottom:4px" />
        <div style="display:flex;justify-content:space-between;font-size:11px;color:var(--text-muted);margin-bottom:12px">
          <span>4:30</span><span>7:00</span><span>9:30</span>
        </div>

        <div class="show-section-divider">Movements</div>
        <div id="milestones-${s.id}" class="milestones-list">
          <div class="empty-state" style="padding:12px">Loading...</div>
        </div>
        ` : `
        <div class="show-section-divider">Project Description</div>
        <textarea class="project-description-input" data-show-id="${s.id}"
          placeholder="Describe the composition project..."
          rows="3">${escapeHTML(s.project_description || '')}</textarea>

        <div class="show-section-divider">Writing Milestones</div>
        <div id="milestones-${s.id}" class="milestones-list">
          <div class="empty-state" style="padding:12px">Loading...</div>
        </div>
        `}

        <div class="progress-wrap">
          <div class="progress-label">
            <span class="progress-time-display-${s.id}">
              ${dur > 0 ? `${secsToMMSS(written)} / ${secsToMMSS(dur)}` : 'Set duration to enable time tracking'}
            </span>
            <span class="pct-display-${s.id}">${pct}%</span>
          </div>
          <div class="progress-bar-track">
            <div class="progress-bar-fill ${!isMarching ? 'comp' : ''} pct-bar-${s.id}" style="width:${pct}%"></div>
          </div>
          <input type="range" min="0" max="${dur > 0 ? dur : 100}"
            step="${dur > 0 ? 15 : 1}" value="${dur > 0 ? written : pct}"
            class="progress-slider" data-show-id="${s.id}"
            data-duration="${dur}" data-written="${written}"
            ${dur === 0 ? 'disabled title="Set a total duration first"' : ''} />
          ${deliverBy ? `<div class="note-timestamp ${dueDateClass(deliverBy)}" style="margin-top:6px">Deliver by: ${formatDate(deliverBy)}</div>` : ''}
        </div>
      </div>`;
  }).join('');
}

// ── Notes Tab ──────────────────────────────────────────────────────────────
function renderNotesTab(notes) {
  return `
    <div id="notes-ai-summary" class="notes-ai-summary"></div>
    <div class="notes-toolbar">
      <button class="btn btn-sm btn-ghost" id="btn-toggle-composer">+ New Note</button>
    </div>
    <div class="note-composer" id="note-composer">
      <textarea id="note-body-input" placeholder="Type or paste a note..."></textarea>
      <div class="composer-actions">
        <button class="btn btn-ghost btn-sm" id="btn-cancel-note">Cancel</button>
        <button class="btn btn-primary btn-sm" id="btn-save-note">Save Note</button>
      </div>
    </div>
    <div id="notes-list">
      ${notes.length ? notes.map(noteHTML).join('') : davidEmpty('notes')}
    </div>`;
}

async function loadNotesSummary(clientId, refresh = false) {
  const container = document.getElementById('notes-ai-summary');
  if (!container) return;
  container.innerHTML = davidLoading('briefing');
  try {
    const url = `/clients/${clientId}/comms-briefing${refresh ? '?force=true' : ''}`;
    const data = await api(url, { method: 'POST' });
    const text = data.briefing || data.summary || '';
    const cachedAt = data.cached_at || '';
    if (!text) {
      container.innerHTML = '';
      return;
    }
    const age = cachedAt
      ? `<span class="ai-summary-age">Refreshes every 4 hours · Last run ${timeAgo(cachedAt)}</span>`
      : '';
    container.innerHTML = `
      <div class="ai-summary-card advisor-panel">
        <div class="david-panel-header">
          <img src="David_Thorne_2.png" class="david-avatar-sm" alt="David Thorne" />
          <div class="ai-summary-label">David Thorne — The Tactician ${age}</div>
        </div>
        <div class="ai-summary-body">${window.WMM_ROLE === 'viewer' ? '<em style="opacity:0.4">Analysis hidden in viewer mode.</em>' : escapeHTML(text)}</div>
        <button class="btn btn-ghost btn-sm ai-summary-rescan" data-client-id="${clientId}">↺ Refresh Now</button>
      </div>`;
    container.querySelector('.ai-summary-rescan')?.addEventListener('click', () => {
      loadNotesSummary(clientId, true);
    });
  } catch {
    container.innerHTML = '';
  }
}

// Format note body: escape HTML, linkify URLs, preserve line breaks
function formatNoteBody(raw) {
  if (!raw) return '';
  // Escape HTML entities first
  let html = raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  // Convert URLs to clickable links
  html = html.replace(
    /(https?:\/\/[^\s&<"]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer" class="note-link">$1</a>'
  );
  // Preserve line breaks
  html = html.replace(/\n/g, '<br>');
  return html;
}

// Extract reply context from a note — works for both new notes (email_log join)
// and legacy email notes where From:/Subject: are embedded in the note body.
function noteReplyContext(n) {
  if (n.source !== 'email') return null;
  if (n.reply_to) return n; // already joined from email_log

  // Fallback: parse headers embedded by emailNoteBody()
  const fromMatch    = (n.body || '').match(/^From:\s*(.+)/m);
  const subjectMatch = (n.body || '').match(/^Subject:\s*(.+)/m);
  if (!fromMatch) return null;

  return {
    ...n,
    reply_to:         fromMatch[1].trim(),
    original_subject: subjectMatch?.[1]?.trim() || '',
    reply_via:        'gmail_wmm',
    original_body:    n.body
  };
}

const NOTE_COLLAPSE_THRESHOLD = 400; // chars before we truncate

function noteHTML(n) {
  // Ensemble survey notes get a special formatted display
  if (n.source === 'ensemble_survey') {
    return `
    <div class="note-item note-item-survey" data-note-id="${n.id}">
      <div class="note-meta">
        <span class="note-timestamp">${formatDate(n.created_at)}</span>
        <span class="badge badge-survey">Ensemble Survey</span>
      </div>
      <div class="survey-note-body">${formatNoteBody(n.body || '')}</div>
    </div>`;
  }

  const sourceBadge = { manual: 'badge-neutral', email: 'badge-comp', text: 'badge-success', agent: 'badge-warning' };

  // Resolve reply context (DB join for new notes, body-parse for legacy)
  const rc = noteReplyContext(n);
  if (rc) state.inboxItemsById['n' + n.id] = rc;

  const body = n.body || '';
  const isLong = body.length > NOTE_COLLAPSE_THRESHOLD;
  const previewBody = isLong ? body.slice(0, NOTE_COLLAPSE_THRESHOLD) + '…' : body;
  const isDismissable = n.source === 'email' || n.source === 'text';

  return `
    <div class="note-item" data-note-id="${n.id}">
      <div class="note-meta">
        <span class="note-timestamp">${formatDate(n.created_at)}${n.updated_at !== n.created_at ? ' · edited' : ''}</span>
        <span class="badge ${sourceBadge[n.source] || 'badge-neutral'}">${n.source || 'manual'}</span>
      </div>
      <div class="note-body-display note-body-collapsed" data-full="${escapeHTML(body)}" data-collapsed="${isLong}">${window.WMM_ROLE === 'viewer' ? '<em style="opacity:0.35">Note hidden in viewer mode.</em>' : formatNoteBody(previewBody)}</div>
      ${isLong ? `<button class="btn-note-expand" data-note-id="${n.id}">▼ Show more</button>` : ''}
      <div class="note-attachments" id="attachments-${n.id}"></div>
      <div style="display:flex;gap:8px;margin-top:8px;align-items:center;flex-wrap:wrap">
        ${rc ? `<button class="btn btn-ghost btn-sm btn-reply-email" onclick="openReplyModal('n${n.id}')">↩ Reply</button>` : ''}
        <button class="btn btn-ghost btn-sm btn-edit-note" data-note-id="${n.id}">Edit</button>
        <label class="btn btn-ghost btn-sm" style="cursor:pointer">
          Attach
          <input type="file" class="attach-input" data-note-id="${n.id}" style="display:none" />
        </label>
        <span class="note-revisions-link" data-note-id="${n.id}">revision history</span>
        <button class="btn btn-ghost btn-sm btn-add-task-note" data-note-id="${n.id}"
          data-source="${escapeHTML(n.source || 'note')}"
          data-body="${escapeHTML(body.slice(0, 1200))}">📋 Task</button>
        ${isDismissable ? `<button class="btn btn-ghost btn-sm btn-dismiss-note" data-note-id="${n.id}" title="Hide — not applicable to this show">✕ N/A</button>` : ''}
      </div>
    </div>`;
}

// ── Source Materials Tab ───────────────────────────────────────────────────
function renderMaterialsTab(materials) {
  return `
    <div class="materials-toolbar">
      <button class="btn btn-ghost btn-sm" id="btn-add-material">+ Add Material</button>
      <button class="btn btn-ghost btn-sm" id="btn-upload-pdf">↑ Upload PDF</button>
      <input type="file" id="pdf-upload-input" accept=".pdf,application/pdf" style="display:none">
      <label style="display:inline-flex;align-items:center;gap:6px;font-size:0.8rem;color:var(--text-muted);cursor:pointer;margin-left:4px;">
        <input type="checkbox" id="chk-master-repo" style="cursor:pointer;">
        Add to Master Score Repository
      </label>
    </div>
    <div id="materials-list">
      ${materials.length ? materials.map(materialHTML).join('') : davidEmpty('materials')}
    </div>
    <div class="source-suggestions-section">
      <div class="source-suggestions-header">
        <span class="source-suggestions-title">Source Material Suggestions</span>
        <button class="btn btn-ghost btn-sm" id="btn-find-sources">↺ Rescan</button>
      </div>
      <div id="source-suggestions-list" class="source-suggestions-list">
        ${davidLoading('materials')}
      </div>
    </div>`;
}

// Cache for current suggestions (used by applySuggestion)
let _sourceSuggestions = [];

async function loadSourceSuggestions(clientId, refresh = false) {
  const container = document.getElementById('source-suggestions-list');
  if (!container) return;
  if (refresh) {
    container.innerHTML = davidLoading('materials');
  }
  try {
    const url = `/clients/${clientId}/source-suggestions${refresh ? '?refresh=true' : ''}`;
    const suggestions = await api(url);
    _sourceSuggestions = suggestions;
    if (!suggestions.length) {
      container.innerHTML = davidEmpty('materials');
      return;
    }
    container.innerHTML = suggestions.map((s, i) => `
      <div class="suggestion-item" data-idx="${i}">
        <div class="suggestion-top">
          <span class="suggestion-type-badge type-${s.type}">${s.type}</span>
          <span class="suggestion-label">${escapeHTML(s.label || '')}</span>
          <button class="btn-inline btn-add-suggestion" onclick="applySuggestion(${clientId}, ${i})">+ Add</button>
          <button class="btn-inline btn-dismiss-suggestion" onclick="dismissSuggestion(${clientId}, ${i})" title="Dismiss">×</button>
        </div>
        ${s.url ? `<div class="suggestion-url"><a href="${s.url}" target="_blank" rel="noopener">${escapeHTML(s.url)}</a></div>` : ''}
        <div class="suggestion-source">${escapeHTML(s.source || '')}</div>
      </div>
    `).join('');
  } catch (err) {
    container.innerHTML = davidError();
    console.error('loadSourceSuggestions:', err.message);
  }
}

function applySuggestion(clientId, idx) {
  const s = _sourceSuggestions[idx];
  if (!s) return;
  // Pre-fill the Add Material modal
  document.getElementById('material-client-id').value = clientId;
  const typeEl = document.getElementById('material-type');
  if (typeEl) {
    const validTypes = ['youtube', 'spotify', 'url'];
    typeEl.value = validTypes.includes(s.type) ? s.type : 'url';
  }
  document.getElementById('material-label').value = s.label || '';
  document.getElementById('material-url').value = s.url || '';
  document.getElementById('modal-new-material').style.display = 'flex';
}

async function dismissSuggestion(clientId, idx) {
  const s = _sourceSuggestions[idx];
  if (!s) return;
  try {
    const updated = await api(`/clients/${clientId}/source-suggestions/dismiss`, {
      method: 'POST',
      body: JSON.stringify({ label: s.label, url: s.url })
    });
    _sourceSuggestions = updated;
    const container = document.getElementById('source-suggestions-list');
    if (!container) return;
    if (!updated.length) {
      container.innerHTML = davidEmpty('materials');
      return;
    }
    // Remove just this card from the DOM (instant, no full re-render)
    const card = container.querySelector(`[data-idx="${idx}"]`);
    if (card) card.remove();
    // Re-index remaining cards so future dismissals use correct indices
    container.querySelectorAll('.suggestion-item').forEach((el, i) => {
      el.dataset.idx = i;
      el.querySelector('.btn-add-suggestion').setAttribute('onclick', `applySuggestion(${clientId}, ${i})`);
      el.querySelector('.btn-dismiss-suggestion').setAttribute('onclick', `dismissSuggestion(${clientId}, ${i})`);
    });
  } catch (err) {
    console.error('dismissSuggestion:', err.message);
  }
}

function materialHTML(m) {
  return `
    <div class="material-item" data-material-id="${m.id}">
      <div class="material-icon">${typeIcon(m.type)}</div>
      <div class="material-info">
        <div class="material-label">${escapeHTML(m.label || m.url || '')}</div>
        <div class="material-url"><a href="${m.url}" target="_blank" rel="noopener">${escapeHTML(m.url)}</a></div>
      </div>
      <button class="btn btn-ghost btn-sm btn-delete-material" data-material-id="${m.id}">Remove</button>
    </div>`;
}

// ── Schedule Tab ─────────────────────────────────────────────────────────────
const EVENT_TYPE_LABELS = {
  rehearsal: 'Rehearsal',
  show_day: 'Show Day',
  competition: 'Competition',
  clinic: 'Clinic',
  meeting: 'Meeting',
  other: 'Other'
};

async function loadScheduleTab(shows, client) {
  const container = document.getElementById('tab-schedule');
  if (!container) return;

  const showId = shows[0]?.id;
  if (!showId) {
    container.innerHTML = '<div class="empty-state">No show for this season.</div>';
    return;
  }

  // Fetch schedule events and competitions in parallel
  const [events, allComps] = await Promise.all([
    api(`/schedule/show/${showId}`),
    (async () => {
      let comps = [];
      for (const s of shows) {
        const c = await api(`/competitions/show/${s.id}`);
        comps = [...comps, ...c.map(x => ({ ...x, show_id: s.id }))];
      }
      return comps.sort((a, b) => (a.competition_date || '').localeCompare(b.competition_date || ''));
    })()
  ]);

  container.innerHTML = renderScheduleTab(events, allComps, showId);
  bindScheduleEvents(events, allComps, shows, client, showId);
}

function renderScheduleTab(events, allComps, showId) {
  return `
    <div class="schedule-layout">
      <div class="schedule-left">
        <div class="schedule-left-header">
          <span class="schedule-section-title">Season Timeline</span>
          <button class="btn btn-sm btn-marching" id="btn-add-event">+ Add Event</button>
        </div>
        ${events.length ? `
          <div class="schedule-event-list" id="schedule-event-list">
            ${events.map(e => scheduleEventRowHTML(e)).join('')}
          </div>` : `
          <div class="empty-state" id="schedule-event-list" style="padding:20px">No events yet — add rehearsals, show days, competitions, and more.</div>`}
        <div id="sched-add-form" style="display:none" class="sched-add-form">
          <input type="hidden" id="sched-show-id" value="${showId}" />
          <div class="show-fields">
            <div class="show-field">
              <label>Event Type</label>
              <select id="sched-type">
                <option value="rehearsal">Rehearsal</option>
                <option value="show_day">Show Day</option>
                <option value="competition">Competition</option>
                <option value="clinic">Clinic</option>
                <option value="meeting">Meeting</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="show-field">
              <label>Date</label>
              <input type="date" id="sched-date" />
            </div>
            <div class="show-field">
              <label>Time Start</label>
              <input type="time" id="sched-time-start" />
            </div>
            <div class="show-field">
              <label>Time End</label>
              <input type="time" id="sched-time-end" />
            </div>
            <div class="show-field show-field-full">
              <label>Location</label>
              <input type="text" id="sched-location" placeholder="e.g. Home stadium, Band room" />
            </div>
            <div class="show-field show-field-full">
              <label>Notes</label>
              <input type="text" id="sched-notes" placeholder="Optional notes" />
            </div>
          </div>
          <div id="sched-comp-fields" style="display:none" class="sched-comp-fields">
            <div class="show-section-divider">Competition Data</div>
            <div class="show-fields">
              <div class="show-field">
                <label>Competition Name</label>
                <input type="text" id="sched-comp-name" placeholder="e.g. Regional Championship" />
              </div>
              <div class="show-field">
                <label>Score</label>
                <input type="number" id="sched-comp-score" step="0.01" min="0" placeholder="e.g. 82.5" />
              </div>
              <div class="show-field">
                <label>Placement</label>
                <input type="text" id="sched-comp-placement" placeholder="e.g. 1st / Caption Award" />
              </div>
            </div>
          </div>
          <div style="display:flex;gap:8px;margin-top:8px">
            <button class="btn btn-ghost btn-sm" id="btn-cancel-event">Cancel</button>
            <button class="btn btn-marching btn-sm" id="btn-save-event">Save</button>
          </div>
        </div>
      </div>

      <div class="schedule-right">
        <div class="schedule-section-title">Competition Results</div>
        ${renderCompResultsPanel(allComps)}
      </div>
    </div>`;
}

function scheduleEventRowHTML(e) {
  const typeLabel = EVENT_TYPE_LABELS[e.event_type] || e.event_type;
  const typeCls = `sched-badge-${e.event_type}`;
  const dateStr = e.event_date ? formatDate(e.event_date) : '—';
  const timeStr = e.time_start ? e.time_start.slice(0, 5) + (e.time_end ? `–${e.time_end.slice(0, 5)}` : '') : '';
  const compInfo = e.event_type === 'competition' && e.competition_name
    ? `<span class="sched-comp-info">${escapeHTML(e.competition_name)}${e.score != null ? ` · ${e.score}` : ''}${e.placement ? ` · ${escapeHTML(e.placement)}` : ''}</span>`
    : '';
  const compEditFields = e.event_type === 'competition' ? `
    <div class="sched-edit-row">
      <input class="sched-edit-comp-name" type="text" placeholder="Competition name" value="${escapeHTML(e.competition_name || '')}">
      <input class="sched-edit-comp-score" type="text" placeholder="Score" value="${escapeHTML(e.score != null ? String(e.score) : '')}">
      <input class="sched-edit-comp-placement" type="text" placeholder="Placement" value="${escapeHTML(e.placement || '')}">
    </div>` : '';
  return `
    <div class="sched-event-row" data-event-id="${e.id}">
      <div class="sched-event-main">
        <span class="sched-type-badge ${typeCls}">${typeLabel}</span>
        <span class="sched-event-date">${dateStr}</span>
        ${timeStr ? `<span class="sched-event-time">${timeStr}</span>` : ''}
        ${e.location ? `<span class="sched-event-loc">${escapeHTML(e.location)}</span>` : ''}
        <button class="btn btn-ghost btn-sm btn-edit-event" data-event-id="${e.id}" style="margin-left:auto" title="Edit">✎</button>
        <button class="btn btn-ghost btn-sm btn-delete-event" data-event-id="${e.id}" title="Delete">✕</button>
      </div>
      ${compInfo ? `<div class="sched-event-sub">${compInfo}</div>` : ''}
      ${e.notes ? `<div class="sched-event-notes">${escapeHTML(e.notes)}</div>` : ''}
      <div class="sched-inline-edit" style="display:none">
        <div class="sched-edit-row">
          <input class="sched-edit-date" type="date" value="${e.event_date ? e.event_date.split('T')[0] : ''}">
          <input class="sched-edit-time-start" type="time" value="${e.time_start ? e.time_start.slice(0,5) : ''}">
          <input class="sched-edit-time-end" type="time" value="${e.time_end ? e.time_end.slice(0,5) : ''}">
        </div>
        <div class="sched-edit-row">
          <input class="sched-edit-location" type="text" placeholder="Location" value="${escapeHTML(e.location || '')}">
          <textarea class="sched-edit-notes" placeholder="Notes">${escapeHTML(e.notes || '')}</textarea>
        </div>
        ${compEditFields}
        <div class="sched-edit-actions">
          <button class="btn btn-marching btn-sm btn-save-edit-event" data-event-id="${e.id}">Save</button>
          <button class="btn btn-ghost btn-sm btn-cancel-edit-event">Cancel</button>
        </div>
      </div>
    </div>`;
}

function renderCompResultsPanel(comps) {
  const scored = comps.filter(c => c.score != null && c.score !== '');
  let chartHTML = '';
  if (scored.length >= 2) {
    const maxScore = Math.max(...scored.map(c => parseFloat(c.score)));
    const first = parseFloat(scored[0].score);
    const last = parseFloat(scored[scored.length - 1].score);
    const trend = last >= first ? `+${(last - first).toFixed(2)} pts` : `${(last - first).toFixed(2)} pts`;
    const trendColor = last >= first ? '#2ecc71' : '#e74c3c';
    chartHTML = `
      <div class="comp-chart">
        <div class="comp-chart-bars">
          ${scored.map(c => {
            const pct = Math.round((parseFloat(c.score) / maxScore) * 100);
            return `
              <div class="comp-bar-wrap" title="${escapeHTML(c.competition_name || '')}: ${c.score}">
                <div class="comp-bar" style="height:${pct}%;background:${progressColor(pct)}"></div>
                <div class="comp-bar-label">${c.score}</div>
              </div>`;
          }).join('')}
        </div>
        <div class="comp-trend" style="color:${trendColor}">Season trend: ${trend}</div>
      </div>`;
  }
  return comps.length ? `
    ${chartHTML}
    <table class="client-table comp-table">
      <thead><tr><th>Date</th><th>Competition</th><th>Score</th><th>Placement</th></tr></thead>
      <tbody>
        ${comps.map(c => `
          <tr>
            <td>${c.competition_date ? c.competition_date.split('T')[0] : '—'}</td>
            <td>${escapeHTML(c.competition_name || '—')}</td>
            <td>${c.score != null ? c.score : '—'}</td>
            <td>${escapeHTML(c.placement || '—')}</td>
          </tr>`).join('')}
      </tbody>
    </table>` : '<div class="empty-state" style="padding:16px">No competition results yet.</div>';
}

function bindScheduleEvents(events, allComps, shows, client, showId) {
  const addBtn = document.getElementById('btn-add-event');
  const form = document.getElementById('sched-add-form');
  const typeSelect = document.getElementById('sched-type');
  const compFields = document.getElementById('sched-comp-fields');

  addBtn?.addEventListener('click', () => { form.style.display = 'block'; addBtn.style.display = 'none'; });
  document.getElementById('btn-cancel-event')?.addEventListener('click', () => {
    form.style.display = 'none'; addBtn.style.display = '';
  });

  // Show/hide competition fields based on event type
  typeSelect?.addEventListener('change', () => {
    if (compFields) compFields.style.display = typeSelect.value === 'competition' ? 'block' : 'none';
  });

  document.getElementById('btn-save-event')?.addEventListener('click', async () => {
    const sid = document.getElementById('sched-show-id').value || showId;
    const eventType = typeSelect.value;
    await api('/schedule', {
      method: 'POST',
      body: {
        show_id: parseInt(sid),
        event_type: eventType,
        event_date: document.getElementById('sched-date').value || null,
        time_start: document.getElementById('sched-time-start').value || null,
        time_end: document.getElementById('sched-time-end').value || null,
        location: document.getElementById('sched-location').value || null,
        notes: document.getElementById('sched-notes').value || null,
        competition_name: eventType === 'competition' ? document.getElementById('sched-comp-name').value : null,
        score: eventType === 'competition' ? document.getElementById('sched-comp-score').value || null : null,
        placement: eventType === 'competition' ? document.getElementById('sched-comp-placement').value : null
      }
    });
    await loadScheduleTab(shows, client);
  });

  document.querySelectorAll('.btn-edit-event').forEach(btn => {
    btn.addEventListener('click', () => {
      const row = btn.closest('.sched-event-row');
      const editPanel = row.querySelector('.sched-inline-edit');
      const isOpen = editPanel.style.display !== 'none';
      // Close any other open edit panels first
      document.querySelectorAll('.sched-inline-edit').forEach(p => p.style.display = 'none');
      editPanel.style.display = isOpen ? 'none' : 'block';
    });
  });

  document.querySelectorAll('.btn-cancel-edit-event').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.sched-inline-edit').style.display = 'none';
    });
  });

  document.querySelectorAll('.btn-save-edit-event').forEach(btn => {
    btn.addEventListener('click', async () => {
      const eventId = btn.dataset.eventId;
      const row = btn.closest('.sched-event-row');
      const body = {
        event_date: row.querySelector('.sched-edit-date').value || null,
        time_start: row.querySelector('.sched-edit-time-start').value || null,
        time_end: row.querySelector('.sched-edit-time-end').value || null,
        location: row.querySelector('.sched-edit-location').value || null,
        notes: row.querySelector('.sched-edit-notes').value || null,
      };
      const compName = row.querySelector('.sched-edit-comp-name');
      if (compName) {
        body.competition_name = compName.value || null;
        body.score = row.querySelector('.sched-edit-comp-score').value || null;
        body.placement = row.querySelector('.sched-edit-comp-placement').value || null;
      }
      await api(`/schedule/${eventId}`, { method: 'PUT', body });
      await loadScheduleTab(shows, client);
    });
  });

  document.querySelectorAll('.btn-delete-event').forEach(btn => {
    btn.addEventListener('click', async () => {
      if (!confirm('Delete this event?')) return;
      await api(`/schedule/${btn.dataset.eventId}`, { method: 'DELETE' });
      await loadScheduleTab(shows, client);
    });
  });
}

// ── Drive event handlers (registered once on document) ────────────────────
async function driveClickHandler(e) {
  const provBtn = e.target.closest('.btn-provision-drive');
  if (provBtn) {
    provBtn.disabled = true;
    provBtn.textContent = '⏳ Setting up…';
    try {
      const result = await api('/drive/provision-folder', { method: 'POST', body: { show_id: parseInt(provBtn.dataset.showId) } });
      const row = document.getElementById(`drive-row-${provBtn.dataset.showId}`);
      if (row) row.innerHTML = `<a href="${escapeHTML(result.folderUrl)}" target="_blank" rel="noopener" class="show-drive-link">📁 Open Folder</a>
        <button class="btn btn-ghost btn-sm btn-invite-collabs" data-show-id="${provBtn.dataset.showId}" data-folder-id="${escapeHTML(result.folderId)}">👥 Invite Collaborators</button>
        <button class="btn btn-ghost btn-sm btn-drive-clear" data-show-id="${provBtn.dataset.showId}" title="Clear folder link">✕ Clear Link</button>`;
    } catch (err) {
      provBtn.disabled = false;
      provBtn.textContent = '📁 Set Up Drive Folder';
      alert('Drive setup failed: ' + err.message);
    }
    return;
  }

  const pasteBtn = e.target.closest('.btn-drive-paste-save');
  if (pasteBtn) {
    const showId = pasteBtn.dataset.showId;
    const input = document.querySelector(`.drive-paste-input[data-show-id="${showId}"]`);
    const raw = (input?.value || '').trim();
    if (!raw) return;
    // Extract folder ID from URL like https://drive.google.com/drive/folders/FOLDER_ID or just the ID itself
    const match = raw.match(/\/folders\/([a-zA-Z0-9_-]{10,})/);
    const folderId = match ? match[1] : (raw.match(/^[a-zA-Z0-9_-]{10,}$/) ? raw : null);
    if (!folderId) { alert('Could not extract a folder ID from that URL. Paste the full Drive folder link.'); return; }
    const folderUrl = `https://drive.google.com/drive/folders/${folderId}`;
    pasteBtn.disabled = true;
    pasteBtn.textContent = 'Saving…';
    try {
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'drive_folder_id', value: folderId } });
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'drive_folder_url', value: folderUrl } });
      const row = document.getElementById(`drive-row-${showId}`);
      if (row) row.innerHTML = `<a href="${escapeHTML(folderUrl)}" target="_blank" rel="noopener" class="show-drive-link">📁 Open Folder</a>
        <button class="btn btn-ghost btn-sm btn-invite-collabs" data-show-id="${showId}" data-folder-id="${escapeHTML(folderId)}">👥 Invite Collaborators</button>
        <button class="btn btn-ghost btn-sm btn-drive-clear" data-show-id="${showId}" title="Clear folder link">✕ Clear Link</button>`;
    } catch (err) {
      pasteBtn.disabled = false;
      pasteBtn.textContent = 'Save';
      alert('Save failed: ' + err.message);
    }
    return;
  }

  const invBtn = e.target.closest('.btn-invite-collabs');
  if (invBtn) {
    invBtn.disabled = true;
    invBtn.textContent = '⏳ Inviting…';
    try {
      const { results } = await api('/drive/invite', { method: 'POST', body: { show_id: parseInt(invBtn.dataset.showId) } });
      const accessDiv = document.getElementById(`drive-access-${invBtn.dataset.showId}`);
      if (accessDiv) {
        const displayPerms = results
          .filter(r => r.status === 'invited' || r.status === 'already_invited')
          .map(r => ({ email: r.email, permissionId: r.permissionId, role: 'reader' }));
        renderDriveAccessPanel(accessDiv, invBtn.dataset.showId, displayPerms);
        // Show errors inline if any
        results.filter(r => r.status === 'error').forEach(r => {
          accessDiv.insertAdjacentHTML('beforeend',
            `<div class="drive-access-row"><span class="drive-access-email">${escapeHTML(r.email)}</span><span class="drive-access-error">${escapeHTML(r.message || 'error')}</span></div>`);
        });
      }
      invBtn.textContent = '✓ Collaborators Invited';
      invBtn.classList.add('btn-invite-done');
      // stays disabled — re-invite only makes sense after adding new collaborators
    } catch (err) {
      invBtn.disabled = false;
      invBtn.textContent = '👥 Invite Collaborators';
      alert('Invite failed: ' + err.message);
    }
    return;
  }

  const clearBtn = e.target.closest('.btn-drive-clear');
  if (clearBtn) {
    if (!confirm('Clear the Drive folder link from this show? This does not delete the folder in Drive.')) return;
    clearBtn.disabled = true;
    clearBtn.textContent = '⏳ Clearing…';
    const showId = clearBtn.dataset.showId;
    try {
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'drive_folder_id', value: null } });
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'drive_folder_url', value: null } });
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'drive_shares_folder_id', value: null } });
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'drive_shares_folder_url', value: null } });
      // Clear stale permission records — they're tied to the old folder and will be invalid after re-provisioning
      await api(`/drive/permissions-by-show/${showId}`, { method: 'DELETE' });
      const row = document.getElementById(`drive-row-${showId}`);
      if (row) row.innerHTML = `<button class="btn btn-ghost btn-sm btn-provision-drive" data-show-id="${showId}">📁 Generate Drive Folder</button>
        <button class="btn btn-ghost btn-sm btn-drive-rescan" data-show-id="${showId}" title="Search Drive for existing folder">🔍 Rescan</button>
        <span class="drive-paste-wrap">
          <input type="text" class="drive-paste-input" data-show-id="${showId}" placeholder="Or paste Drive folder URL…" />
          <button class="btn btn-ghost btn-sm btn-drive-paste-save" data-show-id="${showId}">Save</button>
        </span>`;
      const accessDiv = document.getElementById(`drive-access-${showId}`);
      if (accessDiv) { accessDiv.innerHTML = ''; accessDiv.style.display = 'none'; }
    } catch (err) {
      clearBtn.disabled = false;
      clearBtn.textContent = '✕ Clear Link';
      alert('Clear failed: ' + err.message);
    }
    return;
  }

  const rescanBtn = e.target.closest('.btn-drive-rescan');
  if (rescanBtn) {
    rescanBtn.disabled = true;
    rescanBtn.textContent = '⏳ Scanning…';
    const showId = rescanBtn.dataset.showId;
    try {
      const result = await api('/drive/provision-folder', { method: 'POST', body: { show_id: parseInt(showId) } });
      const row = document.getElementById(`drive-row-${showId}`);
      if (row) row.innerHTML = `<a href="${escapeHTML(result.folderUrl)}" target="_blank" rel="noopener" class="show-drive-link">📁 Open Folder</a>
        <button class="btn btn-ghost btn-sm btn-invite-collabs" data-show-id="${showId}" data-folder-id="${escapeHTML(result.folderId)}">👥 Invite Collaborators</button>
        <button class="btn btn-ghost btn-sm btn-drive-clear" data-show-id="${showId}" title="Clear folder link">✕ Clear Link</button>`;
    } catch (err) {
      rescanBtn.disabled = false;
      rescanBtn.textContent = '🔍 Rescan';
      alert('Rescan failed: ' + err.message);
    }
    return;
  }
}

async function loadPeopleBriefing(clientId, force = false) {
  const panel = document.getElementById('people-briefing-panel');
  if (!panel) return;
  try {
    const qs = force ? '?force=true' : '';
    const result = await api(`/clients/${clientId}/people-briefing${qs}`, { method: 'POST' });
    if (!result.briefing) {
      panel.innerHTML = '<div class="people-briefing-empty">Add collaborators above — David will build a people intelligence brief once there\'s someone to read.</div>';
      return;
    }
    const age = result.cached_at ? timeAgo(result.cached_at) : null;
    panel.innerHTML = `
      <div class="people-briefing-text">${escapeHTML(result.briefing)}</div>
      <div class="people-briefing-meta">${age ? `Updated ${age}` : 'Just generated'} · refreshes Monday mornings</div>
    `;
  } catch (e) {
    panel.innerHTML = `<div class="people-briefing-empty">⚠ Could not load people intelligence: ${escapeHTML(e.message)}</div>`;
  }
}

function renderDriveAccessPanel(accessDiv, showId, perms) {
  if (!perms.length) return;
  accessDiv.style.display = 'block';
  accessDiv.innerHTML = `<div class="drive-access-header">Folder Access</div>` +
    perms.map(r => `
      <div class="drive-access-row" data-permission-id="${r.permissionId || r.permission_id || ''}" data-show-id="${showId}">
        <span class="drive-access-email">${escapeHTML(r.email)}</span>
        <select class="drive-role-select" data-permission-id="${r.permissionId || r.permission_id || ''}" data-show-id="${showId}">
          <option value="reader" ${(r.role || 'reader') === 'reader' ? 'selected' : ''}>Viewer</option>
          <option value="commenter" ${r.role === 'commenter' ? 'selected' : ''}>Commenter</option>
          <option value="writer" ${r.role === 'writer' ? 'selected' : ''}>Editor</option>
        </select>
      </div>`).join('');
}

async function loadDrivePermissions(shows) {
  for (const s of shows) {
    try {
      const perms = await api(`/drive/permissions-by-show/${s.id}`);
      if (!perms.length) continue;
      const accessDiv = document.getElementById(`drive-access-${s.id}`);
      if (accessDiv) renderDriveAccessPanel(accessDiv, s.id, perms);
      // Lock the invite button — people are already in, no need to re-invite
      const invBtn = document.querySelector(`.btn-invite-collabs[data-show-id="${s.id}"]`);
      if (invBtn) {
        invBtn.textContent = '✓ Collaborators Invited';
        invBtn.disabled = true;
        invBtn.classList.add('btn-invite-done');
      }
    } catch { /* non-fatal */ }
  }
}

async function driveChangeHandler(e) {
  const roleSelect = e.target.closest('.drive-role-select');
  if (roleSelect) {
    const showId = roleSelect.dataset.showId;
    const permId = roleSelect.dataset.permissionId;
    const role = roleSelect.value;
    try {
      await api('/drive/permission', { method: 'PATCH', body: { show_id: parseInt(showId), permission_id: permId, role } });
    } catch (err) {
      alert('Permission update failed: ' + err.message);
    }
  }
}

function initDriveEvents() {
  if (window._driveEventsInit) return;
  window._driveEventsInit = true;
  document.addEventListener('click', driveClickHandler);
  document.addEventListener('change', driveChangeHandler);
}

// ── Bind Detail Events ─────────────────────────────────────────────────────
function bindDetailEvents(client, shows, allShows, notes, materials, clientYears) {
  const isMarching = client.ensemble_type === 'marching' || client.ensemble_type === 'university_band' || client.ensemble_type === 'drum_corps';

  // Year selector in detail
  document.querySelectorAll('[data-detail-year]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const yr = parseInt(btn.dataset.detailYear);
      // If year has no shows, create one
      const hasShow = allShows.some(s => parseInt(s.season_year) === yr);
      if (!hasShow) {
        // Open add show modal pre-filled with that year
        document.getElementById('show-client-id').value = client.id;
        document.getElementById('show-year').value = yr;
        document.getElementById('modal-new-show').style.display = 'flex';
        return;
      }
      state.clientDetailYear = yr;
      state.currentTab = 'shows';
      await renderClientDetail();
    });
  });

  // Add season button
  // Show title inline editor
  const showTitleEdit   = document.getElementById('btn-show-title-edit');
  const showTitleSave   = document.getElementById('btn-show-title-save');
  const showTitleCancel = document.getElementById('btn-show-title-cancel');
  const showTitleInput  = document.getElementById('show-title-input');
  const showTitleDisplay = document.getElementById('show-title-display');

  showTitleEdit?.addEventListener('click', () => {
    showTitleDisplay.style.display = 'none';
    showTitleEdit.style.display = 'none';
    showTitleInput.style.display = '';
    showTitleSave.style.display = '';
    showTitleCancel.style.display = '';
    showTitleInput.focus();
    showTitleInput.select();
  });

  showTitleCancel?.addEventListener('click', () => {
    showTitleInput.value = showTitleDisplay.textContent;
    showTitleInput.style.display = 'none';
    showTitleSave.style.display = 'none';
    showTitleCancel.style.display = 'none';
    showTitleDisplay.style.display = '';
    showTitleEdit.style.display = '';
  });

  showTitleSave?.addEventListener('click', async () => {
    const newTitle = showTitleInput.value.trim();
    const show = shows[0];
    if (!show) return;
    try {
      await api(`/shows/${show.id}/field`, { method: 'PATCH', body: { field: 'title', value: newTitle } });
      showTitleDisplay.textContent = newTitle;
      // Update local state so dashboard reflects it
      const s = state.allShows.find(s => s.id === show.id);
      if (s) s.title = newTitle;
    } catch (e) {
      alert('Could not save show title: ' + e.message);
    }
    showTitleInput.style.display = 'none';
    showTitleSave.style.display = 'none';
    showTitleCancel.style.display = 'none';
    showTitleDisplay.style.display = '';
    showTitleEdit.style.display = '';
  });

  showTitleInput?.addEventListener('keydown', e => {
    if (e.key === 'Enter') showTitleSave?.click();
    if (e.key === 'Escape') showTitleCancel?.click();
  });

  document.getElementById('btn-add-year-show')?.addEventListener('click', async () => {
    const nextYear = Math.max(...clientYears) + 1;
    document.getElementById('show-client-id').value = client.id;
    document.getElementById('show-year').value = nextYear;
    // Pre-fill from latest season defaults
    try {
      const defaults = await api(`/shows/client/${client.id}/latest-season-defaults`);
      if (defaults.fee_cents) {
        const feeEl = document.getElementById('show-fee');
        if (feeEl) feeEl.value = (defaults.fee_cents / 100).toString();
      }
      if (defaults.role) {
        const defaultRoles = defaults.role.split(',').map(r => r.trim()).filter(Boolean);
        document.querySelectorAll('#show-role-group input[type="checkbox"]').forEach(cb => {
          cb.checked = defaultRoles.includes(cb.value);
        });
      }
      const noContractEl = document.getElementById('show-no-contract');
      if (noContractEl) noContractEl.checked = !!defaults.no_contract;
      const noInvoiceEl = document.getElementById('show-no-invoice');
      if (noInvoiceEl) noInvoiceEl.checked = !!defaults.no_invoice;
    } catch { /* non-fatal */ }
    document.getElementById('modal-new-show').style.display = 'flex';
  });

  // Assistant Brain briefing button
  async function runBriefing(forceRefresh = false) {
    const panel = document.getElementById('briefing-panel');
    const btn = document.getElementById('btn-briefing');
    if (!panel || !btn) return;
    btn.disabled = true;
    btn.textContent = 'Thinking...';
    panel.innerHTML = '<div class="briefing-loading">⟳ David is thinking...</div>';
    panel.classList.add('briefing-has-content');
    try {
      const url = `/clients/${client.id}/briefing${forceRefresh ? '?refresh=true' : ''}`;
      const result = await api(url, { method: 'POST' });
      const text = result.briefing || '';
      panel.innerHTML = `
        <div class="david-panel-header">
          <img src="David_Thorne_2.png" class="david-avatar-sm" alt="David Thorne" />
          <span class="briefing-label">David Thorne — The Tactician</span>
        </div>
        <div class="briefing-text">${escapeHTML(text)}</div>
        <div class="briefing-meta">Generated just now · <a href="#" class="briefing-refresh">Refresh</a></div>
      `;
      // Update local state so re-renders show cached
      const idx = state.clients.findIndex(c => c.id === client.id);
      if (idx >= 0) { state.clients[idx].ai_summary = text; state.clients[idx].ai_summary_at = new Date().toISOString(); }
      panel.querySelector('.briefing-refresh')?.addEventListener('click', e => { e.preventDefault(); runBriefing(true); });
    } catch (e) {
      panel.innerHTML = `<div class="briefing-error">⚠ ${escapeHTML(e.message)}</div>`;
    } finally {
      btn.disabled = false;
      btn.textContent = 'Ask David Thorne';
    }
  }

  document.getElementById('btn-briefing')?.addEventListener('click', () => runBriefing(false));
  document.querySelector('.briefing-refresh')?.addEventListener('click', e => { e.preventDefault(); runBriefing(true); });


  // Yeet button — delete season or full client
  document.getElementById('btn-yeet-client')?.addEventListener('click', function() {
    const btn = this;
    if (btn.dataset.yeeting) return;
    btn.dataset.yeeting = '1';
    btn.disabled = true;
    btn.textContent = 'Yeeting from this realm...';
    setTimeout(() => {
      btn.disabled = false;
      delete btn.dataset.yeeting;
      openYeetModal(client, state.clientDetailYear);
    }, 3000);
  });

  // Tab switching
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      // Auto-save any unsaved collaborator rows before navigating away
      if (state.currentTab === 'collaborators') {
        const tbody = document.getElementById('collaborators-body');
        if (tbody) {
          const dirtyRows = Array.from(tbody.querySelectorAll('tr')).filter(tr => {
            const isEditing = !tr.querySelector('.collab-name')?.disabled;
            const hasContent = (tr.querySelector('.collab-name')?.value.trim() ||
                                tr.querySelector('.collab-role')?.value ||
                                tr.querySelector('.collab-phone')?.value.trim() ||
                                tr.querySelector('.collab-email')?.value.trim());
            return isEditing && hasContent;
          });
          for (const tr of dirtyRows) {
            await saveCollaboratorRow(tr, client.id);
          }
        }
      }

      document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.tab-content').forEach(t => t.classList.remove('active'));
      btn.classList.add('active');
      state.currentTab = btn.dataset.tab;
      sessionStorage.setItem('wmmNavState', JSON.stringify({ view: 'client-detail', clientId: state.currentClientId, tab: state.currentTab }));
      const tabEl = document.getElementById(`tab-${btn.dataset.tab}`);
      if (tabEl) tabEl.classList.add('active');
      if (btn.dataset.tab === 'schedule' && isMarching) {
        await loadScheduleTab(shows, client);
      }
      if (btn.dataset.tab === 'copyright') {
        await loadCopyrightTab(client.id);
      }
      if (btn.dataset.tab === 'notes') {
        loadNotesSummary(client.id);
      }
      if (btn.dataset.tab === 'collaborators') {
        loadCollaboratorsTab(client.id, state.clientDetailYear);
      }
      if (btn.dataset.tab === 'materials') {
        bindFindSourcesBtn(client.id);
      }
      if (btn.dataset.tab === 'finances') {
        loadFinancesTab(client, shows[0] || null);
      }
      if (btn.dataset.tab === 'results') {
        loadResultsTab(client.id);
      }
      if (btn.dataset.tab === 'client-chat' && isMarching) {
        loadClientChatTab(client, shows);
      }
    });
  });

  // Load milestones for all shows
  shows.forEach(s => {
    const parts = Array.isArray(s.ensemble_parts) ? s.ensemble_parts
      : (s.ensemble_parts ? JSON.parse(s.ensemble_parts) : []);
    loadMilestones(s.id, parts);
  });

  // Role checkboxes
  document.querySelectorAll('.role-checkbox-group').forEach(group => {
    group.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', async () => {
        const showId = parseInt(group.dataset.showId);
        const checked = [...group.querySelectorAll('input:checked')].map(c => c.value);
        const value = checked.length ? checked.join(',') : null;
        await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'role', value } });
        const idx = state.allShows.findIndex(s => s.id === showId);
        if (idx >= 0) state.allShows[idx].role = value;
        patchClientCard(client.id, { role: value });
      });
    });
  });

  // ── Band Director Change inline editor ──────────────────────────────────
  const btnDirectorChange = document.getElementById('btn-director-change');
  const dirDisplay        = document.getElementById('director-display');
  const dirEditForm       = document.getElementById('director-edit-form');

  function openDirectorEdit() {
    dirDisplay.style.display  = 'none';
    dirEditForm.style.display = 'flex';
    document.getElementById('director-edit-name').focus();
  }
  function closeDirectorEdit() {
    dirDisplay.style.display  = '';
    dirEditForm.style.display = 'none';
  }

  btnDirectorChange?.addEventListener('click', openDirectorEdit);

  // ── Director name autocomplete ──────────────────────────────────────────────
  let _dirAcTimer = null;
  let _dirAcDropdown = null;

  const removeDirDropdown = () => {
    if (_dirAcDropdown) { _dirAcDropdown.remove(); _dirAcDropdown = null; }
  };

  const dirNameInput = document.getElementById('director-edit-name');

  const handleDirInput = function() {
    const q = this.value.trim();
    clearTimeout(_dirAcTimer);
    removeDirDropdown();
    if (q.length < 2) return;
    const inp = this;
    _dirAcTimer = setTimeout(async () => {
      let results;
      try {
        results = await api(`/collaborators/search?q=${encodeURIComponent(q)}`);
      } catch { return; }
      if (!results || !results.length) return;

      _dirAcDropdown = document.createElement('div');
      _dirAcDropdown.className = 'collab-ac-dropdown';
      results.forEach(r => {
        const item = document.createElement('div');
        item.className = 'collab-ac-item';
        item.innerHTML =
          `<span class="collab-ac-name">${escapeHTML(r.name)}</span>` +
          `<span class="collab-ac-meta">${r.clients ? escapeHTML(r.clients) : ''}</span>`;
        item.addEventListener('mousedown', (e) => {
          e.preventDefault();
          document.getElementById('director-edit-name').value  = r.name  || '';
          document.getElementById('director-edit-email').value = r.email || '';
          document.getElementById('director-edit-phone').value = formatPhone(r.phone || '');
          removeDirDropdown();
          document.getElementById('director-edit-email').focus();
        });
        _dirAcDropdown.appendChild(item);
      });

      // Re-measure after form is fully visible
      requestAnimationFrame(() => {
        const rect = inp.getBoundingClientRect();
        if (!_dirAcDropdown) return;
        _dirAcDropdown.style.position = 'fixed';
        _dirAcDropdown.style.top  = (rect.bottom + 2) + 'px';
        _dirAcDropdown.style.left = rect.left + 'px';
        _dirAcDropdown.style.width = Math.max(rect.width, 260) + 'px';
        document.body.appendChild(_dirAcDropdown);
      });
    }, 280);
  };

  if (dirNameInput) {
    dirNameInput.addEventListener('input', handleDirInput);
    dirNameInput.addEventListener('keyup', handleDirInput);
    dirNameInput.addEventListener('blur', () => setTimeout(removeDirDropdown, 150));
  }

  document.getElementById('btn-director-cancel')?.addEventListener('click', closeDirectorEdit);

  document.getElementById('btn-director-save')?.addEventListener('click', async () => {
    const showId = shows[0]?.id;
    if (!showId) return;
    const newName  = document.getElementById('director-edit-name').value.trim()  || null;
    const newEmail = document.getElementById('director-edit-email').value.trim() || null;
    const newPhone = document.getElementById('director-edit-phone').value.trim() || null;

    await Promise.all([
      api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'director_name',  value: newName  } }),
      api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'director_email', value: newEmail } }),
      api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'director_phone', value: newPhone } })
    ]);

    // Update local state
    const idx = state.allShows.findIndex(s => s.id === showId);
    if (idx >= 0) Object.assign(state.allShows[idx], { director_name: newName, director_email: newEmail, director_phone: newPhone });
    if (shows[0]) Object.assign(shows[0], { director_name: newName, director_email: newEmail, director_phone: newPhone });

    // Refresh display without full re-render
    const dirName  = newName  || client.name  || '';
    const dirEmail = newEmail || client.email || '';
    const dirPhone = newPhone || client.phone || '';
    const nameSpan = document.getElementById('director-name-display');
    if (nameSpan) nameSpan.textContent = dirName;
    const contactEl = document.getElementById('director-contact-display');
    if (contactEl) contactEl.innerHTML =
      `${dirEmail ? `<a href="mailto:${dirEmail}">✉ ${escapeHTML(dirEmail)}</a>` : ''}
       ${dirPhone ? `<a href="#" data-phone="${escapeHTML(dirPhone)}">📞 ${escapeHTML(formatPhone(dirPhone))}</a>` : ''}`;

    closeDirectorEdit();
  });

  // Design status dropdown
  document.querySelectorAll('.design-status-select').forEach(sel => {
    sel.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(sel.dataset.showId));
      if (!show) return;
      show.design_status = sel.value;
      await saveShow(show);
      // Also update allShows and client card
      const idx = state.allShows.findIndex(s => s.id === show.id);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], design_status: show.design_status };
      patchClientCard(client.id, { design_status: show.design_status });
    });
  });

  // Contract/payment checkboxes — includes no_contract and no_invoice overrides
  document.querySelectorAll('.show-checkbox').forEach(cb => {
    cb.addEventListener('change', async () => {
      const showId = parseInt(cb.dataset.showId);
      const field = cb.dataset.field;
      const value = cb.checked;
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field, value } });
      const show = shows.find(s => s.id === showId);
      if (show) show[field] = value;
      const idx = state.allShows.findIndex(s => s.id === showId);
      if (idx >= 0) state.allShows[idx][field] = value;
      patchClientCard(client.id, { [field]: value });
      // Dynamically show/hide contract+invoice rows when override flags change
      if (field === 'no_contract' || field === 'no_invoice') {
        const s2 = shows.find(s => s.id === showId) || {};
        const checksRow = document.getElementById(`contract-payment-checks-${showId}`);
        const descWrap = document.getElementById(`invoice-desc-wrap-${showId}`);
        if (checksRow) checksRow.style.display = (s2.no_contract && s2.no_invoice) ? 'none' : '';
        if (descWrap) descWrap.style.display = s2.no_invoice ? 'none' : '';
      }
    });
  });

  // Ensemble part checkboxes
  document.querySelectorAll('.part-checkbox').forEach(cb => {
    cb.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(cb.dataset.showId));
      if (!show) return;
      const parts = Array.isArray(show.ensemble_parts) ? [...show.ensemble_parts]
        : (show.ensemble_parts ? JSON.parse(show.ensemble_parts) : []);
      if (cb.checked && !parts.includes(cb.value)) parts.push(cb.value);
      if (!cb.checked) parts.splice(parts.indexOf(cb.value), 1);
      show.ensemble_parts = parts;
      await saveShow(show);
      patchClientCard(client.id, { ensemble_parts: parts });
      // If sound_design toggled, reload milestones to show/hide that row
      if (cb.value === 'sound_design') {
        loadMilestones(show.id, parts);
      }
    });
  });

  // Fee input
  document.querySelectorAll('.fee-input').forEach(input => {
    input.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(input.dataset.showId));
      if (!show) return;
      show.fee_cents = Math.round(parseFloat(input.value || 0) * 100);
      await saveShow(show);
      patchClientCard(client.id, { fee_cents: show.fee_cents });
    });
  });

  // Invoice description
  document.querySelectorAll('.invoice-desc-input').forEach(input => {
    input.addEventListener('change', async () => {
      const showId = parseInt(input.dataset.showId);
      await api(`/shows/${showId}/field`, { method: 'PATCH', body: { field: 'invoice_description', value: input.value || null } });
      const idx = state.allShows.findIndex(s => s.id === showId);
      if (idx >= 0) state.allShows[idx].invoice_description = input.value || null;
    });
  });

  // Season year field
  document.querySelectorAll('[data-field="season_year"]').forEach(el => {
    el.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(el.dataset.showId));
      if (!show) return;
      show.season_year = el.value;
      await saveShow(show);
    });
  });

  // Deliver By date
  document.querySelectorAll('.deliver-by-input').forEach(input => {
    input.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(input.dataset.showId));
      if (!show) return;
      show.deliver_by_date = input.value || null;
      await saveShow(show);
      const idx = state.allShows.findIndex(s => s.id === show.id);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], deliver_by_date: show.deliver_by_date };
    });
  });

  // Ready to Write date
  document.querySelectorAll('.ready-to-write-input').forEach(input => {
    input.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(input.dataset.showId));
      if (!show) return;
      show.ready_to_write_date = input.value || null;
      await saveShow(show);
      const idx = state.allShows.findIndex(s => s.id === show.id);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], ready_to_write_date: show.ready_to_write_date };
    });
  });

  // Project description (composition)
  document.querySelectorAll('.project-description-input').forEach(textarea => {
    textarea.addEventListener('change', async () => {
      const show = shows.find(s => s.id === parseInt(textarea.dataset.showId));
      if (!show) return;
      show.project_description = textarea.value;
      await saveShow(show);
      const idx = state.allShows.findIndex(s => s.id === show.id);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], project_description: show.project_description };
    });
  });

  // Generate schedule button
  document.querySelectorAll('.btn-gen-schedule-pill').forEach(btn => {
    btn.addEventListener('click', async () => {
      const showId = parseInt(btn.dataset.showId);
      const show = shows.find(s => s.id === showId);
      if (!show) return;
      const deliverByInput = document.querySelector(`.deliver-by-input[data-show-id="${showId}"]`);
      const readyInput = document.querySelector(`.ready-to-write-input[data-show-id="${showId}"]`);
      const deliverBy = deliverByInput?.value || show.deliver_by_date;
      if (!deliverBy) { alert('Set a Deliver By date first.'); return; }
      btn.textContent = '...';
      const showParts = Array.isArray(show.ensemble_parts) ? show.ensemble_parts
        : (show.ensemble_parts ? JSON.parse(show.ensemble_parts) : []);
      await api(`/shows/${showId}/milestones/generate`, {
        method: 'POST',
        body: {
          deliver_by_date: deliverBy,
          ready_to_write_date: readyInput?.value || show.ready_to_write_date || null,
          show_type: show.show_type || 'marching_band',
          ensemble_parts: showParts
        }
      });
      await loadMilestones(showId, showParts);
      btn.textContent = '↻ Generate Schedule';
    });
  });

  // Add show button
  document.getElementById('btn-add-show')?.addEventListener('click', () => {
    document.getElementById('show-client-id').value = client.id;
    document.getElementById('show-year').value = state.clientDetailYear;
    document.getElementById('modal-new-show').style.display = 'flex';
  });

  // Duration slider
  document.querySelectorAll('.duration-input').forEach(input => {
    if (input.dataset.isDuration === 'true') {
      input.addEventListener('input', () => {
        const val = parseInt(input.value);
        document.querySelector(`.duration-display-${input.dataset.showId}`).textContent = secsToMMSS(val);
      });
    }
    input.addEventListener('change', async () => {
      const showId = parseInt(input.dataset.showId);
      const show = shows.find(s => s.id === showId);
      if (!show) return;
      const newDur = input.dataset.isDuration === 'true'
        ? parseInt(input.value)
        : mmssToSecs(input.value);
      show.duration_seconds = newDur;
      if (!show.written_seconds && show.percent_complete) {
        show.written_seconds = Math.round((show.percent_complete / 100) * newDur);
      }
      show.percent_complete = newDur > 0 ? Math.round((show.written_seconds / newDur) * 100) : show.percent_complete;
      await api(`/shows/${showId}`, { method: 'PUT', body: show });
      const idx = state.allShows.findIndex(s => s.id === showId);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], ...show };
      updateMasterBar();
      await renderClientDetail();
    });
  });

  // Progress sliders
  document.querySelectorAll('.progress-slider').forEach(slider => {
    const initDur = parseInt(slider.dataset.duration) || 0;
    const initVal = parseInt(slider.value);
    const initPct = initDur > 0 ? Math.round((initVal / initDur) * 100) : initVal;
    const initBar = document.querySelector(`.pct-bar-${slider.dataset.showId}`);
    if (initBar) applyProgressColor(initBar, initPct);

    slider.addEventListener('input', () => {
      const sid = slider.dataset.showId;
      const dur = parseInt(slider.dataset.duration) || 0;
      const val = parseInt(slider.value);
      const pct = dur > 0 ? Math.round((val / dur) * 100) : val;
      document.querySelector(`.pct-display-${sid}`).textContent = `${pct}%`;
      const bar = document.querySelector(`.pct-bar-${sid}`);
      bar.style.width = `${pct}%`;
      applyProgressColor(bar, pct);
      if (dur > 0) {
        document.querySelector(`.progress-time-display-${sid}`).textContent =
          `${secsToMMSS(val)} / ${secsToMMSS(dur)}`;
      }
    });

    slider.addEventListener('change', async () => {
      const showId = parseInt(slider.dataset.showId);
      const show = shows.find(s => s.id === showId);
      if (!show) return;
      const dur = parseInt(slider.dataset.duration) || 0;
      const val = parseInt(slider.value);
      if (dur > 0) {
        show.written_seconds = val;
        show.percent_complete = Math.round((val / dur) * 100);
      } else {
        show.percent_complete = val;
      }
      await api(`/shows/${showId}`, { method: 'PUT', body: show });
      const idx = state.allShows.findIndex(s => s.id === showId);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], ...show };
      updateMasterBar();
    });
  });

  // Notes
  document.getElementById('btn-toggle-composer')?.addEventListener('click', () => {
    document.getElementById('note-composer').classList.toggle('open');
    document.getElementById('note-body-input')?.focus();
  });
  document.getElementById('btn-cancel-note')?.addEventListener('click', () => {
    document.getElementById('note-composer').classList.remove('open');
    document.getElementById('note-body-input').value = '';
  });
  document.getElementById('btn-save-note')?.addEventListener('click', async () => {
    const body = document.getElementById('note-body-input').value.trim();
    if (!body) return;
    const note = await api(`/clients/${client.id}/notes`, { method: 'POST', body: { body } });
    notes.unshift(note);
    document.getElementById('notes-list').innerHTML = notes.map(noteHTML).join('');
    document.getElementById('note-composer').classList.remove('open');
    document.getElementById('note-body-input').value = '';
    bindNoteEvents(client, notes);
  });

  bindNoteEvents(client, notes);
  notes.forEach(n => loadAttachments(n.id));

  // Materials
  document.getElementById('btn-add-material')?.addEventListener('click', () => {
    document.getElementById('material-client-id').value = client.id;
    document.getElementById('modal-new-material').style.display = 'flex';
  });

  document.getElementById('btn-upload-pdf')?.addEventListener('click', () => {
    document.getElementById('pdf-upload-input')?.click();
  });

  document.getElementById('pdf-upload-input')?.addEventListener('change', async e => {
    const file = e.target.files?.[0];
    if (!file) return;
    const btn = document.getElementById('btn-upload-pdf');
    btn.disabled = true;
    btn.textContent = 'Uploading…';
    try {
      const form = new FormData();
      form.append('file', file);
      form.append('label', file.name.replace(/\.pdf$/i, ''));
      if (document.getElementById('chk-master-repo')?.checked) {
        form.append('add_to_repo', 'true');
      }
      const res = await fetch(`${API}/clients/${client.id}/source-materials/upload`, {
        method: 'POST',
        body: form
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      await renderClientDetail();
    } catch (err) {
      alert('Upload failed: ' + err.message);
      btn.disabled = false;
      btn.textContent = '↑ Upload PDF';
    }
    e.target.value = '';
  });

  document.querySelectorAll('.btn-delete-material').forEach(btn => {
    btn.addEventListener('click', async () => {
      await api(`/clients/source-materials/${btn.dataset.materialId}`, { method: 'DELETE' });
      btn.closest('.material-item').remove();
    });
  });

  // Circuit inline save
  document.getElementById('btn-save-circuit')?.addEventListener('click', async () => {
    const val = document.getElementById('circuit-input')?.value.trim() || null;
    try {
      const updated = await api(`/clients/${client.id}/circuit`, { method: 'PATCH', body: { primary_circuit: val } });
      client.primary_circuit = updated.primary_circuit;
      const idx = state.clients.findIndex(c => c.id === client.id);
      if (idx >= 0) state.clients[idx].primary_circuit = updated.primary_circuit;
      const btn = document.getElementById('btn-save-circuit');
      if (btn) { btn.textContent = '✓ Saved'; setTimeout(() => { btn.textContent = '✓'; }, 1500); }
    } catch (err) { alert('Error saving circuit: ' + err.message); }
  });

  // Edit client
  document.getElementById('btn-edit-client')?.addEventListener('click', () => openEditClientModal(client));

  // Find Band Website (shown when no website is set)
  document.querySelector('.btn-find-website')?.addEventListener('click', async function() {
    const btn = this;
    btn.textContent = 'Searching…';
    btn.disabled = true;
    try {
      const result = await api(`/clients/${client.id}/find-band-website`, { method: 'POST' });
      const row = document.getElementById('client-website-row');
      if (result.band_website) {
        client.band_website = result.band_website;
        const idx = state.clients.findIndex(c => c.id === client.id);
        if (idx >= 0) state.clients[idx].band_website = result.band_website;
        if (row) row.innerHTML = `<a href="${escapeHTML(result.band_website)}" target="_blank" rel="noopener" class="band-website-link">🌐 Band Website</a>
          <button class="btn-website-clear" title="Clear website" data-client-id="${client.id}">✕</button>`;
        bindWebsiteClearBtn(client);
      } else {
        btn.textContent = 'Not found — edit to add manually';
        btn.disabled = false;
      }
    } catch (err) {
      btn.textContent = 'Search failed';
      btn.disabled = false;
    }
  });

  bindWebsiteClearBtn(client);

  // Contract & Invoice
  const yearShow = shows[0] || null; // current detail-year show
  document.getElementById('btn-open-contract')?.addEventListener('click', () => openContractModal(client, yearShow));
  document.getElementById('btn-open-invoice')?.addEventListener('click', () => openInvoiceModal(client, yearShow));

  // Drive events — register once globally
  initDriveEvents();

  // Highlight note if navigating from a task link
  if (state.highlightNoteId) {
    const noteIdToHighlight = state.highlightNoteId;
    state.highlightNoteId = null;
    requestAnimationFrame(() => {
      const el = document.querySelector(`.note-item[data-note-id="${noteIdToHighlight}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.classList.add('note-highlight');
        setTimeout(() => el.classList.remove('note-highlight'), 2000);
      }
    });
  }
}

function bindNoteEvents(client, notes) {
  document.querySelectorAll('.btn-edit-note').forEach(btn => {
    btn.addEventListener('click', () => {
      const noteId = parseInt(btn.dataset.noteId);
      const noteEl = btn.closest('.note-item');
      const bodyEl = noteEl.querySelector('.note-body-display');
      const current = bodyEl.textContent;
      bodyEl.innerHTML = `
        <div class="inline-edit-form">
          <textarea class="note-edit-area">${escapeHTML(current)}</textarea>
          <div class="note-edit-actions">
            <button class="btn btn-ghost btn-sm btn-cancel-edit">Cancel</button>
            <button class="btn btn-primary btn-sm btn-save-edit" data-note-id="${noteId}">Save</button>
          </div>
        </div>`;
      bodyEl.querySelector('.btn-cancel-edit').addEventListener('click', () => {
        bodyEl.className = 'note-body-display';
        bodyEl.innerHTML = escapeHTML(current);
      });
      bodyEl.querySelector('.btn-save-edit').addEventListener('click', async () => {
        const newBody = bodyEl.querySelector('textarea').value.trim();
        if (!newBody) return;
        const updated = await api(`/notes/${noteId}`, { method: 'PUT', body: { body: newBody } });
        const idx = notes.findIndex(n => n.id === noteId);
        if (idx >= 0) notes[idx] = updated;
        bodyEl.className = 'note-body-display';
        bodyEl.innerHTML = escapeHTML(newBody);
      });
    });
  });

  document.querySelectorAll('.attach-input').forEach(input => {
    input.addEventListener('change', async () => {
      const noteId = input.dataset.noteId;
      const file = input.files[0];
      if (!file) return;
      const form = new FormData();
      form.append('file', file);
      const res = await fetch(`${API}/notes/${noteId}/attachments`, { method: 'POST', body: form });
      const att = await res.json();
      addAttachmentChip(noteId, att);
      input.value = '';
    });
  });

  document.querySelectorAll('.note-revisions-link').forEach(link => {
    link.addEventListener('click', async () => {
      const revisions = await api(`/notes/${link.dataset.noteId}/revisions`);
      if (!revisions.length) { alert('No revision history for this note.'); return; }
      alert('Revisions:\n\n' + revisions.map(r => `[${formatDate(r.revised_at)}]\n${r.body}`).join('\n\n---\n\n'));
    });
  });

  document.querySelectorAll('.btn-note-expand').forEach(btn => {
    btn.addEventListener('click', () => {
      const noteId = btn.dataset.noteId;
      const bodyEl = document.querySelector(`.note-item[data-note-id="${noteId}"] .note-body-display`);
      if (!bodyEl) return;
      const collapsed = bodyEl.dataset.collapsed === 'true';
      if (collapsed) {
        bodyEl.innerHTML = formatNoteBody(bodyEl.dataset.full);
        bodyEl.dataset.collapsed = 'false';
        btn.textContent = '▲ Show less';
      } else {
        const preview = bodyEl.dataset.full.slice(0, NOTE_COLLAPSE_THRESHOLD) + '…';
        bodyEl.innerHTML = formatNoteBody(preview);
        bodyEl.dataset.collapsed = 'true';
        btn.textContent = '▼ Show more';
      }
    });
  });

  document.querySelectorAll('.btn-add-task-note').forEach(btn => {
    btn.addEventListener('click', async () => {
      const client = state.clients.find(c => c.id === state.currentClientId);
      const clientName = client?.org_name || client?.name || '';
      btn.disabled = true;
      btn.textContent = '⏳';
      try {
        // Ask Claude for a concise task title
        let summary;
        try {
          const ai = await api('/admin-tasks/ai-title', { method: 'POST', body: {
            body: btn.dataset.body,
            source: btn.dataset.source,
            client_name: clientName
          }});
          summary = `[${clientName}] ${ai.title}`;
        } catch {
          // Fallback to raw preview if AI call fails
          summary = `[${clientName}] ${btn.dataset.source}: ${btn.dataset.body.slice(0, 70)}`;
        }
        await api('/admin-tasks', { method: 'POST', body: {
          summary,
          note_id: parseInt(btn.dataset.noteId),
          client_id: state.currentClientId
        }});
        btn.textContent = '✓ Added';
        loadAdminTasks();
      } catch (err) {
        btn.disabled = false;
        btn.textContent = '📋 Task';
        alert('Could not add task: ' + err.message);
      }
    });
  });

  document.querySelectorAll('.btn-dismiss-note').forEach(btn => {
    btn.addEventListener('click', async () => {
      if (!confirm('Hide this message from the Notes tab? It will no longer appear on this client card.')) return;
      try {
        await api(`/notes/${btn.dataset.noteId}/dismiss`, { method: 'PATCH' });
        btn.closest('.note-item').remove();
      } catch (err) {
        alert('Could not dismiss: ' + err.message);
      }
    });
  });
}

async function loadMilestones(showId, ensembleParts = []) {
  const container = document.getElementById(`milestones-${showId}`);
  if (!container) return;
  let milestones = await api(`/shows/${showId}/milestones`);

  // Hide Sound Design milestone if sound_design is not an ensemble part
  if (!ensembleParts.includes('sound_design')) {
    milestones = milestones.filter(m => m.milestone_name !== 'Sound Design');
  }

  if (!milestones.length) {
    container.innerHTML = '<div style="font-size:13px;color:var(--text-muted);padding:4px 0">No movements yet — set Deliver By date and click Generate Schedule.</div>';
    return;
  }

  container.innerHTML = milestones.map(m => `
    <div class="milestone-row ${m.completed ? 'milestone-done' : ''}">
      <label class="check-label">
        <input type="checkbox" class="milestone-checkbox" data-milestone-id="${m.id}" ${m.completed ? 'checked' : ''} />
        <span class="milestone-name">${escapeHTML(m.milestone_name)}</span>
      </label>
      <span class="milestone-date ${dueDateClass(m.due_date)}">${formatDate(m.due_date)}</span>
    </div>`).join('');

  container.querySelectorAll('.milestone-checkbox').forEach(cb => {
    cb.addEventListener('change', async () => {
      await api(`/shows/milestones/${cb.dataset.milestoneId}`, {
        method: 'PUT',
        body: { completed: cb.checked }
      });
      const row = cb.closest('.milestone-row');
      row.classList.toggle('milestone-done', cb.checked);
      state.clients = await api('/clients');
      renderDashboard();
    });
  });
}

async function loadAttachments(noteId) {
  try {
    const atts = await api(`/attachments/note/${noteId}`);
    atts.forEach(a => addAttachmentChip(noteId, a));
  } catch (e) {}
}

function addAttachmentChip(noteId, att) {
  const container = document.getElementById(`attachments-${noteId}`);
  if (!container) return;

  const wrap = document.createElement('span');
  wrap.className = 'attachment-wrap';

  const chip = document.createElement('a');
  chip.className = 'attachment-chip';
  chip.href = att.drive_url || `/api/v1/attachments/${att.id}/file`;
  chip.target = '_blank';
  chip.rel = 'noopener';
  const icon = att.drive_url ? '🔗' :
               att.file_type === 'application/pdf' ? '📄' :
               att.file_name?.endsWith('.docx') ? '📝' : '📎';
  chip.textContent = `${icon} ${att.file_name}`;
  chip.title = att.drive_url ? 'Stored in Google Drive' :
               att.in_db ? 'Stored in database' : 'Stored on disk only';
  wrap.appendChild(chip);

  if (att.drive_url) {
    const saved = document.createElement('span');
    saved.className = 'att-saved-badge';
    saved.textContent = '✅ Saved';
    wrap.appendChild(saved);
  } else if (att.in_db) {
    const driveBtn = document.createElement('button');
    driveBtn.className = 'btn-inline btn-file-drive';
    driveBtn.textContent = '📁 Drive';
    driveBtn.title = "File to client's Google Drive folder";
    driveBtn.onclick = () => fileToDrive(att.id, driveBtn, chip, wrap);
    wrap.appendChild(driveBtn);
  }

  container.appendChild(wrap);
}

async function fileToDrive(attId, btn, chip, wrap) {
  btn.disabled = true;
  btn.textContent = '⏳';
  try {
    const show = state.allShows.find(s =>
      s.client_id === state.currentClientId &&
      parseInt(s.season_year) === state.clientDetailYear
    );
    const body = show?.season_year ? { season_year: show.season_year } : {};
    const result = await api(`/attachments/${attId}/file-to-drive`, { method: 'POST', body });
    chip.href = result.drive_url;
    chip.title = 'Stored in Google Drive';
    chip.textContent = '🔗 ' + chip.textContent.replace(/^[^\s]+\s/, '');
    btn.remove();
    const saved = document.createElement('span');
    saved.className = 'att-saved-badge';
    saved.textContent = '✅ Saved';
    wrap.appendChild(saved);
  } catch (err) {
    btn.disabled = false;
    btn.textContent = '📁 Drive';
    alert('Drive upload failed: ' + err.message);
  }
}

async function markContractSigned(btn) {
  const show = state.allShows.find(s =>
    s.client_id === state.currentClientId &&
    parseInt(s.season_year) === state.clientDetailYear
  );
  if (!show) { alert('No show found for this client / year.'); return; }
  if (show.contract_signed) { alert('Contract is already marked as signed.'); return; }
  if (!confirm(`Mark contract as signed for ${show.show_title || 'this show'}?`)) return;
  btn.disabled = true;
  try {
    await api(`/shows/${show.id}/field`, { method: 'PATCH', body: { field: 'contract_signed', value: true } });
    // Fire automation trigger (non-blocking)
    fetch('/api/automations/trigger', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: 'contract_signed', client_id: state.currentClientId, show_id: show.id })
    }).catch(err => console.warn('Automation trigger failed (non-blocking):', err));
    // Update local state and the checkbox in the Shows tab
    const idx = state.allShows.findIndex(s => s.id === show.id);
    if (idx >= 0) state.allShows[idx].contract_signed = true;
    const cb = document.querySelector(`.show-checkbox[data-show-id="${show.id}"][data-field="contract_signed"]`);
    if (cb) cb.checked = true;
    btn.textContent = '✅ Signed';
    btn.style.opacity = '0.5';
  } catch (err) {
    btn.disabled = false;
    alert('Failed to mark signed: ' + err.message);
  }
}

// ── Collaborators ──────────────────────────────────────────────────────────

const COLLABORATOR_ROLES = [
  'Assistant Director',
  'Arranger',
  'Percussion Writer',
  'Drill Writer',
  'Sound Designer',
  'Color Guard',
  'Instructor'
];

function formatPhone(raw) {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1,4)}) ${digits.slice(4,7)}-${digits.slice(7)}`;
  }
  return raw; // return as-is if not a standard US number
}

function roleOptions(selected) {
  return `<option value="">— Role —</option>` +
    COLLABORATOR_ROLES.map(r =>
      `<option value="${r}" ${selected === r ? 'selected' : ''}>${r}</option>`
    ).join('');
}

async function loadCollaboratorsTab(clientId, year) {
  const el = document.getElementById('tab-collaborators');
  if (!el) return;

  let rows = [];
  try {
    const qs = year ? `?year=${year}` : '';
    rows = await api(`/collaborators/client/${clientId}${qs}`);
  } catch (e) {}

  renderCollaboratorsTab(clientId, rows, year);
}

function renderCollaboratorsTab(clientId, rows, year) {
  const el = document.getElementById('tab-collaborators');
  if (!el) return;

  el.innerHTML = `
    <div class="collaborators-wrap">
      <div class="collab-toolbar">
        <button class="btn btn-ghost btn-sm" id="btn-collab-from-email">📧 Pick from Emails</button>
      </div>
      <div id="collab-email-suggestions" style="display:none"></div>
      <table class="collaborators-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Phone</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody id="collaborators-body"></tbody>
      </table>
      <hr class="collab-intel-divider">
      <div class="david-panel-header people-briefing-header">
        <img src="David_Thorne_2.png" class="david-avatar-sm" alt="David Thorne" />
        <div class="ai-summary-label">David Thorne — People Intelligence</div>
        <button type="button" class="btn btn-ghost btn-sm" id="btn-people-briefing-refresh">↺ Refresh</button>
      </div>
      <div id="people-briefing-panel" class="people-briefing-panel">
        <div class="people-briefing-loading">⟳ Loading people intelligence...</div>
      </div>
    </div>`;

  const tbody = document.getElementById('collaborators-body');
  rows.forEach(r => appendCollaboratorRow(tbody, clientId, r));
  appendCollaboratorRow(tbody, clientId, null); // blank sentinel row

  // Pick from Emails button
  document.getElementById('btn-collab-from-email').addEventListener('click', async function() {
    const panel = document.getElementById('collab-email-suggestions');
    if (panel.style.display !== 'none') { panel.style.display = 'none'; return; }
    panel.innerHTML = '<div style="padding:10px;color:var(--text-muted);font-size:13px">Loading...</div>';
    panel.style.display = 'block';
    try {
      const senders = await api(`/clients/${clientId}/email-senders`);
      if (!senders.length) {
        panel.innerHTML = '<div class="collab-suggest-empty">No email senders found for this client yet.</div>';
        return;
      }
      // Filter out already-added collaborators by email
      const existingEmails = new Set(rows.map(r => (r.email || '').toLowerCase()));
      const fresh = senders.filter(s => !existingEmails.has(s.email.toLowerCase()));
      if (!fresh.length) {
        panel.innerHTML = '<div class="collab-suggest-empty">All known email senders are already collaborators.</div>';
        return;
      }
      panel.innerHTML = `
        <div class="collab-suggest-header">Email senders filed to this client — click Add to pre-fill a row:</div>
        ${fresh.map((s, i) => `
          <div class="collab-suggest-row" data-idx="${i}">
            <div class="collab-suggest-info">
              <span class="collab-suggest-name">${escapeHTML(s.name || s.email)}</span>
              <span class="collab-suggest-email">${escapeHTML(s.email)}</span>
              <span class="collab-suggest-subject">${escapeHTML(s.subject || '')}</span>
            </div>
            <button class="btn btn-sm btn-ghost collab-suggest-add" data-name="${escapeHTML(s.name)}" data-email="${escapeHTML(s.email)}">+ Add</button>
          </div>
        `).join('')}
      `;
      panel.querySelectorAll('.collab-suggest-add').forEach(btn => {
        btn.addEventListener('click', () => {
          // Fill the sentinel (blank) row, or append a new one if sentinel is dirty
          const sentinel = tbody.querySelector('tr[data-id=""]');
          const nameEl  = sentinel?.querySelector('.collab-name');
          const emailEl = sentinel?.querySelector('.collab-email');
          if (sentinel && !nameEl.value && !emailEl.value) {
            nameEl.value  = btn.dataset.name;
            emailEl.value = btn.dataset.email;
            setCollabLocked(sentinel, false);
            nameEl.focus();
          } else {
            appendCollaboratorRow(tbody, clientId, { name: btn.dataset.name, email: btn.dataset.email });
          }
          btn.textContent = '✓ Added';
          btn.disabled = true;
        });
      });
    } catch (e) {
      panel.innerHTML = `<div class="collab-suggest-empty">Error: ${escapeHTML(e.message)}</div>`;
    }
  });

  // Load people intelligence briefing
  loadPeopleBriefing(clientId);

  document.getElementById('btn-people-briefing-refresh')?.addEventListener('click', () => {
    const panel = document.getElementById('people-briefing-panel');
    if (panel) panel.innerHTML = '<div class="people-briefing-loading">⟳ Loading people intelligence...</div>';
    loadPeopleBriefing(clientId, true);
  });
}

function appendCollaboratorRow(tbody, clientId, data) {
  const tr = document.createElement('tr');
  tr.className = 'collaborator-row';
  tr.dataset.id = data?.id || '';
  tr.dataset.clientId = clientId;

  const phone = formatPhone(data?.phone || '');
  const isSaved = !!data?.id;

  tr.innerHTML = `
    <td><input class="collab-input collab-name" type="text" placeholder="Name" value="${escapeHTML(data?.name || '')}"></td>
    <td><select class="collab-input collab-role">${roleOptions(data?.role || '')}</select></td>
    <td><input class="collab-input collab-phone" type="tel" placeholder="(xxx) xxx-xxxx" value="${escapeHTML(phone)}"></td>
    <td><input class="collab-input collab-email" type="email" placeholder="email@example.com" value="${escapeHTML(data?.email || '')}"></td>
    <td class="collab-actions">
      <button class="collab-btn collab-btn-delete" title="Delete row">✕</button>
      <button class="collab-btn collab-btn-save" title="Save row">✓</button>
      <button class="collab-btn collab-btn-edit" title="Edit row">✏</button>
    </td>`;

  // Format phone on blur
  tr.querySelector('.collab-phone').addEventListener('blur', function() {
    this.value = formatPhone(this.value);
  });

  // ── Name autocomplete (cross-client lookup) ───────────────────────────────
  let _collabAcTimer = null;
  let _collabAcDropdown = null;

  function removeCollabDropdown() {
    if (_collabAcDropdown) { _collabAcDropdown.remove(); _collabAcDropdown = null; }
  }

  tr.querySelector('.collab-name').addEventListener('input', function() {
    const q = this.value.trim();
    clearTimeout(_collabAcTimer);
    removeCollabDropdown();
    if (q.length < 2) return;
    const nameInput = this;
    _collabAcTimer = setTimeout(async () => {
      let results;
      try {
        results = await api(`/collaborators/search?q=${encodeURIComponent(q)}&exclude_client=${clientId}`);
      } catch { return; }
      if (!results.length) return;

      _collabAcDropdown = document.createElement('div');
      _collabAcDropdown.className = 'collab-ac-dropdown';
      results.forEach(r => {
        const item = document.createElement('div');
        item.className = 'collab-ac-item';
        item.innerHTML =
          `<span class="collab-ac-name">${escapeHTML(r.name)}</span>` +
          `<span class="collab-ac-meta">${r.clients ? escapeHTML(r.clients) : ''}</span>`;
        item.addEventListener('mousedown', (e) => {
          e.preventDefault(); // prevent blur before click fires
          tr.querySelector('.collab-name').value  = r.name  || '';
          tr.querySelector('.collab-role').value  = r.role  || '';
          tr.querySelector('.collab-phone').value = formatPhone(r.phone || '');
          tr.querySelector('.collab-email').value = r.email || '';
          removeCollabDropdown();
          tr.querySelector('.collab-email').focus();
        });
        _collabAcDropdown.appendChild(item);
      });

      // Position below the name input cell
      const tdRect = nameInput.closest('td').getBoundingClientRect();
      _collabAcDropdown.style.position = 'fixed';
      _collabAcDropdown.style.top  = (tdRect.bottom + 2) + 'px';
      _collabAcDropdown.style.left = tdRect.left + 'px';
      _collabAcDropdown.style.width = Math.max(tdRect.width, 240) + 'px';
      document.body.appendChild(_collabAcDropdown);
    }, 280);
  });

  tr.querySelector('.collab-name').addEventListener('blur', () => {
    // Small delay so mousedown on item fires first
    setTimeout(removeCollabDropdown, 150);
  });

  // Start in correct state
  setCollabLocked(tr, isSaved);

  // Delete / clear button
  tr.querySelector('.collab-btn-delete').addEventListener('click', async () => {
    if (tr.dataset.id) {
      // Snapshot before delete so we can undo
      const snapshot = {
        client_id: parseInt(tr.dataset.clientId),
        name: tr.querySelector('.collab-name').value,
        role: tr.querySelector('.collab-role').value,
        phone: tr.querySelector('.collab-phone').value,
        email: tr.querySelector('.collab-email').value,
        season_year: data?.season_year || null
      };
      await api(`/collaborators/${tr.dataset.id}`, { method: 'DELETE' });
      tr.remove();
      pushUndo('delete_collaborator', snapshot);
    } else {
      // Sentinel row — blank it out instead of removing
      tr.querySelector('.collab-name').value = '';
      tr.querySelector('.collab-role').value = '';
      tr.querySelector('.collab-phone').value = '';
      tr.querySelector('.collab-email').value = '';
    }
  });

  // Save (green check) button
  tr.querySelector('.collab-btn-save').addEventListener('click', () => {
    saveCollaboratorRow(tr, clientId);
  });

  // Edit (yellow pencil) button
  tr.querySelector('.collab-btn-edit').addEventListener('click', () => {
    setCollabLocked(tr, false);
    tr.querySelector('.collab-name').focus();
  });

  tbody.appendChild(tr);
}

function setCollabLocked(tr, locked) {
  // Remove any existing display elements first
  tr.querySelectorAll('.collab-link, .collab-display').forEach(el => el.remove());

  // Hide or show all inputs
  tr.querySelectorAll('.collab-input').forEach(input => {
    input.style.display = locked ? 'none' : '';
    if (input.tagName === 'SELECT') input.disabled = locked;
  });

  if (locked) {
    const nameInput  = tr.querySelector('.collab-name');
    const roleSelect = tr.querySelector('.collab-role');
    const phoneInput = tr.querySelector('.collab-phone');
    const emailInput = tr.querySelector('.collab-email');

    // Name — plain text span
    if (nameInput.value.trim()) {
      const span = document.createElement('span');
      span.className = 'collab-display';
      span.textContent = nameInput.value.trim();
      nameInput.insertAdjacentElement('afterend', span);
    }

    // Role — selected option label
    const roleLabel = roleSelect.options[roleSelect.selectedIndex]?.text || '';
    if (roleLabel && roleLabel !== '—') {
      const span = document.createElement('span');
      span.className = 'collab-display';
      span.textContent = roleLabel;
      roleSelect.insertAdjacentElement('afterend', span);
    }

    // Phone → tappable link
    if (phoneInput.value.trim()) {
      const a = document.createElement('a');
      a.className = 'collab-link';
      a.href = '#';
      a.dataset.phone = phoneInput.value.trim();
      a.textContent = phoneInput.value.trim();
      phoneInput.insertAdjacentElement('afterend', a);
    }

    // Email → mailto link
    if (emailInput.value.trim()) {
      const a = document.createElement('a');
      a.className = 'collab-link';
      a.href = `mailto:${emailInput.value.trim()}`;
      a.textContent = emailInput.value.trim();
      emailInput.insertAdjacentElement('afterend', a);
    }
  }

  tr.querySelector('.collab-btn-delete').style.display = locked ? 'none' : '';
  tr.querySelector('.collab-btn-save').style.display   = locked ? 'none' : '';
  tr.querySelector('.collab-btn-edit').style.display   = locked ? ''     : 'none';
}

async function saveCollaboratorRow(tr, clientId) {
  const name  = tr.querySelector('.collab-name').value.trim();
  const role  = tr.querySelector('.collab-role').value;
  const phone = tr.querySelector('.collab-phone').value.trim();
  const email = tr.querySelector('.collab-email').value.trim();

  // Don't save completely empty rows
  if (!name && !role && !phone && !email) return;

  const payload = { client_id: clientId, name, role, phone: formatPhone(phone), email };

  if (tr.dataset.id) {
    await api(`/collaborators/${tr.dataset.id}`, { method: 'PATCH', body: payload });
  } else {
    // New row: stamp with current season year so it's season-specific
    const created = await api(`/collaborators`, {
      method: 'POST',
      body: { ...payload, season_year: state.clientDetailYear || null }
    });
    tr.dataset.id = created.id;
    appendCollaboratorRow(tr.closest('tbody'), clientId, null);
  }

  setCollabLocked(tr, true);
}

// ── Email Reply Modal ──────────────────────────────────────────────────────

function openReplyModal(itemId) {
  const item = state.inboxItemsById[itemId];
  if (!item || !item.reply_to) return;

  const isPersonal  = item.reply_via === 'gmail_personal';
  const sendingFrom = isPersonal ? 'ryan@ryanjwilliams.net' : 'Ryan@whitemagemusic.com';
  const rawSubject  = item.original_subject || '';
  const reSubject   = rawSubject.match(/^re:/i) ? rawSubject : `Re: ${rawSubject}`;

  document.getElementById('reply-to-display').textContent  = item.reply_to;
  document.getElementById('reply-subject').value           = reSubject;
  document.getElementById('reply-body').value              = '';
  document.getElementById('reply-sending-via').textContent = `Sending from: ${sendingFrom}`;
  document.getElementById('reply-signature').textContent   =
    `--\nRyan Williams\n${sendingFrom}\nSent from the White Mage Music Dashboard.`;

  const modal = document.getElementById('modal-email-reply');
  modal.dataset.itemId    = itemId;
  modal.dataset.to        = item.reply_to;
  modal.dataset.via       = item.reply_via || 'gmail_wmm';
  modal.dataset.inReplyTo = item.reply_message_id || '';
  modal.style.display     = 'flex';

  document.getElementById('reply-body').focus();
}

async function generateAIDraft() {
  const modal  = document.getElementById('modal-email-reply');
  const item   = state.inboxItemsById[modal.dataset.itemId];
  const btn    = document.getElementById('btn-ai-draft');
  btn.disabled = true;
  btn.textContent = '✨ Writing…';
  try {
    const result = await api('/gmail/ai-draft', {
      method: 'POST',
      body: {
        original_subject: item?.original_subject || '',
        original_body:    item?.original_body    || item?.summary || '',
        from_email:       item?.reply_to         || '',
        client_name:      item?.client_name      || item?.org_name || '',
        account:          modal.dataset.via
      }
    });
    document.getElementById('reply-body').value = result.draft;
  } catch (err) {
    alert('AI draft failed: ' + err.message);
  } finally {
    btn.disabled    = false;
    btn.textContent = '✨ Write with AI';
  }
}

async function sendEmailReply() {
  const modal = document.getElementById('modal-email-reply');
  const body  = document.getElementById('reply-body').value.trim();
  if (!body) { alert('Please write a reply first.'); return; }

  const btn    = document.getElementById('btn-reply-send');
  btn.disabled = true;
  btn.textContent = 'Sending…';

  try {
    await api('/gmail/reply', {
      method: 'POST',
      body: {
        to:        modal.dataset.to,
        subject:   document.getElementById('reply-subject').value.trim(),
        body,
        account:   modal.dataset.via,
        inReplyTo: modal.dataset.inReplyTo || undefined
      }
    });
    modal.style.display = 'none';
  } catch (err) {
    alert('Send failed: ' + err.message);
    btn.disabled    = false;
    btn.textContent = 'Send ✈';
  }
}

// Wire reply modal buttons (called once DOM is ready)
function initReplyModal() {
  document.getElementById('modal-reply-close')?.addEventListener('click', () => {
    document.getElementById('modal-email-reply').style.display = 'none';
  });
  document.getElementById('btn-reply-cancel')?.addEventListener('click', () => {
    document.getElementById('modal-email-reply').style.display = 'none';
  });
  document.getElementById('btn-reply-send')?.addEventListener('click', sendEmailReply);
  document.getElementById('btn-ai-draft')?.addEventListener('click', generateAIDraft);
  // Close on overlay click
  document.getElementById('modal-email-reply')?.addEventListener('click', e => {
    if (e.target === e.currentTarget) e.currentTarget.style.display = 'none';
  });
}

// ── Phone tap action (text or call) ───────────────────────────────────────

function initPhoneTapMenu() {
  // Delegated listener for any phone number link clicked in the dashboard
  document.addEventListener('click', e => {
    const link = e.target.closest('a[data-phone]');
    if (!link) return;
    e.preventDefault();
    const phone = link.dataset.phone;
    showPhoneActionMenu(phone, link);
  });
}

function showPhoneActionMenu(phone, anchor) {
  document.getElementById('phone-action-menu')?.remove();

  const menu = document.createElement('div');
  menu.id = 'phone-action-menu';
  menu.className = 'phone-action-menu';
  menu.innerHTML = `
    <a href="tel:${phone}" class="phone-action-item">📞 Call ${phone}</a>
    <a href="sms:${phone}" class="phone-action-item">💬 Text ${phone}</a>`;

  document.body.appendChild(menu);

  // Position near the anchor
  const rect = anchor.getBoundingClientRect();
  menu.style.top  = `${rect.bottom + window.scrollY + 4}px`;
  menu.style.left = `${rect.left  + window.scrollX}px`;

  // Close on outside click
  setTimeout(() => {
    document.addEventListener('click', () => menu.remove(), { once: true });
  }, 10);
}

// ── Modals ─────────────────────────────────────────────────────────────────
function bindWebsiteClearBtn(client) {
  document.querySelector('.btn-website-clear')?.addEventListener('click', async function() {
    if (!confirm('Remove the band website for this client?')) return;
    try {
      await api(`/clients/${client.id}/band-website`, { method: 'DELETE' });
      client.band_website = null;
      const idx = state.clients.findIndex(c => c.id === client.id);
      if (idx >= 0) state.clients[idx].band_website = null;
      const row = document.getElementById('client-website-row');
      if (row) row.innerHTML = `<button class="btn btn-ghost btn-xs btn-find-website" data-client-id="${client.id}">Find Band Website</button>`;
      // Re-bind find button
      row?.querySelector('.btn-find-website')?.addEventListener('click', async function() {
        const btn = this; btn.textContent = 'Searching…'; btn.disabled = true;
        try {
          const result = await api(`/clients/${client.id}/find-band-website`, { method: 'POST' });
          if (result.band_website) {
            client.band_website = result.band_website;
            const i = state.clients.findIndex(c => c.id === client.id);
            if (i >= 0) state.clients[i].band_website = result.band_website;
            row.innerHTML = `<a href="${escapeHTML(result.band_website)}" target="_blank" rel="noopener" class="band-website-link">🌐 Band Website</a>
              <button class="btn-website-clear" title="Clear website" data-client-id="${client.id}">✕</button>`;
            bindWebsiteClearBtn(client);
          } else { btn.textContent = 'Not found — edit to add manually'; btn.disabled = false; }
        } catch { btn.textContent = 'Search failed'; btn.disabled = false; }
      });
    } catch (err) {
      console.error('clear website:', err.message);
    }
  });
}

function openEditClientModal(client) {
  document.getElementById('field-ensemble-type').value = client.ensemble_type;
  document.getElementById('field-name').value = client.name || '';
  document.getElementById('field-org').value = client.org_name || '';
  document.getElementById('field-email').value = client.email || '';
  document.getElementById('field-phone').value = client.phone || '';
  document.getElementById('field-address1').value = client.address_line1 || '';
  document.getElementById('field-address2').value = client.address_line2 || '';
  document.getElementById('field-city').value = client.city || '';
  document.getElementById('field-state').value = client.state || '';
  document.getElementById('field-zip').value = client.zip || '';
  document.getElementById('field-band-size').value = client.band_size || '';
  document.getElementById('field-circuit').value = client.primary_circuit || '';
  document.getElementById('field-band-website').value = client.band_website || '';
  document.getElementById('website-search-status').textContent = '';
  document.getElementById('modal-client-title').textContent = 'Edit Client';
  document.getElementById('modal-new-client').style.display = 'flex';
  document.getElementById('form-new-client').dataset.editId = client.id;
}

function closeModal(id) {
  document.getElementById(id).style.display = 'none';
}

// ── New Client Form ────────────────────────────────────────────────────────
document.getElementById('btn-new-marching').addEventListener('click', () => {
  document.getElementById('field-ensemble-type').value = 'marching';
  document.getElementById('modal-client-title').textContent = 'New Marching Client';
  document.getElementById('form-new-client').reset();
  delete document.getElementById('form-new-client').dataset.editId;
  document.getElementById('field-ensemble-type').value = 'marching';
  document.getElementById('modal-new-client').style.display = 'flex';
});

document.getElementById('btn-new-university').addEventListener('click', () => {
  document.getElementById('field-ensemble-type').value = 'university_band';
  document.getElementById('modal-client-title').textContent = 'New University / College Band';
  document.getElementById('form-new-client').reset();
  delete document.getElementById('form-new-client').dataset.editId;
  document.getElementById('field-ensemble-type').value = 'university_band';
  document.getElementById('modal-new-client').style.display = 'flex';
});

document.getElementById('btn-new-drum-corps').addEventListener('click', () => {
  document.getElementById('field-ensemble-type').value = 'drum_corps';
  document.getElementById('modal-client-title').textContent = 'New Drum Corps';
  document.getElementById('form-new-client').reset();
  delete document.getElementById('form-new-client').dataset.editId;
  document.getElementById('field-ensemble-type').value = 'drum_corps';
  document.getElementById('modal-new-client').style.display = 'flex';
});

document.getElementById('btn-new-comp').addEventListener('click', () => {
  document.getElementById('field-ensemble-type').value = 'composition';
  document.getElementById('modal-client-title').textContent = 'New Composition Client';
  document.getElementById('form-new-client').reset();
  delete document.getElementById('form-new-client').dataset.editId;
  document.getElementById('field-ensemble-type').value = 'composition';
  document.getElementById('modal-new-client').style.display = 'flex';
});

document.getElementById('btn-undo').addEventListener('click', () => applyUndo());

document.getElementById('modal-client-close').addEventListener('click', () => closeModal('modal-new-client'));
document.getElementById('modal-client-cancel').addEventListener('click', () => closeModal('modal-new-client'));

// "Search" button inside new/edit client modal — finds band website via Claude
document.getElementById('btn-search-website').addEventListener('click', async () => {
  const org = document.getElementById('field-org').value.trim();
  const city = document.getElementById('field-city').value.trim();
  const st = document.getElementById('field-state').value.trim();
  const dir = document.getElementById('field-name').value.trim();
  const email = document.getElementById('field-email')?.value.trim() || '';
  if (!org) { document.getElementById('website-search-status').textContent = 'Enter a school name first.'; return; }

  const statusEl = document.getElementById('website-search-status');
  statusEl.textContent = 'Searching…';
  document.getElementById('btn-search-website').disabled = true;
  try {
    const result = await api('/clients/lookup-website', {
      method: 'POST',
      body: JSON.stringify({ org_name: org, city, state: st, director_name: dir, director_email: email })
    });
    if (result.band_website) {
      document.getElementById('field-band-website').value = result.band_website;
      statusEl.textContent = 'Found — verify and save with Create / Save.';
    } else {
      statusEl.textContent = 'No website found. You can enter one manually.';
    }
  } catch (err) {
    statusEl.textContent = 'Search failed — try again or enter manually.';
  } finally {
    document.getElementById('btn-search-website').disabled = false;
  }
});

document.getElementById('form-new-client').addEventListener('submit', async e => {
  e.preventDefault();
  const data = {
    name: document.getElementById('field-name').value,
    org_name: document.getElementById('field-org').value,
    email: document.getElementById('field-email').value,
    phone: document.getElementById('field-phone').value,
    address_line1: document.getElementById('field-address1').value || null,
    address_line2: document.getElementById('field-address2').value || null,
    city: document.getElementById('field-city').value || null,
    state: document.getElementById('field-state').value,
    zip: document.getElementById('field-zip').value || null,
    band_size: document.getElementById('field-band-size').value || null,
    ensemble_type: document.getElementById('field-ensemble-type').value,
    primary_circuit: document.getElementById('field-circuit').value || null,
    band_website: document.getElementById('field-band-website').value || null
  };
  const editId = document.getElementById('form-new-client').dataset.editId;
  if (editId) {
    const updated = await api(`/clients/${editId}`, { method: 'PUT', body: data });
    const idx = state.clients.findIndex(c => c.id === updated.id);
    if (idx >= 0) state.clients[idx] = { ...state.clients[idx], ...updated };
    closeModal('modal-new-client');
    await renderClientDetail();
  } else {
    const client = await api('/clients', { method: 'POST', body: data });
    state.clients.push(client);

    // For marching clients, auto-create a show for the current year so the
    // card appears immediately on the dashboard grid.
    if (client.ensemble_type === 'marching') {
      const currentYear = new Date().getFullYear();
      try {
        const newShow = await api(`/clients/${client.id}/shows`, {
          method: 'POST',
          body: {
            title: '',
            season_year: currentYear,
            show_type: 'marching',
            status: 'active',
            duration_seconds: 420
          }
        });
        if (!state.allShows) state.allShows = [];
        state.allShows.push(newShow);
      } catch (err) {
        console.warn('[new client] auto-show creation failed:', err.message);
      }
    }

    closeModal('modal-new-client');
    renderDashboard();
    // Open the new client card so Ryan can fill in show details right away
    state.selectedYear = new Date().getFullYear();
    openClient(client.id);
  }
});

// ── New Show Form ──────────────────────────────────────────────────────────
document.getElementById('modal-show-close').addEventListener('click', () => closeModal('modal-new-show'));
document.getElementById('modal-show-cancel').addEventListener('click', () => closeModal('modal-new-show'));

document.getElementById('form-new-show').addEventListener('submit', async e => {
  e.preventDefault();
  const clientId = document.getElementById('show-client-id').value;
  const newShowClient = state.clients.find(c => c.id === parseInt(clientId));
  const isMarching = newShowClient && newShowClient.ensemble_type === 'marching';
  const year = parseInt(document.getElementById('show-year').value);
  const newShow = await api(`/clients/${clientId}/shows`, {
    method: 'POST',
    body: {
      title: document.getElementById('show-title').value,
      season_year: year,
      show_type: document.getElementById('show-type').value,
      due_date: document.getElementById('show-due-date').value || null,
      status: document.getElementById('show-status').value,
      duration_seconds: isMarching ? 420 : 0
    }
  });
  // Patch role, fee, flags from modal fields
  const checkedRoles = [...document.querySelectorAll('#show-role-group input:checked')].map(c => c.value);
  const roleVal = checkedRoles.length ? checkedRoles.join(',') : '';
  const feeVal = document.getElementById('show-fee')?.value;
  const noContract = document.getElementById('show-no-contract')?.checked;
  const noInvoice = document.getElementById('show-no-invoice')?.checked;
  if (newShow?.id) {
    const patches = [];
    if (roleVal) patches.push(api(`/shows/${newShow.id}/field`, { method: 'PATCH', body: { field: 'role', value: roleVal } }));
    if (feeVal) patches.push(api(`/shows/${newShow.id}/field`, { method: 'PATCH', body: { field: 'fee_cents', value: Math.round(parseFloat(feeVal) * 100) } }));
    if (noContract) patches.push(api(`/shows/${newShow.id}/field`, { method: 'PATCH', body: { field: 'no_contract', value: true } }));
    if (noInvoice) patches.push(api(`/shows/${newShow.id}/field`, { method: 'PATCH', body: { field: 'no_invoice', value: true } }));
    await Promise.all(patches);
  }
  // Copy collaborators from the most recent previous season
  const allClientYears = [...new Set(state.allShows.filter(s => s.client_id === parseInt(clientId)).map(s => parseInt(s.season_year)))].sort();
  const prevYear = Math.max(...allClientYears.filter(y => y < year), 0);
  if (prevYear > 0) {
    api('/collaborators/copy-season', {
      method: 'POST',
      body: { client_id: parseInt(clientId), from_year: prevYear, to_year: year }
    }).catch(() => {}); // non-fatal
  }

  // Reset modal fields
  document.querySelectorAll('#show-role-group input[type="checkbox"]').forEach(cb => cb.checked = false);
  const feeEl = document.getElementById('show-fee'); if (feeEl) feeEl.value = '';
  const ncEl = document.getElementById('show-no-contract'); if (ncEl) ncEl.checked = false;
  const niEl = document.getElementById('show-no-invoice'); if (niEl) niEl.checked = false;
  // Refresh allShows
  state.allShows = await api('/shows');
  state.clientDetailYear = year;
  closeModal('modal-new-show');
  await renderClientDetail();
});

// ── Source Material Form ───────────────────────────────────────────────────
document.getElementById('modal-material-close').addEventListener('click', () => closeModal('modal-new-material'));
document.getElementById('modal-material-cancel').addEventListener('click', () => closeModal('modal-new-material'));

document.getElementById('form-new-material').addEventListener('submit', async e => {
  e.preventDefault();
  const clientId = document.getElementById('material-client-id').value;
  await api(`/clients/${clientId}/source-materials`, {
    method: 'POST',
    body: {
      type: document.getElementById('material-type').value,
      url: document.getElementById('material-url').value,
      label: document.getElementById('material-label').value
    }
  });
  closeModal('modal-new-material');
  await renderClientDetail();
});

// ── Admin Tasks ────────────────────────────────────────────────────────────
async function loadAdminTasks() {
  try {
    const tasks = await api('/admin-tasks');
    renderAdminTasks(tasks);
  } catch (err) {
    console.error('loadAdminTasks:', err.message);
  }
}

function renderAdminTasks(tasks) {
  const list = document.getElementById('admin-tasks-list');
  if (!list) return;
  if (!tasks.length) {
    list.innerHTML = '<div class="admin-tasks-empty">No tasks — you\'re all clear!</div>';
    return;
  }
  list.innerHTML = tasks.map(t => {
    const hasLink = t.client_id && t.note_id;
    return `
      <div class="admin-task-item" data-task-id="${t.id}">
        <button class="task-complete-btn" data-task-id="${t.id}" title="Mark complete">✓</button>
        <span class="task-summary ${hasLink ? 'task-link' : ''}"
          ${hasLink ? `data-client-id="${t.client_id}" data-note-id="${t.note_id}"` : ''}
        >${escapeHTML(t.summary)}</span>
        <button class="task-delete-btn" data-task-id="${t.id}" title="Remove task">✕</button>
      </div>`;
  }).join('');

  list.querySelectorAll('.task-complete-btn').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.stopPropagation();
      await api(`/admin-tasks/${btn.dataset.taskId}/complete`, { method: 'PATCH' });
      btn.closest('.admin-task-item').remove();
      if (!list.querySelector('.admin-task-item')) {
        list.innerHTML = '<div class="admin-tasks-empty">No tasks — you\'re all clear!</div>';
      }
    });
  });

  list.querySelectorAll('.task-delete-btn').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.stopPropagation();
      await api(`/admin-tasks/${btn.dataset.taskId}`, { method: 'DELETE' });
      btn.closest('.admin-task-item').remove();
      if (!list.querySelector('.admin-task-item')) {
        list.innerHTML = '<div class="admin-tasks-empty">No tasks — you\'re all clear!</div>';
      }
    });
  });

  list.querySelectorAll('.task-summary.task-link').forEach(el => {
    el.addEventListener('click', () => {
      const clientId = parseInt(el.dataset.clientId);
      const noteId = parseInt(el.dataset.noteId);
      state.highlightNoteId = noteId;
      openClient(clientId, 'notes');
    });
  });
}

// Direct task input ("+" button)
document.getElementById('btn-add-task')?.addEventListener('click', () => {
  const wrap = document.getElementById('task-input-wrap');
  wrap.style.display = wrap.style.display === 'none' ? 'flex' : 'none';
  if (wrap.style.display === 'flex') document.getElementById('task-direct-input').focus();
});

document.getElementById('btn-save-direct-task')?.addEventListener('click', async () => {
  const input = document.getElementById('task-direct-input');
  const summary = input.value.trim();
  if (!summary) return;
  input.disabled = true;
  try {
    await api('/admin-tasks', { method: 'POST', body: { summary } });
    input.value = '';
    document.getElementById('task-input-wrap').style.display = 'none';
    loadAdminTasks();
  } catch (err) {
    alert('Could not save task: ' + err.message);
  } finally {
    input.disabled = false;
  }
});

document.getElementById('task-direct-input')?.addEventListener('keydown', e => {
  if (e.key === 'Enter') document.getElementById('btn-save-direct-task').click();
  if (e.key === 'Escape') {
    document.getElementById('task-input-wrap').style.display = 'none';
  }
});

// ── Nav ────────────────────────────────────────────────────────────────────
// ── Global Search ──────────────────────────────────────────────────────────
(function initGlobalSearch() {
  const input   = document.getElementById('global-search-input');
  const results = document.getElementById('global-search-results');
  if (!input || !results) return;

  let timer = null;
  let activeIdx = -1;

  function closeResults() {
    results.style.display = 'none';
    results.innerHTML = '';
    activeIdx = -1;
  }

  function navigateToResult(item) {
    closeResults();
    input.value = '';
    const clientId = parseInt(item.dataset.clientId);
    const tab      = item.dataset.tab || 'shows';
    const year     = parseInt(item.dataset.year) || null;
    if (!clientId) return;
    if (year) state.clientDetailYear = year;
    state.currentTab = tab;
    openClient(clientId);
  }

  function renderResults(data) {
    const sections = [
      { key: 'clients',       label: 'Clients',       icon: '🏫' },
      { key: 'shows',         label: 'Shows',         icon: '🎬' },
      { key: 'notes',         label: 'Notes',         icon: '📝' },
      { key: 'emails',        label: 'Emails',        icon: '✉' },
      { key: 'songs',         label: 'Songs & Copyright', icon: '🎵' },
      { key: 'collaborators', label: 'Collaborators', icon: '👤' },
    ];

    const total = sections.reduce((n, s) => n + (data[s.key]?.length || 0), 0);
    if (!total) {
      results.innerHTML = '<div class="search-empty">No results found.</div>';
      results.style.display = 'block';
      return;
    }

    let html = '';
    sections.forEach(({ key, label, icon }) => {
      const rows = data[key];
      if (!rows?.length) return;
      html += `<div class="search-section-label">${icon} ${label}</div>`;
      rows.forEach(r => {
        let mainText = '', subText = '', clientId = '', tab = 'shows', year = '';
        switch (key) {
          case 'clients':
            mainText = r.org_name || r.name;
            subText  = [r.director_name, r.state].filter(Boolean).join(' · ');
            clientId = r.id;
            tab = 'shows';
            break;
          case 'shows':
            mainText = r.title;
            subText  = `${r.season_year} · ${r.client_name}`;
            clientId = r.client_id;
            tab = 'shows';
            year = r.season_year;
            break;
          case 'notes':
            mainText = r.snippet?.replace(/\s+/g, ' ').trim() || '(note)';
            subText  = r.client_name;
            clientId = r.client_id;
            tab = 'notes';
            break;
          case 'emails':
            mainText = r.subject || '(no subject)';
            subText  = `${r.from_email} · ${r.client_name}`;
            clientId = r.client_id;
            tab = 'notes';
            break;
          case 'songs':
            mainText = r.title;
            subText  = [r.client_name, r.season_year].filter(Boolean).join(' · ');
            clientId = r.client_id;
            tab = 'copyright';
            year = r.season_year;
            break;
          case 'collaborators':
            mainText = r.name;
            subText  = [r.role, r.client_name].filter(Boolean).join(' · ');
            clientId = r.client_id;
            tab = 'collaborators';
            break;
        }
        html += `<div class="search-result-item" tabindex="-1"
          data-client-id="${clientId}" data-tab="${tab}" data-year="${year || ''}">
          <div class="search-result-main">${escapeHTML(mainText)}</div>
          ${subText ? `<div class="search-result-sub">${escapeHTML(subText)}</div>` : ''}
        </div>`;
      });
    });

    results.innerHTML = html;
    results.style.display = 'block';

    results.querySelectorAll('.search-result-item').forEach(item => {
      item.addEventListener('mousedown', e => { e.preventDefault(); navigateToResult(item); });
    });
  }

  function setActive(items, idx) {
    items.forEach((el, i) => el.classList.toggle('search-result-active', i === idx));
    if (items[idx]) items[idx].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { closeResults(); return; }
    timer = setTimeout(async () => {
      try {
        const data = await api(`/search?q=${encodeURIComponent(q)}`);
        renderResults(data);
      } catch { closeResults(); }
    }, 280);
  });

  input.addEventListener('keydown', e => {
    const items = [...results.querySelectorAll('.search-result-item')];
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = Math.min(activeIdx + 1, items.length - 1);
      setActive(items, activeIdx);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = Math.max(activeIdx - 1, 0);
      setActive(items, activeIdx);
    } else if (e.key === 'Enter' && activeIdx >= 0) {
      e.preventDefault();
      navigateToResult(items[activeIdx]);
    } else if (e.key === 'Escape') {
      closeResults();
      input.blur();
    }
  });

  input.addEventListener('blur', () => setTimeout(closeResults, 150));
})();

document.querySelectorAll('.nav-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const view = btn.dataset.view;
    showView(view);
    if (view === 'contacts') {
      if (window.renderContactsView) { window.renderContactsView(); }
      else { renderContacts(); }
    }
    if (view === 'inbox') {
      if (window.renderEmailView) { window.renderEmailView(); return; }
      renderInboxView();
      loadOvernightActivity();
      initBroadcastComposer();
      // Clear breathing badge when inbox is opened
      const badge = document.getElementById('inbox-badge');
      if (badge) badge.classList.remove('inbox-badge-breathing');
    }
    if (view === 'dashboard') {
      if (window.renderDashboardView) { window.renderDashboardView(); }
      else { loadAdminTasks(); }
    }
    if (view === 'copyright') loadCopyrightOverview();
    if (view === 'calendar')  loadCalendarView();
    if (view === 'invoices')  renderInvoicesView();
    if (view === 'intake') {
      if (window.renderIntakeView) window.renderIntakeView();
      const badge = document.getElementById('inbox-badge');
      if (badge) badge.classList.remove('inbox-badge-breathing');
    }
    if (view === 'competition'  && window.renderCompetitionView)  window.renderCompetitionView();
    if (view === 'business'     && window.renderBusinessView)     window.renderBusinessView();
    if (view === 'staff-bus'    && window.renderStaffBusView)     window.renderStaffBusView();
    if (view === 'portal-admin' && window.renderPortalAdminView)  window.renderPortalAdminView();
  });
});

['cr-filter-status','cr-filter-source'].forEach(id => {
  document.getElementById(id)?.addEventListener('change', renderCopyrightOverview);
});
document.getElementById('cr-filter-client')?.addEventListener('input', renderCopyrightOverview);

document.getElementById('btn-back').addEventListener('click', () => {
  const target = state.previousView || 'dashboard';
  showView(target);
  if (target === 'dashboard' && window.renderDashboardView) window.renderDashboardView();
});

document.getElementById('btn-back-contacts').addEventListener('click', () => {
  renderContacts();
});

document.getElementById('contact-search').addEventListener('input', e => {
  renderContacts(e.target.value.toLowerCase());
});

// ── Init ───────────────────────────────────────────────────────────────────
// ── Broadcast "To Name" contact autocomplete ───────────────────────────────
function initToNameAutocomplete() {
  const nameInput  = document.getElementById('bc-to-name');
  const emailInput = document.getElementById('bc-to-email');
  const sugBox     = document.getElementById('bc-to-name-suggestions');
  if (!nameInput || !sugBox) return;

  function buildCandidates() {
    const seen = new Set();
    const out  = [];
    // contactPeople (richer: name + email already normalised)
    _contactPeople.forEach(p => {
      if (!p.name) return;
      const key = (p.email || p.name).toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      out.push({ name: p.name, email: p.email || '', org: (p.programs?.[0]?.org_name) || '' });
    });
    // clients (director info)
    state.clients.forEach(c => {
      if (!c.name) return;
      const key = (c.email || c.name).toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      out.push({ name: c.name, email: c.email || '', org: c.org_name || '' });
    });
    return out;
  }

  nameInput.addEventListener('input', () => {
    const q = nameInput.value.trim().toLowerCase();
    if (q.length < 1) { sugBox.style.display = 'none'; return; }
    const matches = buildCandidates().filter(c =>
      c.name.toLowerCase().includes(q) ||
      (c.email || '').toLowerCase().includes(q) ||
      (c.org || '').toLowerCase().includes(q)
    ).slice(0, 8);
    if (!matches.length) { sugBox.style.display = 'none'; return; }
    sugBox.innerHTML = matches.map((m, i) =>
      `<div class="bc-suggest-item" data-idx="${i}">
        <span class="bc-suggest-name">${escapeHTML(m.name)}</span>
        ${m.org ? `<span class="bc-suggest-org">${escapeHTML(m.org)}</span>` : ''}
        ${m.email ? `<span class="bc-suggest-email">${escapeHTML(m.email)}</span>` : ''}
      </div>`
    ).join('');
    sugBox.style.display = '';
    sugBox.querySelectorAll('.bc-suggest-item').forEach((item, i) => {
      item.addEventListener('mousedown', e => {
        e.preventDefault();
        nameInput.value  = matches[i].name;
        emailInput.value = matches[i].email;
        sugBox.style.display = 'none';
        emailInput.focus();
      });
    });
  });

  nameInput.addEventListener('blur', () => {
    setTimeout(() => { sugBox.style.display = 'none'; }, 150);
  });
}

// ── Notifications popup ────────────────────────────────────────────────────
const NOTIF_LABELS = {
  survey:           'Survey',
  invoice:          'Invoice',
  contract_sent:    'Contract',
  contract_signed:  'Signed'
};

function getDismissedNotifKeys() {
  try {
    const raw = JSON.parse(localStorage.getItem('wmmDismissedNotifs') || '[]');
    const cutoff = Date.now() - 24 * 60 * 60 * 1000;
    return new Set(raw.filter(d => d.at > cutoff).map(d => d.key));
  } catch { return new Set(); }
}

function saveDismissedNotifKeys(keys) {
  const cutoff = Date.now() - 24 * 60 * 60 * 1000;
  try {
    const existing = JSON.parse(localStorage.getItem('wmmDismissedNotifs') || '[]')
      .filter(d => d.at > cutoff);
    const merged = [...existing, ...[...keys].map(key => ({ key, at: Date.now() }))];
    localStorage.setItem('wmmDismissedNotifs', JSON.stringify(merged));
  } catch {}
}

async function checkNotifications() {
  try {
    const lastSeen = localStorage.getItem('wmmLastSeen')
      || new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
    const allItems = await api(`/notifications/recent?since=${encodeURIComponent(lastSeen)}`);
    if (!allItems || !allItems.length) return;

    const dismissed = getDismissedNotifKeys();
    const items = allItems.filter(i => !dismissed.has(`${i.client_name}|${i.type}`));
    if (!items.length) return;

    const text = items
      .map(i => `${i.client_name}: ${NOTIF_LABELS[i.type] || i.type}`)
      .join('  ·  ');

    const popup = document.createElement('div');
    popup.id = 'notif-popup';
    popup.dataset.keys = JSON.stringify(items.map(i => `${i.client_name}|${i.type}`));
    popup.innerHTML = `
      <span class="notif-eyebrow">New since last visit</span>
      <span class="notif-text">${escapeHTML(text)}</span>
      <button class="notif-dismiss" onclick="dismissNotifications()">✕</button>
    `;
    document.body.appendChild(popup);
  } catch (_) {}
}

function dismissNotifications() {
  const popup = document.getElementById('notif-popup');
  if (!popup) return;
  try {
    const keys = JSON.parse(popup.dataset.keys || '[]');
    saveDismissedNotifKeys(keys);
  } catch {}
  localStorage.setItem('wmmLastSeen', new Date().toISOString());
  popup.remove();
}
window.dismissNotifications = dismissNotifications;

async function init() {
  await initRole();
  [state.clients, state.allShows] = await Promise.all([
    api('/clients'),
    api('/shows')
  ]);
  const years = availableYears();
  const currentYear = new Date().getFullYear();
  state.selectedYear = years.includes(currentYear) ? currentYear : (years[years.length - 2] || currentYear);
  if (window.renderDashboardView) {
    window.renderDashboardView();
  } else {
    renderDashboard();
    updateMasterBar();
    loadAdminTasks();
    loadTopPriorities();
    loadUpcomingWriting();
    loadPortfolioWidget();
  }
  loadOvernightActivity();
  checkGmailStatus();
  updateInboxBadge();
  initPhoneTapMenu();
  initReplyModal();
  initToNameAutocomplete();

  // Refresh priorities button
  document.getElementById('btn-refresh-priorities')?.addEventListener('click', () => loadTopPriorities(true));
  document.getElementById('btn-refresh-portfolio')?.addEventListener('click', loadPortfolioWidget);

  // Calendar completed toggle
  document.getElementById('cal-show-completed')?.addEventListener('change', loadCalendarView);

  // Restore last screen after refresh
  const savedNav = JSON.parse(sessionStorage.getItem('wmmNavState') || 'null');
  if (savedNav?.view === 'client-detail' && savedNav?.clientId) {
    await openClient(savedNav.clientId, savedNav.tab || 'shows');
  } else if (savedNav?.view && savedNav.view !== 'dashboard') {
    showView(savedNav.view);
    if (savedNav.view === 'calendar') loadCalendarView();
    if (savedNav.view === 'inbox') updateInboxBadge();
  }

  // Notifications — after state restore so popup appears on top
  checkNotifications();
}

init().catch(console.error);

// Expose local functions needed by V4 modules
window.openClient = openClient;
window.showView   = showView;

// ══════════════════════════════════════════════════════════════════════════
// ── Gmail Status ──────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════
async function checkGmailStatus() {
  try {
    const status = await api('/gmail/status');
    state.gmailConnected = status.wmm;
    state.gmailPersonalConnected = status.personal;
    state.gmailDavidConnected = status.david;

    // Update the 4-dot pill
    const accounts = ['wmm', 'david', 'personal', 'mac'];
    accounts.forEach(key => {
      const dot = document.getElementById(`mpd-${key}`);
      if (dot) dot.className = `mail-pill-dot ${status[key] ? 'on' : 'off'}`;
    });

    // Update dropdown rows
    const gmailAccounts = ['wmm', 'david', 'personal'];
    gmailAccounts.forEach(key => {
      const acctDot = document.getElementById(`mad-${key}`);
      const actionsEl = document.getElementById(`maa-${key}`);
      if (acctDot) acctDot.className = `mail-acct-dot ${status[key] ? 'on' : 'off'}`;
      if (actionsEl) {
        if (status[key]) {
          actionsEl.innerHTML = `<button class="mail-acct-btn disconnect" onclick="window.mailDisconnect('${key}')">Disconnect</button>`;
        } else {
          actionsEl.innerHTML = `<button class="mail-acct-btn connect" onclick="window.mailConnect('${key}')">Connect</button>`;
        }
      }
    });

    // iCloud dot + note
    const macDot = document.getElementById('mad-mac');
    const macNote = document.getElementById('mac-imap-note');
    if (macDot) macDot.className = `mail-acct-dot ${status.mac ? 'on' : 'off'}`;
    if (macNote) macNote.textContent = status.mac ? 'Configured' : 'Set ICLOUD_EMAIL + ICLOUD_PASSWORD';
  } catch {}
}

async function disconnectGmail(account) {
  const label = account === 'wmm' ? 'WMM' : account === 'david' ? 'David' : 'Personal';
  if (!confirm(`Disconnect the ${label} Gmail account?`)) return;
  try {
    await api(`/gmail/disconnect?account=${account}`, { method: 'DELETE' });
    await checkGmailStatus();
    if (document.getElementById('inbox-view')?.style.display !== 'none') renderInboxView();
  } catch (err) {
    alert('Disconnect failed: ' + err.message);
  }
}

// ══════════════════════════════════════════════════════════════════════════
// ── PDF Helpers ───────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════

// Convert jsPDF arraybuffer output to base64 string
function pdfToBase64(doc) {
  const ab = doc.output('arraybuffer');
  const bytes = new Uint8Array(ab);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

// Add wrapped text to jsPDF doc; returns new Y position
function addWrappedText(doc, text, x, y, maxWidth, lineHeight, pageHeight, margin) {
  const lines = doc.splitTextToSize(text, maxWidth);
  for (const line of lines) {
    if (y > pageHeight - margin) {
      doc.addPage();
      y = margin;
    }
    doc.text(line, x, y);
    y += lineHeight;
  }
  return y;
}

// Renders mixed normal/bold segments inline with word-wrap (for wildcard fields in PDFs)
function addMixedWrapped(doc, segs, x, y, maxW, lh, H, pg) {
  const tokens = [];
  for (const {text, bold} of segs)
    text.split(' ').forEach(w => { if (w) tokens.push({ word: w, bold }); });
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  const spW = doc.getTextWidth(' ');
  let cx = x;
  for (const {word, bold} of tokens) {
    doc.setFont('helvetica', bold ? 'bold' : 'normal');
    const wW = doc.getTextWidth(word);
    if (cx > x && cx + spW + wW > x + maxW) {
      y += lh; if (y > H - pg) { doc.addPage(); y = pg; } cx = x;
    }
    if (cx > x) cx += spW;
    doc.text(word, cx, y);
    cx += wW;
  }
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(60, 60, 60);
  return y + lh;
}

// ══════════════════════════════════════════════════════════════════════════
// ── Contract PDF Generator ────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════
function generateContractPDF(client, show) {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: 'mm', format: 'letter' });

  const W = 215.9, H = 279.4;
  const margin = 20, maxW = W - margin * 2;
  const lh = 5.5; // line height mm
  let y = margin;

  // Brand header
  doc.setFillColor(21, 15, 34);
  doc.rect(0, 0, W, 30, 'F');

  if (_wmmLogoData) {
    const logoH = 20;
    const logoW = _wmmLogoData.w * (logoH / _wmmLogoData.h);
    doc.addImage(_wmmLogoData.url, 'PNG', (W - logoW) / 2, 4, logoW, logoH);
  } else {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(20);
    doc.setTextColor(255, 45, 120);
    doc.text('White Mage Music', W / 2, 16, { align: 'center' });
  }

  doc.setFontSize(11);
  doc.setTextColor(200, 180, 240);
  doc.text('Contract for Marching Band Writing Services', W / 2, 27, { align: 'center' });

  y = 38;

  // Divider
  doc.setDrawColor(255, 45, 120);
  doc.setLineWidth(0.5);
  doc.line(margin, y, W - margin, y);
  y += 8;

  // Fill-in data
  const directorName = client.name || '________________________';
  const schoolName = client.org_name || '________________________';
  const parts = (() => {
    const p = Array.isArray(show?.ensemble_parts) ? show.ensemble_parts
      : (show?.ensemble_parts ? JSON.parse(show.ensemble_parts) : []);
    const labels = { winds: 'Winds', battery: 'Battery', front_ensemble: 'Front Ensemble', sound_design: 'Sound Design' };
    return p.length ? p.map(x => labels[x] || x).join(', ') : '________________________';
  })();
  const fee = show?.fee_cents
    ? `$${(show.fee_cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
    : '___________';
  const year = show?.season_year || new Date().getFullYear();

  // Helper: bold inline value
  function inlineText(label, value, x, curY) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    const labelW = doc.getTextWidth(label);
    doc.text(label, x, curY);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(21, 15, 100);
    doc.text(value, x + labelW + 1, curY);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(60, 60, 60);
  }

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(60, 60, 60);

  y = addMixedWrapped(doc, [
    {text: 'This document will serve as an agreement between Ryan Williams on behalf of White Mage Music (hereafter "The Arranger") and', bold: false},
    {text: directorName.toUpperCase(), bold: true},
    {text: '(hereafter "The Director") of', bold: false},
    {text: schoolName.toUpperCase(), bold: true},
    {text: '(hereafter "The Program").', bold: false}
  ], margin, y, maxW, lh, H, margin);
  y += 4;

  // Section helper
  function section(title, items) {
    if (y > H - 40) { doc.addPage(); y = margin; }
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(255, 45, 120);
    doc.text(title, margin, y);
    y += lh + 1;
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(60, 60, 60);
    for (const item of items) {
      if (y > H - 20) { doc.addPage(); y = margin; }
      y = Array.isArray(item)
        ? addMixedWrapped(doc, item, margin + 4, y, maxW - 4, lh, H, margin)
        : addWrappedText(doc, item, margin + 4, y, maxW - 4, lh, H, margin);
      y += 1.5;
    }
    y += 3;
  }

  section('I. Period of Agreement', [
    'This contract will be valid for the period from the date signed to the conclusion of The Director\'s scheduled marching band season, to include all public performances of the field show written under this agreement.'
  ]);

  section('II. Process of Writing', [
    'The Arranger will be involved in the programming and design process to the degree requested by The Director.',
    'All music decisions for the design should be agreed upon/approved by The Arranger, allowing for limitations of ability levels, limitations of instrumentation, or aesthetic.',
    [{text: 'Under this contract, The Arranger will be responsible for writing for the following sections of the ensemble:', bold: false}, {text: parts.toUpperCase(), bold: true}],
    'The Arranger will begin writing after the following conditions have been met: (1) This Contract has been signed; (2) The Director has provided an instrumentation list/personnel roster; (3) A show design has been agreed upon with all interested parties.',
    'The Arranger will work to reasonably fulfill the design plan of The Director and other staff members.',
    'A completed draft of the show will be delivered within sixty (60) days of the writing process commencing, or within three (3) days of the primary rehearsal (typically, Band Camp) commencing, whichever comes first.',
    'The Arranger will deliver PDF files of Score and Parts and will provide cleanly formatted parts for all players covered under this agreement after any and all necessary Copyright Clearances have been finalized.',
    'The Arranger will collaborate as necessary with other staff writers throughout the writing and revision processes.'
  ]);

  section('III. Revisions', [
    'During the period covered by this contract, The Arranger will be available to make revisions as requested by The Director.',
    'All musical revisions, whether made by The Director, The Arranger, or other staff members, should be done in consultation with The Arranger.',
    'Minor revisions will be covered by the fee detailed below in Section VI. Minor revisions may include (but are not limited to): revoicing of chords, addition/removal of "inner voice" material, extension/shortening of phrases, addition/removal of short musical phrases, or addition/removal of one (1) entire instrumental voice/part.',
    'Substantial revisions will be done at a prorated rate equal to the fee defined in Section VI. (For example, substantially changing one (1) minute in a seven (7) minute show would add an additional 14% to the fee.) Substantial revisions may include: rearranging of show segments/material, elimination of/change to one or more entire show segments/movements, or addition/removal of two (2) or more instrumental voices.'
  ]);

  section('IV. Copyright Clearance', [
    'The Director will be responsible for securing copyright clearances (typically referred to as "permission to arrange"). While not required, it is advisable to work with Tresona Music.',
    'Any copyright fees will be paid by The Director. The Arranger will provide any required documentation to the copyright holder/clearing house upon request.'
  ]);

  section('V. Intellectual Property & Digital Information', [
    'In the case of originally-composed show material, The Arranger will retain copyright ownership of the music material.',
    'The Arranger may reuse material in future projects with other organizations.',
    'The Arranger will provide The Director and other staff writers with engraving software files upon request.',
    'The Director will ensure The Arranger receives all version updates from other staff writers; The Arranger will ensure all version updates are shared with The Director and other staff writers.'
  ]);

  section('VI. Payment', [
    [{text: 'The fee for this arranging work, having been agreed upon, will be', bold: false}, {text: fee + '.', bold: true}],
    'The Arranger will submit an invoice for payment to The Director on or (shortly) after July 1, unless otherwise agreed upon.',
    'Payment will be received by The Arranger within 30 days of The Director receiving the invoice.',
    'The Arranger waives the obligation of a down payment due to the execution of this agreement.'
  ]);

  // Signature block
  if (y > H - 50) { doc.addPage(); y = margin; }
  y += 6;
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(margin, y + 14, W / 2 - 10, y + 14);
  doc.line(W / 2 + 10, y + 14, W - margin, y + 14);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  doc.text('(Band Director)(Date)', margin, y + 19);
  doc.text('(Ryan Williams, Composer and Arranger)(Date)', W / 2 + 10, y + 19);

  doc.setFont('helvetica', 'italic');
  doc.setFontSize(9);
  doc.setTextColor(140, 120, 170);
  doc.text('Please sign and return a copy to Ryan Williams at your earliest convenience.', W / 2, y + 30, { align: 'center' });

  // Footer
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(160, 150, 180);
    doc.text(`White Mage Music — Confidential — Page ${i} of ${totalPages}`, W / 2, H - 8, { align: 'center' });
  }

  return pdfToBase64(doc);
}

// ══════════════════════════════════════════════════════════════════════════
// ── Invoice PDF Generator ─────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════
function generateInvoicePDF(client, show, invoiceNumber, squarePayUrl, opts = {}) {
  // opts: { items, payeeName, payeeAddress, amountCents, isQuote }
  // items: [{description, amount_cents}] — if provided, replaces default single line
  // payeeName/payeeAddress: overrides Bill To block (for split invoice secondary)
  // amountCents: overrides total (for split invoice)
  // isQuote: renders as Quote/Estimate instead of Invoice
  const isQuote = !!opts.isQuote;
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: 'mm', format: 'letter' });
  const W = 215.9, H = 279.4;

  // ── Teal header bar — gradient left (full teal) → right (white)
  const gradStrips = 80;
  const stripW = W / gradStrips;
  for (let i = 0; i < gradStrips; i++) {
    const t = i / gradStrips;
    doc.setFillColor(
      Math.round(0   + 255 * t),
      Math.round(156 + (255 - 156) * t),
      Math.round(180 + (255 - 180) * t)
    );
    doc.rect(i * stripW, 0, stripW + 0.3, 38, 'F');
  }

  // INVOICE / QUOTE title
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(isQuote ? 22 : 28);
  doc.setTextColor(255, 255, 255);
  doc.text(isQuote ? 'QUOTE / ESTIMATE' : 'INVOICE', 18, 23);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`${isQuote ? 'Quote#' : 'Invoice#'} ${invoiceNumber}`, 18, 31);

  // Ryan Williams Music logo — centered in header
  if (_rwmLogoData) {
    const logoH = 26;
    const logoW = _rwmLogoData.w * (logoH / _rwmLogoData.h);
    doc.addImage(_rwmLogoData.url, 'PNG', (W - logoW) / 2, (38 - logoH) / 2, logoW, logoH);
  } else {
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(255, 255, 255);
    doc.text('RYAN WILLIAMS MUSIC', W / 2, 19, { align: 'center' });
  }

  // ── Balance Due / Quoted Amount box (left, below header)
  doc.setTextColor(80, 80, 80);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text(isQuote ? 'Quoted Amount' : 'Balance Due', 18, 47);
  const total = opts.amountCents ?? (show?.fee_cents || 0);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 156, 180);
  doc.text(`$${(total / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`, 18, 57);

  // ── Invoice meta (left column)
  const today = new Date();
  const dueDate = new Date(today); dueDate.setDate(today.getDate() + 30);
  const fmt = d => d.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' });

  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  doc.setFont('helvetica', 'normal');
  const metaY = 68;
  doc.text(isQuote ? 'Quote Date :' : 'Invoice Date :', 18, metaY);
  doc.text(isQuote ? 'Valid For :' : 'Terms :', 18, metaY + 7);
  doc.text(isQuote ? 'Valid Until :' : 'Due Date :', 18, metaY + 14);
  doc.setTextColor(50, 50, 50);
  doc.text(fmt(today), 48, metaY);
  doc.text(isQuote ? '30 Days' : 'Net 30', 48, metaY + 7);
  doc.text(fmt(dueDate), 48, metaY + 14);

  // ── Bill To (right column)
  const billName = opts.payeeName || client.org_name || client.name || '—';
  const billAddr = opts.payeeAddress || {
    address_line1: client.address_line1 || client.street,
    address_line2: client.address_line2,
    city: client.city,
    state: client.state,
    zip: client.zip
  };
  const billX = 120;
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text('Bill To', billX, metaY);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(30, 30, 30);
  doc.text(billName, billX, metaY + 7);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);
  let billY = metaY + 14;
  if (billAddr.address_line1) { doc.text(billAddr.address_line1, billX, billY); billY += 6; }
  if (billAddr.address_line2) { doc.text(billAddr.address_line2, billX, billY); billY += 6; }
  if (billAddr.city || billAddr.state || billAddr.zip) {
    doc.text([billAddr.city, billAddr.state, billAddr.zip].filter(Boolean).join(', '), billX, billY);
    billY += 6;
  }
  doc.text('U.S.A', billX, billY);

  // ── Line items table
  const tableTop = 100;
  doc.setFillColor(0, 156, 180);
  doc.rect(18, tableTop, W - 36, 8, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  doc.text('#', 22, tableTop + 5.5);
  doc.text('Item & Description', 32, tableTop + 5.5);
  doc.text('Qty', W - 76, tableTop + 5.5, { align: 'right' });
  doc.text('Rate', W - 54, tableTop + 5.5, { align: 'right' });
  doc.text('Amount', W - 20, tableTop + 5.5, { align: 'right' });

  // Line items — use opts.items if provided, otherwise single default line
  const year = show?.season_year || new Date().getFullYear();
  const defaultDesc = isQuote ? `${year} Marching Band Show Design — Quote/Estimate` : `${year} Marching Band Show Design`;
  const lineItems = (opts.items && opts.items.length)
    ? opts.items
    : [{ description: defaultDesc, amount_cents: total }];

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(60, 60, 60);
  doc.setFontSize(9);

  let rowY = tableTop + 14;
  lineItems.forEach((item, idx) => {
    const lineAmt = (item.amount_cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
    doc.text(String(idx + 1), 22, rowY);
    doc.text(item.description, 32, rowY);
    doc.text('1.00', W - 76, rowY, { align: 'right' });
    doc.text(lineAmt, W - 54, rowY, { align: 'right' });
    doc.text(lineAmt, W - 20, rowY, { align: 'right' });
    rowY += 12;
  });

  const feeAmt = (total / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });

  // Light divider
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(18, rowY + 2, W - 18, rowY + 2);

  // Totals block
  let totY = rowY + 10;
  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  doc.text('Sub Total', W - 60, totY, { align: 'right' });
  doc.text(feeAmt, W - 20, totY, { align: 'right' });
  totY += 7;

  doc.setFont('helvetica', 'bold');
  doc.setTextColor(30, 30, 30);
  doc.text('Total', W - 60, totY, { align: 'right' });
  doc.text(`$${feeAmt}`, W - 20, totY, { align: 'right' });
  totY += 7;

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100, 100, 100);
  doc.text('Payment Made', W - 60, totY, { align: 'right' });
  doc.setTextColor(231, 76, 60);
  doc.text('(-) 0.00', W - 20, totY, { align: 'right' });
  totY += 7;

  doc.setLineWidth(0.5);
  doc.setDrawColor(0, 156, 180);
  doc.line(W - 80, totY - 2, W - 18, totY - 2);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(30, 30, 30);
  doc.text(isQuote ? 'Quoted Amount' : 'Balance Due', W - 60, totY + 4, { align: 'right' });
  doc.text(`$${feeAmt}`, W - 20, totY + 4, { align: 'right' });

  // ── Square Pay Button (invoices only)
  let payY = totY + 18;
  if (squarePayUrl && !isQuote) {
    doc.setFillColor(0, 156, 180);
    doc.roundedRect(18, payY, W - 36, 16, 3, 3, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(255, 255, 255);
    doc.text('Pay Online with Square  →', W / 2, payY + 7, { align: 'center' });
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(squarePayUrl, W / 2, payY + 12, { align: 'center' });
    doc.link(18, payY, W - 36, 16, { url: squarePayUrl });
    payY += 22;
  }

  // ── Notes & Terms
  payY += 4;
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(18, payY, W - 18, payY);
  payY += 6;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(140, 140, 140);
  doc.text('Notes', 18, payY);
  payY += 5;
  doc.setTextColor(80, 80, 80);
  if (isQuote) {
    doc.text('This is a quote/estimate only — not an invoice. Reply to accept, request changes, or provide a PO number.', 18, payY);
    payY += 5;
    doc.text('This quote is valid for 30 days from the date above.', 18, payY);
  } else {
    doc.text('Thank you for your continued support. As always, it has been my pleasure to collaborate with you!', 18, payY);
    payY += 5;
    doc.text('Please be sure to make a note of the correct, up-to-date mailing/billing address!', 18, payY);
  }
  payY += 8;

  doc.setTextColor(140, 140, 140);
  doc.text(isQuote ? 'Quote Terms' : 'Terms & Conditions', 18, payY);
  payY += 5;
  doc.setTextColor(80, 80, 80);
  if (isQuote) {
    doc.text('Quote valid for 30 days. Prices subject to change after expiration. Contact Ryan to renew.', 18, payY);
  } else {
    doc.text('Payment due within 30 days. After 30 days, 1.5% added monthly.', 18, payY);
    payY += 5;
    doc.text('Please verify the mailing address at the top of the invoice.', 18, payY);
  }

  // WMM logo — centered in footer below Terms & Conditions (2× size, same bottom edge)
  if (_wmmBlwLogoData) {
    const fLogoH = 28;
    const fLogoW = _wmmBlwLogoData.w * (fLogoH / _wmmBlwLogoData.h);
    doc.addImage(_wmmBlwLogoData.url, 'PNG', (W - fLogoW) / 2, H - 44, fLogoW, fLogoH);
  }

  // Footer line
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(18, H - 12, W - 18, H - 12);
  doc.setFontSize(8);
  doc.setTextColor(160, 160, 160);
  doc.text('1', W - 20, H - 6, { align: 'right' });

  return pdfToBase64(doc);
}

// ══════════════════════════════════════════════════════════════════════════
// ── Quote / Estimate Flow ─────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════

function generateQuotePDF(client, show, quoteNumber, items = null) {
  return generateInvoicePDF(client, show, quoteNumber, null, {
    isQuote: true,
    items: items || undefined
  });
}

async function openQuoteModal(client, show) {
  // Create modal dynamically if needed
  if (!document.getElementById('modal-send-quote')) {
    const m = document.createElement('div');
    m.id = 'modal-send-quote';
    m.className = 'modal-overlay';
    m.style.display = 'none';
    m.innerHTML = `
      <div class="modal-box">
        <div class="modal-header">
          <h3>Send Quote / Estimate</h3>
          <button class="modal-close" onclick="document.getElementById('modal-send-quote').style.display='none'">×</button>
        </div>
        <div id="quote-send-content"></div>
      </div>`;
    document.body.appendChild(m);
  }

  const modal = document.getElementById('modal-send-quote');
  const content = document.getElementById('quote-send-content');

  if (!client.email) {
    content.innerHTML = `<div class="empty-state" style="color:var(--danger);padding:16px">⚠ No email on file. Add an email address first.</div>`;
    modal.style.display = 'flex';
    return;
  }

  content.innerHTML = `<div style="padding:16px;color:var(--text-muted)">Loading quote number…</div>`;
  modal.style.display = 'flex';

  const year = show.season_year || new Date().getFullYear();
  const numRes = await api(`/quotes/next-number?year=${year}`);
  const quoteNumber = numRes.quote_number;
  const amount = show.fee_cents
    ? `$${(show.fee_cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
    : '—';

  content.innerHTML = `
    <div class="send-preview">
      <table class="send-preview-table">
        <tr><td>To</td><td><strong>${escapeHTML(client.name)}</strong> &lt;${escapeHTML(client.email)}&gt;</td></tr>
        <tr><td>School</td><td>${escapeHTML(client.org_name || '—')}</td></tr>
        <tr><td>Quote #</td><td><strong>${escapeHTML(quoteNumber)}</strong></td></tr>
        <tr><td>Amount</td><td>${amount}</td></tr>
        <tr><td>Year</td><td>${year}</td></tr>
      </table>
      <p class="send-note">A Quote/Estimate PDF will be generated and sent from your Gmail. The email will mention the PO process.</p>
      <div id="quote-send-status" style="display:none" class="send-status"></div>
    </div>
    <div class="modal-footer" id="quote-modal-footer">
      <button class="btn btn-ghost" onclick="document.getElementById('modal-send-quote').style.display='none'">Cancel</button>
      <button class="btn" id="btn-confirm-send-quote">Generate & Send Quote</button>
    </div>`;

  document.getElementById('btn-confirm-send-quote').addEventListener('click', () => {
    executeQuoteSend(client, show, quoteNumber);
  });
}

async function executeQuoteSend(client, show, quoteNumber) {
  const statusEl = document.getElementById('quote-send-status');
  const footer   = document.getElementById('quote-modal-footer');
  statusEl.style.display = 'block';
  footer.style.display = 'none';

  const setStatus = (msg, isErr = false) => {
    statusEl.innerHTML = `<span style="color:${isErr ? 'var(--danger)' : 'var(--comp-secondary)'}">${msg}</span>`;
  };

  try {
    setStatus('📄 Generating quote PDF…');
    const items = (show.invoice_items && show.invoice_items.length) ? show.invoice_items : null;
    const pdfBase64 = generateQuotePDF(client, show, quoteNumber, items);

    setStatus('📨 Sending via Gmail…');
    await api('/quotes/send', {
      method: 'POST',
      body: {
        show_id:      show.id,
        director_email: client.email,
        director_name:  client.name,
        school_name:    client.org_name,
        pdf_base64:     pdfBase64,
        quote_number:   quoteNumber,
        amount_cents:   show.fee_cents,
        year:           show.season_year,
        client_id:      client.id,
        season_year:    show.season_year,
        line_items:     items
      }
    });

    setStatus('✅ Quote sent!');
    setTimeout(() => {
      document.getElementById('modal-send-quote').style.display = 'none';
      loadFinancesTabAsync(client, show);
    }, 1500);
  } catch (err) {
    setStatus(`⚠ ${err.message}`, true);
    footer.style.display = 'flex';
    const btn = document.getElementById('btn-confirm-send-quote');
    btn.textContent = 'Retry';
    btn.onclick = () => executeQuoteSend(client, show, quoteNumber);
  }
}

// Async data loader for Quote + Payment Details sections in Bookkeeping tab
async function loadFinancesTabAsync(client, show) {
  // Load quote
  try {
    const quotes = await api(`/quotes?show_id=${show.id}`);
    renderQuoteSection(client, show, quotes[0] || null);
  } catch (e) {
    const el = document.getElementById('fin-quote-content');
    if (el) el.innerHTML = `<span style="color:var(--danger)">Failed to load quote data</span>`;
  }

  // Load invoice for payment details
  try {
    const data = await api(`/invoices?show_id=${show.id}`);
    renderPaymentDetails(show, data.invoices[0] || null);
  } catch (e) {
    const el = document.getElementById('fin-payment-content');
    if (el) el.innerHTML = `<span style="color:var(--danger)">Failed to load invoice data</span>`;
  }
}

function renderQuoteSection(client, show, quote) {
  const el = document.getElementById('fin-quote-content');
  if (!el) return;

  if (!quote) {
    el.innerHTML = `
      <div style="display:flex;align-items:center;gap:12px">
        <span class="finance-hint">No quote on file for this season.</span>
        <button class="btn btn-sm" id="btn-send-quote">📋 Send Quote</button>
      </div>`;
    document.getElementById('btn-send-quote')?.addEventListener('click', () => openQuoteModal(client, show));
    return;
  }

  const statusColor = { draft:'var(--text-muted)', sent:'var(--warning)', accepted:'var(--success)', declined:'var(--danger)', converted:'var(--comp-primary)' };
  const isEditable = ['sent', 'accepted'].includes(quote.status);

  el.innerHTML = `
    <div style="display:flex;align-items:center;gap:16px;flex-wrap:wrap">
      <span style="font-weight:600">${escapeHTML(quote.quote_number)}</span>
      <span style="color:${statusColor[quote.status] || 'var(--text)'}">● ${quote.status.toUpperCase()}</span>
      ${quote.issued_at ? `<span class="finance-hint">Sent ${new Date(quote.issued_at).toLocaleDateString()}</span>` : ''}
      ${quote.status === 'converted' && quote.converted_invoice_number ? `<span class="finance-hint">→ Invoice #${escapeHTML(quote.converted_invoice_number)}</span>` : ''}
    </div>
    <div style="display:flex;gap:8px;margin-top:10px;flex-wrap:wrap">
      ${quote.status === 'sent' ? `
        <button class="btn btn-sm btn-ghost" id="btn-quote-accepted">✓ Mark Accepted</button>
        <button class="btn btn-sm btn-ghost" style="color:var(--danger)" id="btn-quote-declined">✗ Mark Declined</button>` : ''}
      ${isEditable ? `<button class="btn btn-sm" id="btn-convert-invoice">→ Convert to Invoice</button>` : ''}
      <button class="btn btn-sm btn-ghost" id="btn-resend-quote">↺ Resend Quote</button>
    </div>`;

  document.getElementById('btn-quote-accepted')?.addEventListener('click', async () => {
    await api(`/quotes/${quote.id}`, { method: 'PATCH', body: { status: 'accepted' } });
    quote.status = 'accepted';
    renderQuoteSection(client, show, quote);
  });

  document.getElementById('btn-quote-declined')?.addEventListener('click', async () => {
    await api(`/quotes/${quote.id}`, { method: 'PATCH', body: { status: 'declined' } });
    quote.status = 'declined';
    renderQuoteSection(client, show, quote);
  });

  document.getElementById('btn-convert-invoice')?.addEventListener('click', async () => {
    await api(`/quotes/${quote.id}/convert`, { method: 'POST', body: {} });
    quote.status = 'converted';
    renderQuoteSection(client, show, quote);
    // Hand off to the normal invoice send flow
    const yearShow = state.allShows.find(s => s.id === show.id) || show;
    openInvoiceModal(client, yearShow);
  });

  document.getElementById('btn-resend-quote')?.addEventListener('click', () => openQuoteModal(client, show));
}

function renderPaymentDetails(show, invoice) {
  const el = document.getElementById('fin-payment-content');
  if (!el) return;

  if (!invoice) {
    el.innerHTML = `<span class="finance-hint">No invoice on file yet for this season.</span>`;
    return;
  }

  const methods = ['check', 'ach', 'zelle', 'square', 'venmo', 'cash', 'other'];
  const labels  = { check: 'Check', ach: 'ACH / Wire', zelle: 'Zelle', square: 'Square', venmo: 'Venmo', cash: 'Cash', other: 'Other' };

  el.innerHTML = `
    <div style="display:flex;gap:16px;flex-wrap:wrap;align-items:flex-end">
      <div class="form-group" style="max-width:220px">
        <label>School PO Number</label>
        <input type="text" id="fin-po-number" value="${escapeHTML(invoice.po_number || '')}" placeholder="e.g. PO-2026-1234" />
      </div>
      <div class="form-group">
        <label>Payment Method</label>
        <select id="fin-payment-method">
          <option value="">— not recorded —</option>
          ${methods.map(m => `<option value="${m}"${invoice.payment_method === m ? ' selected' : ''}>${labels[m]}</option>`).join('')}
        </select>
      </div>
      <div class="form-group">
        <label>Date Received</label>
        <input type="date" id="fin-payment-date" value="${invoice.payment_date ? invoice.payment_date.slice(0, 10) : ''}" />
      </div>
      <div class="form-group">
        <label>Check # / Reference</label>
        <input type="text" id="fin-payment-ref" value="${escapeHTML(invoice.payment_reference || '')}" placeholder="Check number or transaction ID" style="min-width:180px" />
      </div>
    </div>
    <div class="form-group" style="max-width:480px">
      <label>Payment Notes</label>
      <input type="text" id="fin-payment-notes" value="${escapeHTML(invoice.payment_notes || '')}" placeholder="Optional notes" />
    </div>
    <div style="display:flex;align-items:center;gap:10px;margin-top:4px">
      <button class="btn btn-sm" id="btn-save-payment">Save Payment Details</button>
      <span id="fin-payment-status" class="fin-save-status"></span>
    </div>`;

  document.getElementById('btn-save-payment')?.addEventListener('click', async () => {
    const statusEl = document.getElementById('fin-payment-status');
    statusEl.textContent = 'Saving…';
    try {
      await Promise.all([
        api(`/invoices/${invoice.id}/po`, {
          method: 'PATCH',
          body: { po_number: document.getElementById('fin-po-number').value || null }
        }),
        api(`/invoices/${invoice.id}/payment`, {
          method: 'PATCH',
          body: {
            payment_method:    document.getElementById('fin-payment-method').value || null,
            payment_date:      document.getElementById('fin-payment-date').value || null,
            payment_reference: document.getElementById('fin-payment-ref').value || null,
            payment_notes:     document.getElementById('fin-payment-notes').value || null
          }
        })
      ]);
      statusEl.textContent = '✓ Saved';
      setTimeout(() => { statusEl.textContent = ''; }, 2500);
    } catch (err) {
      statusEl.textContent = '⚠ ' + err.message;
    }
  });
}

// ══════════════════════════════════════════════════════════════════════════
// ── Contract Send Flow ────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════
window.openContractModal = openContractModal;
async function openContractModal(client, show) {
  const modal = document.getElementById('modal-send-contract');
  const content = document.getElementById('contract-send-content');

  const parts = (() => {
    const p = Array.isArray(show?.ensemble_parts) ? show.ensemble_parts
      : (show?.ensemble_parts ? JSON.parse(show.ensemble_parts) : []);
    const labels = { winds: 'Winds', battery: 'Battery', front_ensemble: 'Front Ensemble', sound_design: 'Sound Design' };
    return p.length ? p.map(x => labels[x] || x).join(', ') : '—';
  })();
  const fee = show?.fee_cents ? `$${(show.fee_cents / 100).toLocaleString()}` : '—';

  // Prefer show-level director fields — handles director changes between seasons
  const directorEmail = show?.director_email || client.email;
  const directorName  = show?.director_name  || client.name;

  if (!directorEmail) {
    content.innerHTML = `<div class="empty-state" style="color:var(--danger)">⚠ No email on file. Add the director's email to the show or client record first.</div>`;
    modal.style.display = 'flex';
    return;
  }

  content.innerHTML = `
    <div class="send-preview">
      <table class="send-preview-table">
        <tr>
          <td style="vertical-align:top;padding-top:5px;">To</td>
          <td>
            <input type="text"  id="contract-modal-name"  value="${escapeHTML(directorName)}"  placeholder="Director name"
              style="width:100%;background:#0d1520;border:1px solid rgba(255,255,255,.15);border-radius:4px;color:var(--text);padding:4px 7px;font-size:0.85rem;margin-bottom:4px;">
            <input type="email" id="contract-modal-email" value="${escapeHTML(directorEmail)}" placeholder="director@school.org"
              style="width:100%;background:#0d1520;border:1px solid rgba(255,255,255,.15);border-radius:4px;color:var(--text);padding:4px 7px;font-size:0.85rem;">
          </td>
        </tr>
        <tr><td>School</td><td>${escapeHTML(client.org_name || '—')}</td></tr>
        <tr><td>Ensemble Parts</td><td>${escapeHTML(parts)}</td></tr>
        <tr><td>Fee</td><td>${fee}</td></tr>
        <tr><td>Year</td><td>${show?.season_year || '—'}</td></tr>
      </table>
      <label style="display:flex;align-items:center;gap:0.5rem;margin-top:0.6rem;font-size:0.8rem;color:#7a9ab8;cursor:pointer;">
        <input type="checkbox" id="contract-modal-persist" checked style="accent-color:#00b4d8;">
        Save updated name/email to client record (cascades to future sends)
      </label>
      <p class="send-note" style="margin-top:0.5rem;">Claude AI will write a personalized email. The contract PDF will be generated, attached, and sent from your Gmail automatically.</p>
      <div id="contract-send-status" style="display:none" class="send-status"></div>
    </div>
    <div class="modal-footer" id="contract-modal-footer">
      <button class="btn btn-ghost" onclick="document.getElementById('modal-send-contract').style.display='none'">Cancel</button>
      <button class="btn" style="background:var(--warning);color:#fff" id="btn-confirm-send-contract">Generate & Send Contract</button>
    </div>`;

  document.getElementById('btn-confirm-send-contract').addEventListener('click', async () => {
    const editedName  = document.getElementById('contract-modal-name')?.value.trim()  || directorName;
    const editedEmail = document.getElementById('contract-modal-email')?.value.trim() || directorEmail;
    const persist     = document.getElementById('contract-modal-persist')?.checked;
    // Persist back to DB via canonical PATCH if values changed and checkbox is on
    if (persist && show?.id && (editedName !== directorName || editedEmail !== directorEmail)) {
      try {
        const patchBody = {};
        if (editedName  !== directorName)  patchBody.director_name  = editedName;
        if (editedEmail !== directorEmail) patchBody.director_email = editedEmail;
        await apiFetch(`/api/shows/${show.id}/director`, { method: 'PATCH', body: JSON.stringify(patchBody) });
        // Refresh _currentShow so subsequent opens use new values
        if (window._currentShow && window._currentShow.id === show.id) {
          if (patchBody.director_name)  window._currentShow.director_name  = editedName;
          if (patchBody.director_email) window._currentShow.director_email = editedEmail;
        }
      } catch (e) {
        console.warn('[contract modal] persist PATCH failed:', e.message);
      }
    }
    await executeSendContract(client, show, editedName, editedEmail);
  });

  modal.style.display = 'flex';
}

async function executeSendContract(client, show, directorName, directorEmail) {
  // Fall back to client fields if not resolved upstream (direct calls from app-legacy show rows)
  directorName  = directorName  || show?.director_name  || client.name;
  directorEmail = directorEmail || show?.director_email || client.email;
  const statusEl = document.getElementById('contract-send-status');
  const footer = document.getElementById('contract-modal-footer');
  statusEl.style.display = 'block';
  footer.style.display = 'none';

  function setStatus(msg, isError = false) {
    statusEl.innerHTML = `<span style="color:${isError ? 'var(--danger)' : 'var(--comp-secondary)'}">${msg}</span>`;
  }

  try {
    setStatus('📄 Generating contract PDF...');
    const pdfBase64 = generateContractPDF(client, show);

    setStatus('✍ Writing email with Claude AI...');
    // Send to backend (Claude call happens server-side)
    setStatus('📨 Sending via Gmail...');
    const result = await api('/contracts/send-contract', {
      method: 'POST',
      body: {
        show_id: show?.id,
        director_email: directorEmail,
        director_name:  directorName,
        school_name: client.org_name,
        pdf_base64: pdfBase64,
        year: show?.season_year || new Date().getFullYear()
      }
    });

    setStatus('✅ Contract sent! Updating client record...');

    // Update state
    if (show) {
      show.contract_sent = true;
      const idx = state.allShows.findIndex(s => s.id === show.id);
      if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], contract_sent: true };
    }
    patchClientCard(client.id, { contract_sent: true });

    setTimeout(() => {
      document.getElementById('modal-send-contract').style.display = 'none';
    }, 1800);

  } catch (err) {
    setStatus(`⚠ ${err.message}`, true);
    footer.style.display = 'flex';
    document.getElementById('btn-confirm-send-contract').textContent = 'Retry';
    document.getElementById('btn-confirm-send-contract').onclick = () => executeSendContract(client, show);
  }
}

// ══════════════════════════════════════════════════════════════════════════
// ── Invoice Send Flow ─────────────────────────────────════════════════════
// ══════════════════════════════════════════════════════════════════════════
async function openInvoiceModal(client, show) {
  const modal = document.getElementById('modal-send-invoice');
  const content = document.getElementById('invoice-send-content');

  if (!client.email) {
    content.innerHTML = `<div class="empty-state" style="color:var(--danger)">⚠ No email on file. Add an email address first.</div>`;
    modal.style.display = 'flex';
    return;
  }

  if (!show?.fee_cents) {
    content.innerHTML = `<div class="empty-state" style="color:var(--danger)">⚠ No fee set for this show. Set the fee before generating an invoice.</div>`;
    modal.style.display = 'flex';
    return;
  }

  const fee = `$${(show.fee_cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

  // Get next invoice number
  const { invoice_number: nextInvoice } = await api('/contracts/next-invoice-number');

  content.innerHTML = `
    <div class="send-preview">
      <table class="send-preview-table">
        <tr><td>To</td><td><strong>${escapeHTML(client.name)}</strong> &lt;${escapeHTML(client.email)}&gt;</td></tr>
        <tr><td>School</td><td>${escapeHTML(client.org_name || '—')}</td></tr>
        <tr><td>Invoice #</td><td><strong>${nextInvoice}</strong></td></tr>
        <tr><td>Amount</td><td><strong>${fee}</strong></td></tr>
        <tr><td>Year</td><td>${show?.season_year || '—'}</td></tr>
      </table>
      <p class="send-note">A Square payment link will be created, embedded in the PDF, and attached to a Claude AI–written email sent from your Gmail automatically.</p>
      <div id="invoice-send-status" style="display:none" class="send-status"></div>
    </div>
    <div class="modal-footer" id="invoice-modal-footer">
      <button class="btn btn-ghost" onclick="document.getElementById('modal-send-invoice').style.display='none'">Cancel</button>
      <button class="btn" style="background:var(--comp-primary);color:#fff" id="btn-confirm-send-invoice">Generate & Send Invoice</button>
    </div>`;

  document.getElementById('btn-confirm-send-invoice').addEventListener('click', async () => {
    await executeSendInvoice(client, show, nextInvoice);
  });

  modal.style.display = 'flex';
}

async function executeSendInvoice(client, show, invoiceNumber) {
  const statusEl = document.getElementById('invoice-send-status');
  const footer = document.getElementById('invoice-modal-footer');
  statusEl.style.display = 'block';
  footer.style.display = 'none';

  function setStatus(msg, isError = false) {
    statusEl.innerHTML = `<span style="color:${isError ? 'var(--danger)' : 'var(--comp-secondary)'}">${msg}</span>`;
  }

  const isSplit = show?.invoice_split && show?.invoice_split_amount_1_cents && show?.invoice_split_amount_2_cents;
  const items = show?.invoice_items && Array.isArray(show.invoice_items) && show.invoice_items.length ? show.invoice_items : null;

  try {
    if (isSplit) {
      // ── Split invoice: two PDFs, one email ────────────────────────────────
      const invoiceNumber2 = String(parseInt(invoiceNumber) + 1);
      const amt1 = show.invoice_split_amount_1_cents;
      const amt2 = show.invoice_split_amount_2_cents;

      setStatus('🔗 Creating Square payment links...');
      let payUrl1 = null, payUrl2 = null;
      try {
        const [sq1, sq2] = await Promise.all([
          api('/square/payment-link', { method: 'POST', body: { amount_cents: amt1, description: `Invoice #${invoiceNumber} — ${client.org_name}`, invoice_number: invoiceNumber } }),
          api('/square/payment-link', { method: 'POST', body: { amount_cents: amt2, description: `Invoice #${invoiceNumber2} — ${client.alt_payee_name}`, invoice_number: invoiceNumber2 } })
        ]);
        payUrl1 = sq1.url; payUrl2 = sq2.url;
      } catch (e) { console.warn('Square link failed:', e.message); }

      setStatus('🧾 Generating invoices...');
      const pdf1 = generateInvoicePDF(client, show, invoiceNumber, payUrl1, { amountCents: amt1 });
      const pdf2 = generateInvoicePDF(client, show, invoiceNumber2, payUrl2, {
        amountCents: amt2,
        payeeName: client.alt_payee_name,
        payeeAddress: {
          address_line1: client.alt_payee_address_line1,
          address_line2: client.alt_payee_address_line2,
          city: client.alt_payee_city,
          state: client.alt_payee_state,
          zip: client.alt_payee_zip
        }
      });

      setStatus('✍ Writing email with Claude AI...');
      setStatus('📨 Sending via Gmail...');

      await api('/contracts/send-split-invoice', {
        method: 'POST',
        body: {
          show_id: show.id,
          director_email: client.email,
          director_name: client.name,
          school_name: client.org_name,
          pdf_base64_1: pdf1,
          pdf_base64_2: pdf2,
          invoice_number_1: invoiceNumber,
          invoice_number_2: invoiceNumber2,
          amount_1_cents: amt1,
          amount_2_cents: amt2,
          payee_1_name: client.org_name,
          payee_2_name: client.alt_payee_name,
          year: show.season_year || new Date().getFullYear()
        }
      });

      setStatus('✅ Split invoices sent!');
      if (show) {
        show.invoiced = true;
        const idx = state.allShows.findIndex(s => s.id === show.id);
        if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], invoiced: true };
      }

    } else {
      // ── Standard invoice ─────────────────────────────────────────────────
      setStatus('🔗 Creating Square payment link...');
      let squarePayUrl = null;
      try {
        const squareRes = await api('/square/payment-link', {
          method: 'POST',
          body: {
            amount_cents: show.fee_cents,
            description: `Invoice #${invoiceNumber} - ${client.org_name} ${show.season_year}`,
            invoice_number: invoiceNumber
          }
        });
        squarePayUrl = squareRes.url;
        if (!squarePayUrl) throw new Error('Square returned no URL');
      } catch (squareErr) {
        setStatus(`⚠ Square link failed: ${squareErr.message} — continuing without payment link`, true);
        await new Promise(r => setTimeout(r, 2500));
      }

      setStatus('🧾 Generating invoice PDF...');
      const pdfBase64 = generateInvoicePDF(client, show, invoiceNumber, squarePayUrl,
        items ? { items } : {}
      );

      setStatus('✍ Writing email with Claude AI...');
      setStatus('📨 Sending via Gmail...');

      await api('/contracts/send-invoice', {
        method: 'POST',
        body: {
          show_id: show?.id,
          director_email: client.email,
          director_name: client.name,
          school_name: client.org_name,
          pdf_base64: pdfBase64,
          invoice_number: invoiceNumber,
          amount_cents: show.fee_cents,
          year: show?.season_year || new Date().getFullYear()
        }
      });

      setStatus('✅ Invoice sent! Updating client record...');
      if (show) {
        show.invoiced = true;
        show.invoice_number = invoiceNumber;
        const idx = state.allShows.findIndex(s => s.id === show.id);
        if (idx >= 0) state.allShows[idx] = { ...state.allShows[idx], invoiced: true, invoice_number: invoiceNumber };
      }
      patchClientCard(client.id, { invoiced: true, invoice_number: invoiceNumber });
    }

    setTimeout(() => {
      document.getElementById('modal-send-invoice').style.display = 'none';
    }, 1800);

  } catch (err) {
    setStatus(`⚠ ${err.message}`, true);
    footer.style.display = 'flex';
    document.getElementById('btn-confirm-send-invoice').textContent = 'Retry';
    document.getElementById('btn-confirm-send-invoice').onclick = () => executeSendInvoice(client, show, invoiceNumber);
  }
}

// ══════════════════════════════════════════════════════════════════════════
// ── Finances Tab ──────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════
function loadFinancesTab(client, show) {
  const el = document.getElementById('tab-finances');
  if (!el) return;

  const isSplit = show?.invoice_split;
  const hasItems = show?.invoice_items && Array.isArray(show.invoice_items) && show.invoice_items.length;
  const hasAltPayee = !!(client.alt_payee_name);

  const renderLineItems = () => {
    const items = show?.invoice_items || [];
    if (!items.length) return `<div class="fin-empty-items">No line items yet. Click "+ Add Line" below.</div>`;
    return items.map((item, i) => `
      <div class="fin-line-item" data-idx="${i}">
        <input class="fin-line-desc" type="text" value="${escapeHTML(item.description || '')}" placeholder="Description" />
        <input class="fin-line-amt" type="number" value="${item.amount_cents ? (item.amount_cents / 100).toFixed(2) : ''}" placeholder="0.00" min="0" step="0.01" />
        <button class="btn-fin-remove-line" data-idx="${i}">×</button>
      </div>`).join('');
  };

  const totalFmtd = show?.fee_cents ? `$${(show.fee_cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—';

  el.innerHTML = `
    <div class="finance-tab-wrap finance-tab-two-col">

      <!-- LEFT COLUMN: Fee, contract/invoice status, split/itemize -->
      <div class="fin-col-left">
        ${show ? `
        <div class="finance-section">
          <div class="finance-section-title">${show.season_year} Bookkeeping</div>

          <div class="form-group" style="max-width:200px">
            <label>Client Fee ($)</label>
            <input type="number" id="fin-fee-input" class="fee-input"
              value="${show.fee_cents ? (show.fee_cents / 100).toString() : ''}"
              placeholder="0" min="0" step="50" data-show-id="${show.id}" />
          </div>

          <div class="form-group">
            <label>Invoice Description</label>
            <input type="text" id="fin-invoice-desc" class="invoice-desc-input" data-show-id="${show.id}"
              placeholder="e.g. Show design + arrangement fee"
              value="${escapeHTML(show.invoice_description || '')}" />
          </div>

          <div class="fin-overrides-row">
            <label class="check-label check-label-override"><input type="checkbox" class="show-checkbox" data-show-id="${show.id}" data-field="no_contract" ${show.no_contract ? 'checked' : ''} /> No Contract Needed</label>
            <label class="check-label check-label-override"><input type="checkbox" class="show-checkbox" data-show-id="${show.id}" data-field="no_invoice" ${show.no_invoice ? 'checked' : ''} /> No Invoice Needed</label>
          </div>

          <div class="fin-status-checks" id="fin-status-checks-${show.id}" ${show.no_contract && show.no_invoice ? 'style="display:none"' : ''}>
            ${!show.no_contract ? `
            <label class="check-label"><input type="checkbox" class="show-checkbox" data-show-id="${show.id}" data-field="contract_sent" ${show.contract_sent ? 'checked' : ''} /> Contract Sent</label>
            <label class="check-label"><input type="checkbox" class="show-checkbox" data-show-id="${show.id}" data-field="contract_signed" ${show.contract_signed ? 'checked' : ''} /> Contract Signed</label>` : ''}
            ${!show.no_invoice ? `
            <label class="check-label"><input type="checkbox" class="show-checkbox" data-show-id="${show.id}" data-field="invoiced" ${show.invoiced ? 'checked' : ''} /> Invoiced</label>
            <label class="check-label"><input type="checkbox" class="show-checkbox" data-show-id="${show.id}" data-field="paid" ${show.paid ? 'checked' : ''} /> Paid</label>` : ''}
          </div>

          <hr class="finance-divider" style="margin:16px 0" />

          <div class="fin-toggle-row">
            <button class="btn btn-sm ${isSplit ? 'fin-toggle-on' : 'btn-ghost'}" id="fin-btn-split">Split Invoice</button>
            <button class="btn btn-sm ${hasItems ? 'fin-toggle-on' : 'btn-ghost'}" id="fin-btn-itemize">Itemize Invoice</button>
          </div>

          <div id="fin-split-section" class="fin-panel ${isSplit ? '' : 'fin-panel-hidden'}">
            <p class="finance-hint">Two separate invoices attached to one email. Set the alternate payee on the right first.</p>
            <div class="fin-split-row">
              <span class="fin-split-label">${escapeHTML(client.org_name)}</span>
              <div class="fin-split-input-wrap"><span class="fin-dollar">$</span><input type="number" id="fin-split-1" class="fin-split-input" min="0" step="0.01"
                value="${show.invoice_split_amount_1_cents ? (show.invoice_split_amount_1_cents / 100).toFixed(2) : ''}" placeholder="0.00" /></div>
            </div>
            <div class="fin-split-row">
              <span class="fin-split-label">${escapeHTML(client.alt_payee_name || '(set alt payee →)')}</span>
              <div class="fin-split-auto">$<span id="fin-split-2-display">—</span></div>
            </div>
            <p class="fin-fee-note">Show fee: ${totalFmtd}</p>
          </div>

          <div id="fin-itemize-section" class="fin-panel ${hasItems && !isSplit ? '' : 'fin-panel-hidden'}">
            <p class="finance-hint">Replaces the standard single-line invoice with itemized amounts.</p>
            <div id="fin-line-items-list">${renderLineItems()}</div>
            <button class="btn btn-ghost btn-sm" id="fin-add-line" style="margin-top:8px">+ Add Line</button>
            <div class="fin-items-total">Running total: $<span id="fin-items-total-display">0.00</span> <span class="finance-hint">(show fee: ${totalFmtd})</span></div>
          </div>

          <button class="btn" id="btn-save-billing" style="margin-top:20px">Save Billing Settings</button>
          <span id="fin-billing-status" class="fin-save-status"></span>
        </div>
        ` : '<div class="empty-state" style="padding:16px">No show for this season. Add a season first.</div>'}
      </div>

      <!-- RIGHT COLUMN: Alternate Payee + Quote + Payment Details -->
      <div class="fin-col-right">
        ${show ? `
        <div class="finance-section">
          <div class="finance-section-title">Quote / Estimate</div>
          <div id="fin-quote-content"><span class="finance-hint">Loading…</span></div>
        </div>
        <div class="finance-section" style="margin-top:16px">
          <div class="finance-section-title">Payment Details</div>
          <div id="fin-payment-content"><span class="finance-hint">Loading…</span></div>
        </div>
        ` : ''}
        <div class="finance-section" style="margin-top:16px">
          <div class="finance-section-header">
            <div class="finance-section-title">Alternate Payee</div>
            ${hasAltPayee ? `<span class="fin-payee-set-badge">${escapeHTML(client.alt_payee_name)}</span>` : ''}
          </div>
          <p class="finance-hint">If billing goes to a different organization than the school, enter their info here. Persists across all seasons for this client.</p>
          <div class="form-group"><label>Organization Name</label>
            <input type="text" id="fin-alt-name" value="${escapeHTML(client.alt_payee_name || '')}" placeholder="e.g. Band Parents Association" />
          </div>
          <div class="form-group"><label>Address Line 1</label>
            <input type="text" id="fin-alt-addr1" value="${escapeHTML(client.alt_payee_address_line1 || '')}" />
          </div>
          <div class="form-group"><label>Address Line 2 <span style="opacity:0.5;font-weight:400">(optional)</span></label>
            <input type="text" id="fin-alt-addr2" value="${escapeHTML(client.alt_payee_address_line2 || '')}" placeholder="optional" />
          </div>
          <div class="form-row">
            <div class="form-group" style="flex:2"><label>City</label>
              <input type="text" id="fin-alt-city" value="${escapeHTML(client.alt_payee_city || '')}" />
            </div>
            <div class="form-group"><label>State</label>
              <input type="text" id="fin-alt-state" maxlength="2" style="width:60px" value="${escapeHTML(client.alt_payee_state || '')}" />
            </div>
            <div class="form-group"><label>Zip</label>
              <input type="text" id="fin-alt-zip" maxlength="10" style="width:90px" value="${escapeHTML(client.alt_payee_zip || '')}" />
            </div>
          </div>
          <button class="btn btn-sm" id="btn-save-alt-payee">Save Payee</button>
          <span id="fin-payee-status" class="fin-save-status"></span>
        </div>
      </div>

    </div>`;

  // ── Wire alt payee save ──────────────────────────────────────────────
  document.getElementById('btn-save-alt-payee')?.addEventListener('click', async () => {
    const statusEl = document.getElementById('fin-payee-status');
    statusEl.textContent = 'Saving...';
    try {
      const updated = await api(`/clients/${client.id}/finance`, {
        method: 'PATCH',
        body: {
          alt_payee_name:           document.getElementById('fin-alt-name').value || null,
          alt_payee_address_line1:  document.getElementById('fin-alt-addr1').value || null,
          alt_payee_address_line2:  document.getElementById('fin-alt-addr2').value || null,
          alt_payee_city:           document.getElementById('fin-alt-city').value || null,
          alt_payee_state:          document.getElementById('fin-alt-state').value || null,
          alt_payee_zip:            document.getElementById('fin-alt-zip').value || null
        }
      });
      // Update state
      const idx = state.clients.findIndex(c => c.id === client.id);
      if (idx >= 0) state.clients[idx] = { ...state.clients[idx], ...updated };
      Object.assign(client, updated);
      statusEl.textContent = '✓ Saved';
      setTimeout(() => { statusEl.textContent = ''; }, 2500);
    } catch (err) {
      statusEl.textContent = '⚠ ' + err.message;
    }
  });

  if (!show) return;

  // ── Contract/invoice status checkboxes ───────────────────────────────
  // These are rendered lazily (after renderClientDetail's global querySelectorAll
  // already ran), so they need their own listeners wired here.
  el.querySelectorAll('.show-checkbox').forEach(cb => {
    cb.addEventListener('change', async () => {
      const field = cb.dataset.field;
      const value = cb.checked;
      try {
        await api(`/shows/${show.id}/field`, { method: 'PATCH', body: { field, value } });
      } catch (err) {
        cb.checked = !value; // revert on failure
        return;
      }
      show[field] = value;
      const idx = state.allShows.findIndex(s => s.id === show.id);
      if (idx >= 0) state.allShows[idx][field] = value;
      patchClientCard(client.id, { [field]: value });
      if (field === 'no_contract' || field === 'no_invoice') {
        const checksRow = document.getElementById(`fin-status-checks-${show.id}`);
        if (checksRow) checksRow.style.display = (show.no_contract && show.no_invoice) ? 'none' : '';
      }
    });
  });

  // ── Bookkeeping: fee input ────────────────────────────────────────────
  document.getElementById('fin-fee-input')?.addEventListener('change', async e => {
    const val = parseFloat(e.target.value || 0);
    const cents = Math.round(val * 100);
    await api(`/shows/${show.id}/field`, { method: 'PATCH', body: { field: 'fee_cents', value: cents } });
    const idx = state.allShows.findIndex(x => x.id === show.id);
    if (idx >= 0) state.allShows[idx].fee_cents = cents;
    show.fee_cents = cents;
  });

  // ── Bookkeeping: invoice description ─────────────────────────────────
  document.getElementById('fin-invoice-desc')?.addEventListener('change', async e => {
    await api(`/shows/${show.id}/field`, { method: 'PATCH', body: { field: 'invoice_description', value: e.target.value || null } });
    const idx = state.allShows.findIndex(x => x.id === show.id);
    if (idx >= 0) state.allShows[idx].invoice_description = e.target.value || null;
  });

  // ── Split toggle ─────────────────────────────────────────────────────
  const splitBtn = document.getElementById('fin-btn-split');
  const splitSection = document.getElementById('fin-split-section');
  splitBtn?.addEventListener('click', () => {
    const on = splitSection.classList.toggle('fin-panel-hidden');
    splitBtn.classList.toggle('fin-toggle-on', !on);
    // Turn off itemize when split is on
    if (!on) {
      document.getElementById('fin-itemize-section')?.classList.add('fin-panel-hidden');
      document.getElementById('fin-btn-itemize')?.classList.remove('fin-toggle-on');
    }
  });

  // ── Itemize toggle ───────────────────────────────────────────────────
  const itemizeBtn = document.getElementById('fin-btn-itemize');
  const itemizeSection = document.getElementById('fin-itemize-section');
  itemizeBtn?.addEventListener('click', () => {
    const on = itemizeSection.classList.toggle('fin-panel-hidden');
    itemizeBtn.classList.toggle('fin-toggle-on', !on);
    if (!on) recalcItemsTotal();
  });

  // ── Split amount auto-calc ───────────────────────────────────────────
  document.getElementById('fin-split-1')?.addEventListener('input', () => {
    const fee = (show.fee_cents || 0) / 100;
    const v = parseFloat(document.getElementById('fin-split-1').value) || 0;
    const remainder = Math.max(fee - v, 0);
    document.getElementById('fin-split-2-display').textContent = remainder.toFixed(2);
  });
  // Initialize display
  if (show.invoice_split_amount_1_cents && show.fee_cents) {
    const rem = Math.max((show.fee_cents - show.invoice_split_amount_1_cents) / 100, 0);
    const disp = document.getElementById('fin-split-2-display');
    if (disp) disp.textContent = rem.toFixed(2);
  }

  // ── Line items: add / remove / recalc ───────────────────────────────
  function recalcItemsTotal() {
    const amts = [...document.querySelectorAll('.fin-line-amt')].map(i => parseFloat(i.value) || 0);
    const total = amts.reduce((s, v) => s + v, 0);
    const el = document.getElementById('fin-items-total-display');
    if (el) el.textContent = total.toFixed(2);
  }

  document.getElementById('fin-add-line')?.addEventListener('click', () => {
    const list = document.getElementById('fin-line-items-list');
    const idx = list.querySelectorAll('.fin-line-item').length;
    const div = document.createElement('div');
    div.className = 'fin-line-item';
    div.dataset.idx = idx;
    div.innerHTML = `
      <input class="fin-line-desc" type="text" placeholder="Description" />
      <input class="fin-line-amt" type="number" placeholder="0.00" min="0" step="0.01" />
      <button class="btn-fin-remove-line" data-idx="${idx}">×</button>`;
    list.appendChild(div);
    div.querySelector('.fin-line-amt').addEventListener('input', recalcItemsTotal);
    div.querySelector('.btn-fin-remove-line').addEventListener('click', e => {
      e.target.closest('.fin-line-item').remove();
      recalcItemsTotal();
    });
  });

  // Wire existing remove buttons and amt inputs
  document.querySelectorAll('.btn-fin-remove-line').forEach(btn => {
    btn.addEventListener('click', e => {
      e.target.closest('.fin-line-item').remove();
      recalcItemsTotal();
    });
  });
  document.querySelectorAll('.fin-line-amt').forEach(inp => {
    inp.addEventListener('input', recalcItemsTotal);
  });
  recalcItemsTotal();

  // ── Save billing settings ─────────────────────────────────────────────
  document.getElementById('btn-save-billing')?.addEventListener('click', async () => {
    const statusEl = document.getElementById('fin-billing-status');
    statusEl.textContent = 'Saving...';

    const splitOn = !document.getElementById('fin-split-section')?.classList.contains('fin-panel-hidden');
    const itemizeOn = !document.getElementById('fin-itemize-section')?.classList.contains('fin-panel-hidden');

    let amt1 = null, amt2 = null;
    if (splitOn) {
      const v = parseFloat(document.getElementById('fin-split-1').value) || 0;
      amt1 = Math.round(v * 100);
      amt2 = Math.max((show.fee_cents || 0) - amt1, 0);
    }

    let invoiceItems = null;
    if (itemizeOn && !splitOn) {
      const rows = [...document.querySelectorAll('.fin-line-item')];
      invoiceItems = rows.map(row => ({
        description: row.querySelector('.fin-line-desc').value.trim(),
        amount_cents: Math.round((parseFloat(row.querySelector('.fin-line-amt').value) || 0) * 100)
      })).filter(i => i.description);
    }

    try {
      const updated = await api(`/shows/${show.id}/billing`, {
        method: 'PATCH',
        body: {
          invoice_split: splitOn,
          invoice_split_amount_1_cents: amt1,
          invoice_split_amount_2_cents: amt2,
          invoice_items: invoiceItems
        }
      });
      // Update show in state
      const sIdx = state.allShows.findIndex(s => s.id === show.id);
      if (sIdx >= 0) state.allShows[sIdx] = { ...state.allShows[sIdx], ...updated };
      Object.assign(show, updated);
      statusEl.textContent = '✓ Saved';
      setTimeout(() => { statusEl.textContent = ''; }, 2500);
    } catch (err) {
      statusEl.textContent = '⚠ ' + err.message;
    }
  });

  // ── Load async sections (Quote + Payment Details) ─────────────────────
  loadFinancesTabAsync(client, show);
}

// ══════════════════════════════════════════════════════════════════════════
// ── Inbox View ────────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════

async function renderInboxView() {
  try {
    const [actionItems, holdingItems, gmailStatus, confirmItems] = await Promise.all([
      api('/intake/actions'),
      api('/intake/holding'),
      api('/gmail/status'),
      api('/competition-intel/pending-confirms')
    ]);

    renderGmailAccountsRow(gmailStatus);
    renderActionItems(actionItems);
    renderScheduleConfirms(confirmItems);
    renderHoldingQueue(holdingItems);
    updateInboxBadge();
    loadAgentApiKey();
  } catch (err) {
    console.error('renderInboxView:', err.message);
  }
}

async function loadAgentApiKey() {
  try {
    const data = await api('/agent/api-key');
    const input = document.getElementById('agent-key-display');
    if (input) input.value = data.key || '';
  } catch (e) { /* silent */ }

  document.getElementById('btn-copy-agent-key')?.addEventListener('click', () => {
    const val = document.getElementById('agent-key-display')?.value;
    if (val) {
      const full = `GET https://crm.whitemagemusic.com/api/v1/agent/context\nX-Api-Key: ${val}`;
      navigator.clipboard.writeText(full);
      showToast('API key copied');
    }
  });

  document.getElementById('btn-regen-agent-key')?.addEventListener('click', async () => {
    if (!confirm('Regenerate the API key? The old key will stop working immediately.')) return;
    try {
      const data = await api('/agent/api-key/regenerate', { method: 'POST' });
      const input = document.getElementById('agent-key-display');
      if (input) input.value = data.key;
      showToast('New API key generated');
    } catch (e) {
      showToast('Error generating key', 'error');
    }
  });
}

function renderGmailAccountsRow(status) {
  const row = document.getElementById('gmail-accounts-row');
  if (!row) return;
  row.innerHTML = `
    <div class="gmail-account-chip ${status.wmm ? 'connected' : 'disconnected'}">
      <span class="gmail-chip-dot"></span>
      <span>WMM (Ryan@whitemagemusic.com)</span>
      ${status.wmm
        ? `<a class="gmail-chip-link gmail-chip-disconnect" href="#" onclick="disconnectGmail('wmm');return false;">Disconnect</a>`
        : `<a class="gmail-chip-link" href="/auth/google?account=wmm">Connect</a>`}
    </div>
    <div class="gmail-account-chip ${status.personal ? 'connected' : 'disconnected'}">
      <span class="gmail-chip-dot"></span>
      <span>Personal (ryan@ryanjwilliams.net)</span>
      ${status.personal
        ? `<a class="gmail-chip-link gmail-chip-disconnect" href="#" onclick="disconnectGmail('personal');return false;">Disconnect</a>`
        : `<a class="gmail-chip-link" href="/auth/google?account=personal">Connect</a>`}
    </div>
    <div class="gmail-account-chip ${status.david ? 'connected' : 'disconnected'}">
      <span class="gmail-chip-dot"></span>
      <span>David (david@whitemagemusic.com)</span>
      ${status.david
        ? `<a class="gmail-chip-link gmail-chip-disconnect" href="#" onclick="disconnectGmail('david');return false;">Disconnect</a>`
        : `<a class="gmail-chip-link" href="/auth/google?account=david">Connect</a>`}
    </div>
    <div class="gmail-account-chip icloud">
      <span class="gmail-chip-dot always-on"></span>
      <span>iCloud MarchingBand folder (ryanwms@mac.com)</span>
    </div>
  `;
}

function renderInfoItems(items) {
  const container = document.getElementById('inbox-info-items');
  const countEl = document.getElementById('info-count');
  if (!container) return;
  if (countEl) countEl.textContent = items.length;

  // Cache items for the reply modal
  items.forEach(item => { state.inboxItemsById[item.id] = item; });

  if (!items.length) {
    container.innerHTML = '<div class="inbox-empty">No new info items</div>';
    return;
  }

  container.innerHTML = items.map(item => `
    <div class="inbox-item" data-id="${item.id}">
      <div class="inbox-item-top">
        <span class="inbox-type-badge inbox-type-${item.type}">${typeLabel(item.type)}</span>
        <span class="inbox-client">${escapeHTML(item.client_name || item.org_name || 'Unknown')}</span>
        <span class="inbox-time">${timeAgo(item.created_at)}</span>
      </div>
      <div class="inbox-item-title">${escapeHTML(item.title || '')}</div>
      ${item.original_body
        ? `<div class="inbox-item-full-body">${formatNoteBody(item.original_body)}</div>`
        : `<div class="inbox-item-summary">${escapeHTML(item.summary || '')}</div>`}
      ${item.review_note ? `<div class="inbox-review-note">${escapeHTML(item.review_note)}</div>` : ''}
      <div class="inbox-item-actions">
        ${item.reply_to ? `<button class="btn-inline btn-reply-email" onclick="openReplyModal(${item.id})">↩ Reply</button>` : ''}
        ${item.client_id ? `<button class="btn-inline" onclick="navigateToClient(${item.client_id})">View Client</button>` : ''}
        <button class="btn-inline btn-dismiss" onclick="dismissInboxItem(${item.id}, this)">Dismiss</button>
      </div>
    </div>
  `).join('');
}

function renderActionItems(items) {
  const container = document.getElementById('inbox-action-items');
  const countEl = document.getElementById('action-count');
  if (!container) return;
  if (countEl) countEl.textContent = items.length;

  // Cache for reply modal
  items.forEach(item => { state.inboxItemsById[item.id] = item; });

  if (!items.length) {
    container.innerHTML = '<div class="inbox-empty">No open action items</div>';
    return;
  }

  const clientOptions = state.clients
    .filter(c => c.org_name)
    .sort((a, b) => a.org_name.localeCompare(b.org_name))
    .map(c => `<option value="${c.id}">${escapeHTML(c.org_name)}</option>`)
    .join('');

  container.innerHTML = items.map(item => `
    <div class="inbox-item inbox-action" data-id="${item.id}">
      <div class="inbox-item-top">
        <span class="priority-badge priority-${item.priority}">${item.priority}</span>
        <span class="inbox-client">${escapeHTML(item.client_name || item.org_name || '⚠ Unassigned')}</span>
        <span class="inbox-time">${timeAgo(item.created_at)}</span>
      </div>
      <div class="inbox-item-title">${escapeHTML(item.title || '')}</div>
      ${item.original_body
        ? `<div class="inbox-item-full-body">${formatNoteBody(item.original_body)}</div>`
        : `<div class="inbox-item-summary">${escapeHTML(item.body || '')}</div>`}
      <div class="inbox-item-actions">
        ${item.reply_to ? `<button class="btn-inline btn-reply-email" onclick="openReplyModal(${item.id})">↩ Reply</button>` : ''}
        ${item.client_id ? `<button class="btn-inline" onclick="navigateToClient(${item.client_id})">View Client</button>` : ''}
        <button class="btn-inline btn-complete" onclick="completeActionItem(${item.id}, this)">Mark Complete</button>
        <button class="btn-inline btn-dismiss-action" onclick="dismissActionItem(${item.id}, this)">Dismiss</button>
      </div>
      <div class="action-assign-row">
        <select class="action-assign-select" id="assign-select-${item.id}">
          <option value="">${item.client_id ? '— Reassign to different client —' : '— Assign to client —'}</option>
          ${clientOptions.replace(`value="${item.client_id}"`, `value="${item.client_id}" selected`)}
        </select>
        <button class="btn-inline btn-assign-action" onclick="assignActionItem(${item.id}, this)">${item.client_id ? 'Reassign' : 'Assign'}</button>
      </div>
    </div>
  `).join('');
}

async function assignActionItem(id, btn) {
  const select = document.getElementById(`assign-select-${id}`);
  const clientId = select?.value;
  if (!clientId) return;
  btn.disabled = true;
  btn.textContent = '…';
  await api(`/intake/actions/${id}/assign`, { method: 'PATCH', body: { client_id: parseInt(clientId) } });
  loadInboxData();
}

async function dismissActionItem(id, btn) {
  btn.disabled = true;
  btn.textContent = '…';
  await api(`/intake/actions/${id}`, { method: 'DELETE' });
  loadInboxData();
}

async function renderHoldingQueue(items) {
  const container = document.getElementById('holding-queue-items');
  const countEl = document.getElementById('holding-count');
  if (!container) return;
  if (countEl) countEl.textContent = items.length;

  if (!items.length) {
    container.innerHTML = '<div class="inbox-empty">Nothing in the holding queue</div>';
    return;
  }

  // Build client dropdown options
  const clientOptions = state.clients
    .filter(c => c.org_name)
    .sort((a, b) => a.org_name.localeCompare(b.org_name))
    .map(c => `<option value="${c.id}">${escapeHTML(c.org_name)}</option>`)
    .join('');

  container.innerHTML = items.map(item => {
    const extracted = item.extracted_data || {};
    const summary = extracted.summary || extracted.revision_summary || extracted.inquiry_summary
      || extracted.raw_summary || item.raw_content?.slice(0, 120) || '';

    return `
      <div class="holding-item" data-id="${item.id}">
        <div class="holding-item-meta">
          <span class="inbox-type-badge inbox-type-unclassifiable">${item.source_type || 'email'}</span>
          <span class="holding-from">${escapeHTML(item.from_email || '')}</span>
          <span class="inbox-time">${timeAgo(item.created_at)}</span>
        </div>
        <div class="inbox-item-title">${escapeHTML(item.subject || '(no subject)')}</div>
        <div class="holding-summary">${escapeHTML(summary)}</div>
        <div class="holding-assign-row">
          <select class="holding-client-select" id="holding-select-${item.id}">
            <option value="">-- Select Client --</option>
            ${clientOptions}
          </select>
          <button class="btn-inline btn-assign" onclick="assignHoldingItem(${item.id})">Assign</button>
          <button class="btn-inline btn-dismiss" onclick="dismissHoldingItem(${item.id}, this)">Dismiss</button>
        </div>
      </div>
    `;
  }).join('');
}

// ── Inbox Actions ─────────────────────────────────────────────────────────

async function dismissInboxItem(id, btn) {
  btn.disabled = true;
  try {
    await api(`/intake/inbox/${id}`, { method: 'DELETE' });
    btn.closest('.inbox-item').remove();
    updateInboxBadge();
  } catch (err) {
    btn.disabled = false;
    alert(err.message);
  }
}

async function completeActionItem(id, btn) {
  btn.disabled = true;
  try {
    await api(`/intake/actions/${id}/complete`, { method: 'POST', body: {} });
    btn.closest('.inbox-item').remove();
  } catch (err) {
    btn.disabled = false;
    alert(err.message);
  }
}

async function assignHoldingItem(id) {
  const select = document.getElementById(`holding-select-${id}`);
  const clientId = select?.value;
  if (!clientId) { alert('Select a client first.'); return; }
  const btn = select.parentElement.querySelector('.btn-assign');
  if (btn) btn.disabled = true;
  try {
    await api(`/intake/holding/${id}/assign`, { method: 'POST', body: { client_id: clientId } });
    document.querySelector(`.holding-item[data-id="${id}"]`)?.remove();
    const countEl = document.getElementById('holding-count');
    if (countEl) countEl.textContent = Math.max(0, parseInt(countEl.textContent || '0') - 1);
  } catch (err) {
    if (btn) btn.disabled = false;
    alert(err.message);
  }
}

async function dismissHoldingItem(id, btn) {
  btn.disabled = true;
  try {
    await api(`/intake/holding/${id}`, { method: 'DELETE' });
    document.querySelector(`.holding-item[data-id="${id}"]`)?.remove();
    const countEl = document.getElementById('holding-count');
    if (countEl) countEl.textContent = Math.max(0, parseInt(countEl.textContent || '0') - 1);
  } catch (err) {
    btn.disabled = false;
    alert(err.message);
  }
}

function navigateToClient(clientId) {
  state.previousView = 'inbox';
  openClient(clientId);
}

// ── Inbox Badge ───────────────────────────────────────────────────────────

async function updateInboxBadge() {
  try {
    const res = await fetch('/api/intake/stats', { credentials: 'include' });
    if (!res.ok) return;
    const stats = await res.json();
    const count = stats.needs_review || 0;
    const badge = document.getElementById('inbox-badge');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count > 99 ? '99+' : count;
      badge.style.display = 'inline-block';
    } else {
      badge.style.display = 'none';
    }
  } catch {}
}

// ── Inbox Scan Now button ─────────────────────────────────────────────────

document.getElementById('btn-scan-now')?.addEventListener('click', async (e) => {
  const btn = e.target;
  btn.disabled = true;
  btn.textContent = 'Scanning...';
  try {
    await api('/intake/scan', { method: 'POST', body: {} });
    setTimeout(async () => {
      await renderInboxView();
      btn.disabled = false;
      btn.textContent = 'Scan Now';
    }, 3000);
  } catch (err) {
    btn.disabled = false;
    btn.textContent = 'Scan Now';
    alert(err.message);
  }
});

document.getElementById('btn-gmail-connect-wmm')?.addEventListener('click', () => {
  window.location.href = '/auth/google?account=wmm';
});

document.getElementById('btn-gmail-connect-personal')?.addEventListener('click', () => {
  window.location.href = '/auth/google?account=personal';
});

// ── Helpers ───────────────────────────────────────────────────────────────

function typeLabel(type) {
  const map = {
    info: 'Info', action: 'Action', copyright: 'Copyright',
    drive_link: 'Drive', tresona_new: 'Tresona', tresona_update: 'Tresona',
    feedback: 'Feedback', client_inquiry: 'Inquiry', general_info: 'Info',
    unclassifiable: '?'
  };
  return map[type] || type;
}

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return formatDate(dateStr);
}

// ══════════════════════════════════════════════════════════════════════════
// ── Copyright Tab ─────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════

// ── Copyright Overview (nav view) ──────────────────────────────────────────
let _crOverviewData = [];

async function loadCopyrightOverview() {
  const container = document.getElementById('copyright-overview-content');
  if (!container) return;
  container.innerHTML = '<div class="empty-state">Loading…</div>';
  try {
    _crOverviewData = await api('/copyright/overview');
    renderCopyrightOverview();
  } catch (err) {
    container.innerHTML = `<div class="empty-state">Error: ${escapeHTML(err.message)}</div>`;
  }
}

function renderCopyrightOverview() {
  const container = document.getElementById('copyright-overview-content');
  if (!container) return;

  const filterStatus = document.getElementById('cr-filter-status')?.value || '';
  const filterSource = document.getElementById('cr-filter-source')?.value || '';
  const filterSearch = (document.getElementById('cr-filter-client')?.value || '').toLowerCase();

  const now = new Date();
  const fourWeeksMs = 28 * 24 * 60 * 60 * 1000;

  // Each row is one song (or one song-less record); filter uses record_status + song_title + song_artist + client_name
  let rows = _crOverviewData.filter(r => {
    if (filterStatus && r.record_status !== filterStatus) return false;
    if (filterSource && r.source !== filterSource) return false;
    if (filterSearch) {
      const clientMatch = (r.client_name || '').toLowerCase().includes(filterSearch);
      const songMatch   = (r.song_title  || '').toLowerCase().includes(filterSearch);
      const artistMatch = (r.song_artist || '').toLowerCase().includes(filterSearch);
      if (!clientMatch && !songMatch && !artistMatch) return false;
    }
    return true;
  });

  if (!rows.length) {
    container.innerHTML = '<div class="empty-state">No copyright records match the current filters.</div>';
    return;
  }

  const statusBadge = s => {
    const map = { pending: ['cr-status-pending','Pending'], approved: ['cr-status-approved','Approved'], denied: ['cr-status-denied','Denied'] };
    const [cls, label] = map[s] || ['cr-status-pending', s || 'Pending'];
    return `<span class="cr-status-badge ${cls}">${label}</span>`;
  };

  const sourceBadge = s => {
    const map = { tresona: 'Tresona', direct: 'Direct', public_domain: 'Pub. Domain', other: 'Other' };
    return `<span class="cr-source-badge cr-source-${s || 'other'}">${map[s] || s || '—'}</span>`;
  };

  const tableRows = rows.map(r => {
    const dueDate  = r.show_due_date ? new Date(r.show_due_date) : null;
    const isUrgent = r.record_status === 'pending' && dueDate && (dueDate - now) < fourWeeksMs && (dueDate - now) > 0;
    const songTitle = r.song_title ? escapeHTML(r.song_title) : '<span style="opacity:0.4">—</span>';
    const artistDisplay = r.song_artist
      ? `<span class="cr-artist-text" data-song-id="${r.song_id}">${escapeHTML(r.song_artist)}</span>`
      : (r.song_id ? `<span class="cr-artist-text cr-artist-empty" data-song-id="${r.song_id}" style="opacity:0.4;cursor:pointer;">+ artist</span>` : '');
    return `
      <tr class="cr-overview-row ${isUrgent ? 'cr-row-urgent' : ''}" data-id="${r.id}">
        <td class="cr-ov-song">${songTitle}</td>
        <td class="cr-ov-artist">${artistDisplay}</td>
        <td class="cr-ov-client">
          ${r.client_id ? `<a class="cr-client-link" data-client-id="${r.client_id}">${escapeHTML(r.client_name || '—')}</a>` : escapeHTML(r.client_name || '—')}
        </td>
        <td class="cr-ov-show">${escapeHTML(r.show_title || '—')} ${r.season_year ? `<span class="cr-ov-year">'${String(r.season_year).slice(-2)}</span>` : ''}</td>
        <td class="cr-ov-req">${r.request_number ? `#${escapeHTML(r.request_number)}` : '—'}</td>
        <td class="cr-ov-status">
          ${statusBadge(r.record_status)}
          <select class="cr-status-select cr-ov-select" data-id="${r.id}">
            <option value="pending"  ${r.record_status==='pending'  ? 'selected':''}>Pending</option>
            <option value="approved" ${r.record_status==='approved' ? 'selected':''}>Approved</option>
            <option value="denied"   ${r.record_status==='denied'   ? 'selected':''}>Denied</option>
          </select>
        </td>
        <td class="cr-ov-source">${sourceBadge(r.source)}</td>
        <td class="cr-ov-confirm">
          ${r.confirmed_by === 'auto'
            ? `<button class="btn-cr-confirm" data-id="${r.id}" title="Confirm agent's interpretation">⚠ Confirm</button>`
            : `<span class="cr-confirmed-label">✓</span>`}
        </td>
        <td class="cr-ov-updated">${formatDate(r.updated_at)}</td>
        <td class="cr-ov-reassign">
          <button class="btn-cr-reassign btn btn-ghost btn-sm" data-id="${r.id}" title="Reassign to a different client">↺ Reassign</button>
        </td>
      </tr>`;
  }).join('');

  const pendingCount = [...new Set(rows.filter(r => r.record_status === 'pending').map(r => r.id))].length;

  container.innerHTML = `
    <table class="cr-overview-table">
      <thead>
        <tr>
          <th>Song</th><th>Artist</th><th>Client</th><th>Show</th><th>Request #</th>
          <th>Status</th><th>Source</th><th>Confirmed</th><th>Updated</th><th></th>
        </tr>
      </thead>
      <tbody>${tableRows}</tbody>
    </table>
    <div class="cr-overview-footer">${rows.length} song${rows.length !== 1 ? 's' : ''}${pendingCount ? ` · <span style="color:var(--warning)">${pendingCount} record${pendingCount !== 1 ? 's' : ''} pending</span>` : ''}</div>
  `;

  // Inline artist edit — click to edit
  container.querySelectorAll('.cr-artist-text').forEach(span => {
    span.style.cursor = 'pointer';
    span.addEventListener('click', () => {
      const songId = span.dataset.songId;
      const current = span.classList.contains('cr-artist-empty') ? '' : span.textContent;
      const input = document.createElement('input');
      input.type = 'text';
      input.value = current;
      input.className = 'cr-artist-input';
      input.style.cssText = 'font-size:inherit;background:var(--bg-input,#1e1b2e);color:inherit;border:1px solid var(--accent);border-radius:4px;padding:2px 6px;width:140px;';
      span.replaceWith(input);
      input.focus();
      const save = async () => {
        const val = input.value.trim();
        await api(`/copyright/song/${songId}/artist`, { method: 'PATCH', body: { artist: val } });
        const rowData = _crOverviewData.find(r => r.song_id === parseInt(songId));
        if (rowData) rowData.song_artist = val || null;
        renderCopyrightOverview();
      };
      input.addEventListener('blur', save);
      input.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        if (e.key === 'Escape') { renderCopyrightOverview(); }
      });
    });
  });

  // Bind status selects
  container.querySelectorAll('.cr-ov-select').forEach(sel => {
    sel.addEventListener('change', async () => {
      await api(`/copyright/${sel.dataset.id}`, { method: 'PUT', body: { status: sel.value } });
      _crOverviewData = await api('/copyright/overview');
      renderCopyrightOverview();
    });
  });

  // Bind confirm buttons
  container.querySelectorAll('.btn-cr-confirm').forEach(btn => {
    btn.addEventListener('click', async () => {
      await api(`/copyright/${btn.dataset.id}/confirm`, { method: 'PATCH' });
      _crOverviewData.filter(r => r.id === parseInt(btn.dataset.id)).forEach(r => r.confirmed_by = 'ryan');
      renderCopyrightOverview();
    });
  });

  // Bind client name links → navigate to client detail copyright tab
  container.querySelectorAll('.cr-client-link').forEach(link => {
    link.addEventListener('click', () => {
      openClient(parseInt(link.dataset.clientId), 'copyright');
    });
  });

  // Bind reassign buttons
  container.querySelectorAll('.btn-cr-reassign').forEach(btn => {
    btn.addEventListener('click', async () => {
      const crId = btn.dataset.id;
      const td = btn.closest('td');

      // Build a select of marching clients + their current shows
      const marchingClients = (state.clients || []).filter(c => c.ensemble_type === 'marching');
      if (!marchingClients.length) { alert('No marching clients found.'); return; }

      // Load shows for each marching client (use allShows cache if available)
      const shows = state.allShows?.filter(s => marchingClients.some(c => c.id === s.client_id)) || [];

      let optionsHTML = '<option value="">— pick a show —</option>';
      for (const c of marchingClients) {
        const clientShows = shows.filter(s => s.client_id === c.id);
        if (clientShows.length) {
          optionsHTML += `<optgroup label="${escapeHTML(c.org_name)}">`;
          clientShows.forEach(s => {
            optionsHTML += `<option value="${s.id}">${escapeHTML(s.title || `${s.season_year} Season`)}</option>`;
          });
          optionsHTML += `</optgroup>`;
        } else {
          optionsHTML += `<option value="" disabled>${escapeHTML(c.org_name)} — no shows</option>`;
        }
      }

      td.innerHTML = `
        <select class="cr-reassign-select" style="font-size:12px;max-width:180px">${optionsHTML}</select>
        <button class="btn btn-ghost btn-sm cr-reassign-confirm" style="margin-left:4px">✓</button>
        <button class="btn btn-ghost btn-sm cr-reassign-cancel">✕</button>`;

      td.querySelector('.cr-reassign-cancel').addEventListener('click', () => {
        renderCopyrightOverview();
      });

      td.querySelector('.cr-reassign-confirm').addEventListener('click', async () => {
        const showId = parseInt(td.querySelector('.cr-reassign-select').value);
        if (!showId) { alert('Please select a show.'); return; }
        try {
          await api(`/copyright/${crId}/reassign`, { method: 'PATCH', body: { show_id: showId } });
          _crOverviewData = await api('/copyright/overview');
          renderCopyrightOverview();
        } catch (err) {
          alert('Reassign failed: ' + err.message);
        }
      });
    });
  });
}

async function loadCopyrightTab(clientId) {
  const tab = document.getElementById('tab-copyright');
  if (!tab) return;

  try {
    const records = await api(`/copyright/client/${clientId}`);
    tab.innerHTML = `<div id="copyright-advisor-panel" class="copyright-advisor-panel"><div class="ai-summary-loading">David is scanning clearances…</div></div>` + renderCopyrightTab(records, clientId);
    bindCopyrightEvents(clientId);
    loadCopyrightAdvisor(clientId);
  } catch (err) {
    tab.innerHTML = `<div class="empty-state">Error loading copyright records: ${escapeHTML(err.message)}</div>`;
  }
}

async function loadCopyrightAdvisor(clientId, refresh = false) {
  const panel = document.getElementById('copyright-advisor-panel');
  if (!panel) return;
  try {
    const data = await api(`/clients/${clientId}/copyright-advisor${refresh ? '?force=true' : ''}`, { method: 'POST' });
    const text = data.advisor || data.briefing || '';
    const cachedAt = data.cached_at || '';
    if (!text) {
      panel.innerHTML = '';
      return;
    }
    const age = cachedAt
      ? `<span class="ai-summary-age">Delta-only · Refreshes daily · Last run ${timeAgo(cachedAt)}</span>`
      : '';
    panel.innerHTML = `
      <div class="ai-summary-card advisor-panel">
        <div class="david-panel-header">
          <img src="David_Thorne_2.png" class="david-avatar-sm" alt="David Thorne" />
          <div class="ai-summary-label">David Thorne — The Tactician ${age}</div>
        </div>
        <div class="ai-summary-body">${window.WMM_ROLE === 'viewer' ? '<em style="opacity:0.4">Analysis hidden in viewer mode.</em>' : escapeHTML(text)}</div>
        <button class="btn btn-ghost btn-sm cr-advisor-rescan">↺ Refresh Now</button>
      </div>`;
    panel.querySelector('.cr-advisor-rescan')?.addEventListener('click', () => {
      loadCopyrightAdvisor(clientId, true);
    });
  } catch {
    panel.innerHTML = '';
  }
}

function renderCopyrightTab(records, clientId) {
  const statusBadge = (s) => {
    const map = {
      pending: ['cr-status-pending', 'Pending'],
      approved: ['cr-status-approved', 'Approved'],
      denied: ['cr-status-denied', 'Denied'],
      invoiced: ['cr-status-invoiced', 'Invoiced']
    };
    const [cls, label] = map[s] || ['cr-status-pending', s || 'Pending'];
    return `<span class="cr-status-badge ${cls}">${label}</span>`;
  };

  const songStatusBadge = (s) => {
    const map = { approved: 'cr-song-approved', denied: 'cr-song-denied', pending: 'cr-song-pending' };
    return `<span class="cr-song-badge ${map[s] || 'cr-song-pending'}">${s || 'pending'}</span>`;
  };

  if (!records.length) {
    return `
      <div class="cr-empty">
        <p>No copyright records yet. They'll appear here automatically when Tresona emails arrive,
        or you can add one manually.</p>
        <button class="btn btn-ghost btn-sm" id="btn-add-copyright">+ Add Record</button>
      </div>`;
  }

  // Group by season year
  const byYear = {};
  records.forEach(r => {
    const yr = r.season_year || 'Unassigned';
    if (!byYear[yr]) byYear[yr] = [];
    byYear[yr].push(r);
  });

  const sections = Object.entries(byYear)
    .sort(([a], [b]) => b - a)
    .map(([year, recs]) => `
      <div class="cr-year-section">
        <div class="cr-year-label">${year} Season</div>
        ${recs.map(r => `
          <div class="cr-record" data-id="${r.id}">
            <div class="cr-record-header">
              <div class="cr-record-info">
                <span class="cr-request-num">${r.source === 'tresona' ? 'Tresona' : 'Direct'} ${r.request_number ? `#${r.request_number}` : ''}</span>
                ${r.org_name ? `<span class="cr-org">${escapeHTML(r.org_name)}</span>` : ''}
                ${r.show_title ? `<span class="cr-show">${escapeHTML(r.show_title)}</span>` : ''}
              </div>
              <div class="cr-record-status">
                ${r.confirmed_by === 'auto' ? `<button class="btn-cr-confirm btn-cr-confirm-tab" data-id="${r.id}" title="Agent parsed — click to confirm">⚠ Unconfirmed</button>` : ''}
                ${statusBadge(r.status)}
                <select class="cr-status-select" data-id="${r.id}" title="Update status">
                  <option value="pending" ${r.status === 'pending' ? 'selected' : ''}>Pending</option>
                  <option value="approved" ${r.status === 'approved' ? 'selected' : ''}>Approved</option>
                  <option value="denied" ${r.status === 'denied' ? 'selected' : ''}>Denied</option>
                  <option value="invoiced" ${r.status === 'invoiced' ? 'selected' : ''}>Invoiced</option>
                </select>
                <label class="cr-invoice-label" title="Invoice paid">
                  <input type="checkbox" class="cr-invoice-cb-tab" data-id="${r.id}" ${r.invoice_paid ? 'checked' : ''} />
                  Paid
                </label>
              </div>
            </div>
            ${r.songs?.length ? `
              <div class="cr-songs">
                ${r.songs.map(s => `
                  <div class="cr-song-row">
                    <span class="cr-song-title">${escapeHTML(s.title || '')}</span>
                    ${songStatusBadge(s.status)}
                    ${s.fee_cents ? `<span class="cr-song-fee">$${(s.fee_cents / 100).toFixed(2)}</span>` : ''}
                  </div>
                `).join('')}
              </div>` : ''}
          </div>
        `).join('')}
      </div>
    `).join('');

  return `
    <div class="cr-toolbar">
      <button class="btn btn-ghost btn-sm" id="btn-add-copyright">+ Add Record</button>
    </div>
    ${sections}
  `;
}

function bindCopyrightEvents(clientId) {
  // Status dropdown changes
  document.querySelectorAll('.cr-status-select').forEach(sel => {
    sel.addEventListener('change', async () => {
      const id = sel.dataset.id;
      try {
        await api(`/copyright/${id}`, { method: 'PUT', body: { status: sel.value } });
        await loadCopyrightTab(clientId);
      } catch (err) {
        alert(err.message);
      }
    });
  });

  // Invoice paid checkboxes (client tab)
  document.querySelectorAll('.cr-invoice-cb-tab').forEach(cb => {
    cb.addEventListener('change', async () => {
      await api(`/copyright/${cb.dataset.id}`, { method: 'PUT', body: { status: cb.checked ? 'invoiced' : 'approved', invoice_paid: cb.checked } });
      await loadCopyrightTab(clientId);
    });
  });

  // Confirm buttons (client tab)
  document.querySelectorAll('.btn-cr-confirm-tab').forEach(btn => {
    btn.addEventListener('click', async () => {
      await api(`/copyright/${btn.dataset.id}/confirm`, { method: 'PATCH' });
      await loadCopyrightTab(clientId);
    });
  });

  document.getElementById('btn-add-copyright')?.addEventListener('click', () => {
    // Simple prompt for now — Session 4 will get a proper modal
    const reqNum = prompt('Tresona Request # (or leave blank for direct):');
    const org = prompt('Organization / School name:');
    if (!org) return;
    const client = state.clients.find(c => c.id === state.currentClientId);
    const show = state.allShows.find(s => s.client_id === state.currentClientId && parseInt(s.season_year) === state.clientDetailYear);
    api('/copyright', {
      method: 'POST',
      body: { show_id: show?.id || null, request_number: reqNum || null, org_name: org, source: reqNum ? 'tresona' : 'direct' }
    }).then(() => loadCopyrightTab(clientId)).catch(e => alert(e.message));
  });
}

// ══════════════════════════════════════════════════════════════════════════
// ── Invoices View ─────────────────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════

async function renderInvoicesView() {
  const summaryBar = document.getElementById('invoice-summary-bar');
  const tableWrap = document.getElementById('invoice-table-wrap');
  if (!summaryBar || !tableWrap) return;

  // Populate year filter once
  const yearSel = document.getElementById('inv-filter-year');
  if (yearSel && !yearSel.dataset.populated) {
    const currentYear = new Date().getFullYear();
    yearSel.innerHTML = `<option value="">All Years</option>` +
      [currentYear, currentYear-1, currentYear-2].map(y => `<option value="${y}">${y}</option>`).join('');
    yearSel.dataset.populated = '1';
    yearSel.addEventListener('change', renderInvoicesView);
    document.getElementById('inv-filter-status')?.addEventListener('change', renderInvoicesView);
  }

  const year = document.getElementById('inv-filter-year')?.value || '';
  const status = document.getElementById('inv-filter-status')?.value || 'all';

  tableWrap.innerHTML = '<div class="empty-state">Loading...</div>';

  try {
    const params = new URLSearchParams();
    if (year) params.set('year', year);
    if (status !== 'all') params.set('status', status);
    const { invoices, summary } = await api(`/invoices?${params}`);

    const fmt = cents => cents ? `$${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '$0.00';

    summaryBar.innerHTML = `
      <div class="inv-stat inv-stat-outstanding">
        <div class="inv-stat-label">Outstanding</div>
        <div class="inv-stat-value">${fmt(summary.outstanding_cents)}</div>
        <div class="inv-stat-sub">${summary.outstanding_count} invoice${summary.outstanding_count != 1 ? 's' : ''}</div>
      </div>
      <div class="inv-stat inv-stat-paid">
        <div class="inv-stat-label">Paid (YTD)</div>
        <div class="inv-stat-value">${fmt(summary.paid_ytd_cents)}</div>
      </div>
      <div class="inv-stat inv-stat-alltime">
        <div class="inv-stat-label">All-Time Revenue</div>
        <div class="inv-stat-value">${fmt(summary.paid_cents)}</div>
      </div>
      <div class="inv-stat inv-stat-writtenoff">
        <div class="inv-stat-label">Written Off</div>
        <div class="inv-stat-value">${fmt(summary.written_off_cents)}</div>
      </div>`;

    if (!invoices.length) {
      tableWrap.innerHTML = '<div class="empty-state" style="padding:40px">No invoices found.</div>';
      return;
    }

    const statusBadge = s => {
      const map = { outstanding: 'badge-warning', paid: 'badge-success', written_off: 'badge-neutral' };
      const label = { outstanding: 'Outstanding', paid: 'Paid', written_off: 'Written Off' };
      return `<span class="badge ${map[s] || 'badge-neutral'}">${label[s] || s}</span>`;
    };

    const dueDateCell = (inv) => {
      if (inv.status !== 'outstanding') {
        return inv.due_date ? `<span class="inv-due-date">${formatDate(inv.due_date)}</span>` : '—';
      }
      const val = inv.due_date ? inv.due_date.split('T')[0] : '';
      const overdueClass = inv.due_date && new Date(inv.due_date) < new Date() ? ' inv-due-overdue' : '';
      return `<input type="date" class="inv-due-input${overdueClass}" data-id="${inv.id}" value="${val}" title="Set due date for follow-up reminders" />`;
    };

    tableWrap.innerHTML = `
      <table class="invoice-ledger-table">
        <thead>
          <tr>
            <th>Invoice #</th>
            <th>Issued</th>
            <th>Due Date</th>
            <th>Client</th>
            <th>Payee</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          ${invoices.map(inv => `
            <tr class="inv-row" data-id="${inv.id}" data-status="${inv.status}">
              <td class="inv-num">${escapeHTML(inv.invoice_number)}</td>
              <td>${inv.issued_at ? formatDate(inv.issued_at) : '—'}</td>
              <td class="inv-due-cell">${dueDateCell(inv)}</td>
              <td>${escapeHTML(inv.org_name || inv.client_name || '—')}</td>
              <td class="inv-payee">${escapeHTML(inv.payee_name && inv.payee_name !== inv.org_name ? inv.payee_name : '—')}</td>
              <td class="inv-amount">${fmt(inv.amount_cents)}</td>
              <td>${statusBadge(inv.status)}</td>
              <td class="inv-actions">
                ${inv.status === 'outstanding' ? `
                  <button class="btn btn-sm inv-btn-paid" data-id="${inv.id}" title="Mark Paid">✓ Paid</button>
                  <button class="btn btn-ghost btn-sm inv-btn-writeoff" data-id="${inv.id}" title="Write Off">Write Off</button>
                ` : ''}
                <button class="btn btn-ghost btn-sm inv-btn-delete" data-id="${inv.id}" title="Delete">🗑</button>
              </td>
            </tr>
            ${inv.notes ? `<tr class="inv-notes-row"><td colspan="8"><span class="inv-note-text">📝 ${escapeHTML(inv.notes)}</span></td></tr>` : ''}
          `).join('')}
        </tbody>
      </table>`;

    // Wire actions
    tableWrap.querySelectorAll('.inv-btn-paid').forEach(btn => {
      btn.addEventListener('click', async () => {
        if (!confirm('Mark this invoice as paid?')) return;
        await api(`/invoices/${btn.dataset.id}`, { method: 'PATCH', body: { status: 'paid' } });
        // Fire automation trigger (non-blocking)
        fetch('/api/automations/trigger', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ event: 'invoice_paid', client_id: state.currentClientId })
        }).catch(err => console.warn('Automation trigger failed (non-blocking):', err));
        renderInvoicesView();
      });
    });
    tableWrap.querySelectorAll('.inv-btn-writeoff').forEach(btn => {
      btn.addEventListener('click', async () => {
        if (!confirm('Write off this invoice? It will remain on record but marked as uncollected.')) return;
        await api(`/invoices/${btn.dataset.id}`, { method: 'PATCH', body: { status: 'written_off' } });
        renderInvoicesView();
      });
    });
    tableWrap.querySelectorAll('.inv-btn-delete').forEach(btn => {
      btn.addEventListener('click', async () => {
        if (!confirm('Delete this invoice? This will clear it from the client record and free the invoice number.')) return;
        await api(`/invoices/${btn.dataset.id}`, { method: 'DELETE' });
        renderInvoicesView();
      });
    });

    tableWrap.querySelectorAll('.inv-due-input').forEach(input => {
      input.addEventListener('change', async () => {
        try {
          await api(`/invoices/${input.dataset.id}/due-date`, { method: 'PATCH', body: { due_date: input.value || null } });
          if (input.value && new Date(input.value) < new Date()) {
            input.classList.add('inv-due-overdue');
          } else {
            input.classList.remove('inv-due-overdue');
          }
        } catch (err) {
          alert('Could not save due date: ' + err.message);
        }
      });
    });

  } catch (err) {
    tableWrap.innerHTML = `<div class="empty-state" style="color:var(--danger)">Error: ${err.message}</div>`;
  }
}

// ══════════════════════════════════════════════════════════════════════════
// BROADCAST COMPOSER
// ══════════════════════════════════════════════════════════════════════════

let _broadcastInited = false;
let _bcMode = 'single';
let _bcYear = 'current';
let _bcRecipients = [];

async function initBroadcastComposer() {
  // Collapse/expand toggle
  const panel = document.getElementById('broadcast-panel');
  const toggle = document.getElementById('broadcast-panel-toggle');
  if (toggle && panel && !toggle.dataset.bound) {
    toggle.dataset.bound = '1';
    toggle.addEventListener('click', () => panel.classList.toggle('collapsed'));
  }

  // Populate client dropdown once
  const clientSel = document.getElementById('bc-client-select');
  if (clientSel && !clientSel.dataset.populated) {
    clientSel.dataset.populated = '1';
    try {
      const clients = await api('/clients');
      const sorted = [...clients].sort((a, b) => (a.org_name || a.name || '').localeCompare(b.org_name || b.name || ''));
      sorted.forEach(c => {
        const opt = document.createElement('option');
        opt.value = c.id;
        opt.textContent = c.org_name || c.name;
        clientSel.appendChild(opt);
      });
    } catch { /* non-fatal */ }
  }

  // Populate year select dropdown
  const yearDropdown = document.getElementById('bc-year-select');
  if (yearDropdown && !yearDropdown.dataset.populated) {
    yearDropdown.dataset.populated = '1';
    const cur = new Date().getFullYear();
    [cur, cur-1, cur-2, cur-3].forEach(y => {
      const opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      yearDropdown.appendChild(opt);
    });
    yearDropdown.addEventListener('change', () => loadRecipients());
  }

  if (_broadcastInited) return;
  _broadcastInited = true;

  const draftBtn    = document.getElementById('bc-btn-draft');
  const sendBtn     = document.getElementById('bc-btn-send');
  const redraftBtn  = document.getElementById('bc-btn-redraft');
  const draftWrap   = document.getElementById('bc-draft-wrap');
  const sentMsg     = document.getElementById('bc-sent-msg');
  const progressMsg = document.getElementById('bc-sending-progress');

  // ── Mode tabs ──
  document.querySelectorAll('.bc-mode-tab').forEach(tab => {
    tab.addEventListener('click', async () => {
      document.querySelectorAll('.bc-mode-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      _bcMode = tab.dataset.mode;
      _bcRecipients = [];
      draftWrap.style.display = 'none';

      const singleFields = document.getElementById('bc-single-fields');
      const multiFields  = document.getElementById('bc-multi-fields');
      const roleField    = document.getElementById('bc-role-field');

      if (_bcMode === 'single') {
        singleFields.style.display = '';
        multiFields.style.display = 'none';
      } else {
        singleFields.style.display = 'none';
        multiFields.style.display = '';
        roleField.style.display = _bcMode === 'role' ? '' : 'none';
        if (_bcMode === 'role') await loadRoles();
        await loadRecipients();
      }
    });
  });

  // ── Year tabs ──
  document.querySelectorAll('.bc-year-tab').forEach(tab => {
    tab.addEventListener('click', async () => {
      document.querySelectorAll('.bc-year-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      _bcYear = tab.dataset.year;
      const yearDropdown = document.getElementById('bc-year-select');
      yearDropdown.style.display = _bcYear === 'select' ? '' : 'none';
      await loadRecipients();
    });
  });

  // ── Role select ──
  document.getElementById('bc-role-select')?.addEventListener('change', () => loadRecipients());

  // ── Recipient list toggle ──
  document.getElementById('bc-preview-toggle')?.addEventListener('click', () => {
    const listEl = document.getElementById('bc-recipient-list');
    const btn = document.getElementById('bc-preview-toggle');
    const hidden = listEl.style.display === 'none';
    listEl.style.display = hidden ? '' : 'none';
    btn.textContent = hidden ? 'Hide list' : 'Show list';
  });

  // ── Draft ──
  async function runDraft() {
    const prompt = document.getElementById('bc-prompt').value.trim();
    if (!prompt) { alert('Tell Claude what you want to say.'); return; }

    if (_bcMode === 'single') {
      const toEmail = document.getElementById('bc-to-email').value.trim();
      if (!toEmail) { alert('To Email is required.'); return; }
    } else {
      if (!_bcRecipients.length) { alert('No recipients found for the selected filters.'); return; }
    }

    draftBtn.disabled = true;
    draftBtn.textContent = 'Drafting…';
    draftWrap.style.display = 'none';
    sentMsg.style.display = 'none';
    if (progressMsg) progressMsg.style.display = 'none';

    try {
      let draft;
      if (_bcMode === 'single') {
        const toName  = document.getElementById('bc-to-name').value.trim();
        const toEmail = document.getElementById('bc-to-email').value.trim();
        const clientId = document.getElementById('bc-client-select').value;
        const res = await api('/broadcast/draft', {
          method: 'POST',
          body: { to_name: toName, to_email: toEmail, prompt, client_id: clientId || undefined }
        });
        draft = res.draft;
      } else {
        const modeLabel = bcModeLabel();
        const res = await api('/broadcast/draft-bulk', {
          method: 'POST',
          body: { prompt, mode_label: modeLabel }
        });
        draft = res.draft;
      }
      document.getElementById('bc-draft-body').value = draft;
      draftWrap.style.display = '';
      // Update send button label for bulk
      if (_bcMode !== 'single') {
        sendBtn.textContent = `Send to ${_bcRecipients.length} recipient${_bcRecipients.length !== 1 ? 's' : ''}`;
      } else {
        sendBtn.textContent = 'Send';
      }
    } catch (err) {
      alert('Draft failed: ' + err.message);
    } finally {
      draftBtn.disabled = false;
      draftBtn.textContent = 'Draft with Claude';
    }
  }

  draftBtn?.addEventListener('click', runDraft);
  redraftBtn?.addEventListener('click', runDraft);

  // ── Send ──
  sendBtn?.addEventListener('click', async () => {
    const subject = document.getElementById('bc-subject').value.trim();
    const body    = document.getElementById('bc-draft-body').value.trim();
    if (!subject || !body) { alert('Subject and email body are required.'); return; }

    sendBtn.disabled = true;
    sentMsg.style.display = 'none';

    if (_bcMode === 'single') {
      const toName  = document.getElementById('bc-to-name').value.trim();
      const toEmail = document.getElementById('bc-to-email').value.trim();
      const clientId = document.getElementById('bc-client-select').value;
      if (!toEmail) { alert('To Email is required.'); sendBtn.disabled = false; return; }
      sendBtn.textContent = 'Sending…';
      try {
        await api('/broadcast/send', { method: 'POST', body: { to_name: toName, to_email: toEmail, subject, body, client_id: clientId || undefined } });
        sentMsg.textContent = '✓ Sent';
        sentMsg.style.display = '';
        clearBroadcastForm();
      } catch (err) {
        alert('Send failed: ' + err.message);
      } finally {
        sendBtn.disabled = false;
        sendBtn.textContent = 'Send';
      }
    } else {
      // Bulk send
      const total = _bcRecipients.length;
      if (!total) { alert('No recipients.'); sendBtn.disabled = false; return; }
      if (!confirm(`Send this email to ${total} recipient${total !== 1 ? 's' : ''}?`)) { sendBtn.disabled = false; return; }

      sendBtn.textContent = 'Sending…';
      if (progressMsg) { progressMsg.textContent = `Sending to ${total} recipients…`; progressMsg.style.display = ''; }
      try {
        const { sent, failed } = await api('/broadcast/send-bulk', {
          method: 'POST',
          body: { recipients: _bcRecipients, subject, body }
        });
        sentMsg.textContent = `✓ Sent to ${sent}${failed ? ` · ${failed} failed` : ''}`;
        sentMsg.style.display = '';
        if (progressMsg) progressMsg.style.display = 'none';
        clearBroadcastForm();
      } catch (err) {
        alert('Bulk send failed: ' + err.message);
      } finally {
        sendBtn.disabled = false;
        sendBtn.textContent = `Send to ${total} recipient${total !== 1 ? 's' : ''}`;
      }
    }
  });
}

function bcModeLabel() {
  const yearSuffix = _bcYear === 'all' ? 'all years' : _bcYear === 'select'
    ? (document.getElementById('bc-year-select')?.value || 'selected year')
    : `${new Date().getFullYear()} season`;
  if (_bcMode === 'clients') return `all band directors (${yearSuffix})`;
  if (_bcMode === 'everyone') return `all contacts (${yearSuffix})`;
  if (_bcMode === 'role') {
    const role = document.getElementById('bc-role-select')?.value || 'selected role';
    return `${role} (${yearSuffix})`;
  }
  return '';
}

async function loadRoles() {
  const sel = document.getElementById('bc-role-select');
  if (!sel || sel.dataset.populated) return;
  sel.dataset.populated = '1';
  try {
    const roles = await api('/broadcast/roles');
    sel.innerHTML = '<option value="">— Pick a role —</option>' +
      roles.map(r => `<option value="${escapeHTML(r)}">${escapeHTML(r)}</option>`).join('');
  } catch { sel.innerHTML = '<option value="">Error loading roles</option>'; }
}

async function loadRecipients() {
  const countEl = document.getElementById('bc-recipient-count');
  const toggleBtn = document.getElementById('bc-preview-toggle');
  const listEl = document.getElementById('bc-recipient-list');
  if (!countEl) return;

  const year = _bcYear === 'all' ? null
    : _bcYear === 'select' ? (document.getElementById('bc-year-select')?.value || null)
    : new Date().getFullYear();

  const role = _bcMode === 'role' ? (document.getElementById('bc-role-select')?.value || '') : undefined;

  countEl.textContent = 'Loading…';
  _bcRecipients = [];

  try {
    const recipients = await api('/broadcast/recipients', {
      method: 'POST',
      body: { mode: _bcMode, year: year || undefined, role }
    });
    _bcRecipients = recipients;
    countEl.textContent = `${recipients.length} recipient${recipients.length !== 1 ? 's' : ''} selected`;
    if (toggleBtn) toggleBtn.style.display = recipients.length ? '' : 'none';
    if (listEl) {
      listEl.style.display = 'none';
      if (toggleBtn) toggleBtn.textContent = 'Show list';
      listEl.innerHTML = recipients.map(r =>
        `<div class="bc-recipient-item">
          <span class="bc-rec-name">${escapeHTML(r.name || '—')}</span>
          <span class="bc-rec-org">${escapeHTML(r.org_name || '')}</span>
          <span class="bc-rec-email">${escapeHTML(r.email)}</span>
        </div>`
      ).join('') || '<div class="bc-recipient-item">No recipients found</div>';
    }
  } catch (err) {
    countEl.textContent = 'Error loading recipients';
    _bcRecipients = [];
  }
}

function clearBroadcastForm() {
  setTimeout(() => {
    ['bc-to-name','bc-to-email','bc-subject','bc-prompt','bc-draft-body'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });
    const clientSel = document.getElementById('bc-client-select');
    if (clientSel) clientSel.value = '';
    const draftWrap = document.getElementById('bc-draft-wrap');
    if (draftWrap) draftWrap.style.display = 'none';
    const sentMsg = document.getElementById('bc-sent-msg');
    if (sentMsg) sentMsg.style.display = 'none';
  }, 4000);
}

// ── David Thorne Personality Strings ──────────────────────────────────────

const _davidLoadingPhrases = {
  schedule:   ["David's checking the calendar…", "David's doing the math nobody else bothered to do…", "Computing how far behind you are…"],
  briefing:   ["David's reviewing the file…", "David's pulling the intel…", "David's reading every note you should've already read…"],
  materials:  ["David's scanning the stacks…", "David's cross-referencing. Give him a second.", "David's finding music you may or may not have cleared."],
  copyright:  ["David's checking clearance status…", "David's seeing who owes us what…", "David's navigating the licensing swamp."],
  calendar:   ["David's mapping the timeline…", "David's laying out the battlefield."],
  default:    ["David's on it…", "David's working…", "Stand by."]
};

function davidLoading(context = 'default') {
  const opts = _davidLoadingPhrases[context] || _davidLoadingPhrases.default;
  const phrase = opts[Math.floor(Math.random() * opts.length)];
  return `<div class="ai-summary-loading">${phrase}</div>`;
}

const _davidErrorPhrases = [
  "Bad rep. Reset. Try again.",
  "Connection dropped. Not our finest moment.",
  "Timed out. Server's having a bad day. Hit refresh.",
  "Something broke. Probably not your fault. Try again.",
  "Request failed. That's not a plan. That's a problem."
];

function davidError(msg) {
  const phrase = _davidErrorPhrases[Math.floor(Math.random() * _davidErrorPhrases.length)];
  return `<div class="empty-state">${phrase}${msg ? `<br><small style="opacity:0.5">${escapeHTML(msg)}</small>` : ''}</div>`;
}

const _davidEmptyPhrases = {
  notes:      ["No notes. Nothing. Ryan apparently decided that documentation is optional.", "Zero notes on record. The file is a ghost town.", "No notes yet. Which means either nothing happened, or nobody wrote it down. Both are bad.", "Empty. As in, not a single note. Impressive in the wrong direction."],
  materials:  ["No source materials. Nothing linked. Nothing cleared. Nothing.", "Clean slate. Which at this stage is not actually a compliment.", "No materials attached. I don't know what we're writing to, and apparently neither does anyone else.", "No source material on file. Optimistic of us, really."],
  priorities: ["No priorities. Either everything's fine or nobody checked.", "No priorities generated. Click refresh. I'll wait.", "Nothing flagged. Which either means we're ahead of schedule — or the system doesn't know we're behind."],
  milestones: ["No upcoming milestones. The calendar is empty and I'm not sure how to feel about that.", "Nothing scheduled. Blank. Which is fine if we're ahead of schedule. We are not ahead of schedule.", "No milestones in the queue. Somebody should probably fix that.", "The pipeline is clear. Clear as in empty, not clear as in finished."],
  calendar:   ["Nothing on the calendar. Either we're done or we haven't started. I suspect the latter.", "No items scheduled. Which is a bold choice."],
  clients:    ["No clients for this year. Either it was a slow season or the data's off."],
  default:    ["Nothing here.", "Empty.", "No data to show."]
};

function davidEmpty(context = 'default') {
  const opts = _davidEmptyPhrases[context] || _davidEmptyPhrases.default;
  const phrase = opts[Math.floor(Math.random() * opts.length)];
  return `<div class="empty-state">${phrase}</div>`;
}

// ── David Thorne Chat ──────────────────────────────────────────────────────

const davidChat = { history: [], open: false };

function getDavidButtonText() {
  const h = new Date().getHours();
  if (h >= 5 && h < 14) {
    const opts = [
      "☕  David's on his second cup. You're already behind.",
      "☕  Coffee with David. He has opinions about your week.",
      "☕  David's been at his desk since 6. Catch up.",
      "☕  Buy David a coffee. He'll tell you what you're forgetting.",
    ];
    return opts[new Date().getDate() % opts.length];
  } else if (h >= 14 || h < 1) {
    const opts = [
      "🍺  Pull up a barstool. David has notes.",
      "🍺  David's got a cold one and your priorities pulled up.",
      "🍺  Beer o'clock. David's already there.",
      "🍺  End-of-day debrief. David's buying. (He's not.)",
    ];
    return opts[new Date().getDate() % opts.length];
  } else {
    const opts = [
      `💬  It's ${h}AM. David is asleep. This is your fault.`,
      "💬  Wake David up with an annoying text. You're both adults.",
      "💬  David is not awake. Neither should you be. Here we are.",
      "💬  Text David at an unreasonable hour. He'll be thrilled.",
    ];
    return opts[new Date().getDate() % opts.length];
  }
}

function initDavidButton() {
  const btn = document.getElementById('btn-david-chat');
  if (btn) btn.textContent = getDavidButtonText();
}

async function openDavidChat() {
  const overlay = document.getElementById('david-chat-overlay');
  if (!overlay) return;
  overlay.style.display = 'flex';
  davidChat.open = true;

  // First open — get David's greeting
  if (!davidChat.history.length) {
    appendDavidMessage('david', null, true); // loading
    const h = new Date().getHours();
    try {
      const data = await api('/agent/chat', {
        method: 'POST',
        body: { messages: [], hour: h }
      });
      davidChat.history.push({ role: 'assistant', content: data.reply });
      renderDavidMessages();
    } catch (err) {
      renderDavidMessages();
      appendDavidMessage('david', "Something's broken on my end. Try again.", false);
    }
  }
}

function closeDavidChat(event) {
  if (event && event.target !== document.getElementById('david-chat-overlay')) return;
  const overlay = document.getElementById('david-chat-overlay');
  if (overlay) overlay.style.display = 'none';
  davidChat.open = false;
}

async function sendDavidMessage() {
  const input = document.getElementById('david-chat-input');
  const text = input?.value?.trim();
  if (!text) return;

  input.value = '';
  input.disabled = true;
  document.getElementById('david-chat-send').disabled = true;

  davidChat.history.push({ role: 'user', content: text });
  renderDavidMessages();
  appendDavidMessage('david', null, true); // typing indicator

  const h = new Date().getHours();
  try {
    const data = await api('/agent/chat', {
      method: 'POST',
      body: { messages: davidChat.history.filter(m => m.role !== '__typing'), hour: h }
    });
    davidChat.history.push({ role: 'assistant', content: data.reply });
  } catch {
    davidChat.history.push({ role: 'assistant', content: "Lost my train of thought. Ask me again." });
  }

  input.disabled = false;
  document.getElementById('david-chat-send').disabled = false;
  renderDavidMessages();
  input.focus();
}

function renderDavidMessages() {
  const container = document.getElementById('david-chat-messages');
  if (!container) return;
  container.innerHTML = davidChat.history.map(m => {
    if (m.role === 'user') {
      return `<div class="david-msg ryan"><div class="david-bubble ryan-bubble">${escapeHTML(m.content)}</div></div>`;
    } else {
      return `<div class="david-msg david"><img src="David_Thorne_2.png" class="david-msg-avatar" /><div class="david-bubble david-bubble-text">${escapeHTML(m.content)}</div></div>`;
    }
  }).join('');
  container.scrollTop = container.scrollHeight;
}

function appendDavidMessage(role, text, isTyping) {
  const container = document.getElementById('david-chat-messages');
  if (!container) return;
  if (isTyping) {
    const el = document.createElement('div');
    el.className = 'david-msg david david-typing-row';
    el.innerHTML = `<img src="David_Thorne_2.png" class="david-msg-avatar" /><div class="david-bubble david-bubble-text david-typing"><span></span><span></span><span></span></div>`;
    container.appendChild(el);
  } else {
    const el = document.createElement('div');
    el.className = `david-msg ${role}`;
    el.innerHTML = role === 'david'
      ? `<img src="David_Thorne_2.png" class="david-msg-avatar" /><div class="david-bubble david-bubble-text">${escapeHTML(text)}</div>`
      : `<div class="david-bubble ryan-bubble">${escapeHTML(text)}</div>`;
    container.appendChild(el);
  }
  container.scrollTop = container.scrollHeight;
}

// ── Competition Schedule Confirm Cards ────────────────────────────────────────

function renderScheduleConfirms(items) {
  const panel = document.getElementById('schedule-confirm-panel');
  const container = document.getElementById('schedule-confirm-items');
  const countEl = document.getElementById('schedule-confirm-count');
  if (!panel || !container) return;

  if (!items || !items.length) {
    panel.style.display = 'none';
    return;
  }

  panel.style.display = '';
  if (countEl) countEl.textContent = items.length;

  container.innerHTML = items.map(item => {
    const clientLabel = escapeHTML(item.org_name || item.client_name || 'Unknown');
    let parsed = {};
    try { parsed = JSON.parse(item.summary || '{}'); } catch {}

    if (item.type === 'competition_recap_pending') {
      const circuitOptions = ['cavalcade','tob','usbands','boa','wop_texas','uil_texas','other'].map(c =>
        `<option value="${c}" ${c === (parsed.circuit_guess || '') ? 'selected' : ''}>${c}</option>`
      ).join('');
      return `
        <div class="inbox-item recap-confirm-card" data-id="${item.id}" data-client-id="${item.client_id || ''}">
          <div class="inbox-item-top">
            <span class="inbox-type-badge" style="background:#7c4dff;color:#fff">Recap</span>
            <span class="inbox-client">${clientLabel}</span>
            <span class="inbox-time">${timeAgo(item.created_at)}</span>
          </div>
          <div class="inbox-item-title">${escapeHTML(item.title || 'Competition Recap Received')}</div>
          ${parsed.attachment_name ? `<div class="inbox-item-summary" style="opacity:.7;font-size:12px;margin-bottom:8px">PDF: ${escapeHTML(parsed.attachment_name)}</div>` : ''}
          <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-bottom:8px">
            <input class="recap-event-name" placeholder="Event name" value="${escapeHTML(parsed.event_name || '')}" style="font-size:12px;padding:4px 6px;background:var(--bg-input,#1e1b2e);color:inherit;border:1px solid #4a3065;border-radius:4px">
            <input class="recap-event-date" type="date" value="${parsed.event_date || ''}" style="font-size:12px;padding:4px 6px;background:var(--bg-input,#1e1b2e);color:inherit;border:1px solid #4a3065;border-radius:4px">
            <select class="recap-circuit" style="font-size:12px;padding:4px 6px;background:var(--bg-input,#1e1b2e);color:inherit;border:1px solid #4a3065;border-radius:4px">
              <option value="">— circuit —</option>${circuitOptions}
            </select>
          </div>
          <div style="margin-bottom:6px;font-size:12px;opacity:.6">Or upload PDF directly: <input type="file" class="recap-pdf-input" accept=".pdf" style="font-size:11px"></div>
          ${item.review_note ? `<div class="inbox-review-note">${escapeHTML(item.review_note)}</div>` : ''}
          <div class="inbox-item-actions">
            ${item.client_id ? `<button class="btn-inline" onclick="navigateToClient(${item.client_id})">View Client</button>` : ''}
            <button class="btn-inline btn-parse-recap" data-id="${item.id}" data-client-id="${item.client_id || ''}">Parse & Save</button>
            <button class="btn-inline btn-dismiss" onclick="dismissScheduleConfirm(${item.id}, this)">Dismiss</button>
          </div>
        </div>`;
    }

    // competition_schedule_confirm — editable event table
    const events = parsed.events || [];
    const circuitOptions = ['cavalcade','tob','usbands','other'].map(c =>
      `<option value="${c}">${c}</option>`).join('');

    const eventRows = events.map((ev, idx) => `
      <tr class="sched-confirm-row" data-idx="${idx}">
        <td><input class="sched-field sched-event-name" value="${escapeHTML(ev.event_name || '')}" placeholder="Event name" style="width:100%"></td>
        <td><input class="sched-field sched-event-date" type="date" value="${ev.event_date || ''}"></td>
        <td><input class="sched-field sched-event-location" value="${escapeHTML(ev.location || '')}" placeholder="Location" style="width:100%"></td>
        <td>
          <select class="sched-field sched-event-circuit">
            <option value="">—</option>
            ${circuitOptions.replace(`value="${ev.circuit_guess || ev.circuit || ''}"`, `value="${ev.circuit_guess || ev.circuit || ''}" selected`)}
          </select>
        </td>
        <td><button class="btn-inline btn-dismiss" onclick="this.closest('tr').remove()" title="Remove">✕</button></td>
      </tr>`).join('');

    return `
      <div class="inbox-item sched-confirm-card" data-id="${item.id}" data-client-id="${item.client_id || ''}">
        <div class="inbox-item-top">
          <span class="inbox-type-badge" style="background:#00b4d8;color:#0a0015">Schedule</span>
          <span class="inbox-client">${clientLabel}</span>
          <span class="inbox-time">${timeAgo(item.created_at)}</span>
        </div>
        <div class="inbox-item-title">${escapeHTML(item.title || 'Competition Schedule')}</div>
        ${item.review_note ? `<div class="inbox-review-note">${escapeHTML(item.review_note)}</div>` : ''}
        <div class="sched-confirm-table-wrap" style="overflow-x:auto;margin:10px 0">
          <table class="sched-confirm-table" style="width:100%;border-collapse:collapse;font-size:13px">
            <thead>
              <tr style="opacity:0.6">
                <th style="text-align:left;padding:4px 8px">Event</th>
                <th style="text-align:left;padding:4px 8px">Date</th>
                <th style="text-align:left;padding:4px 8px">Location</th>
                <th style="text-align:left;padding:4px 8px">Circuit</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="sched-confirm-tbody">
              ${eventRows}
            </tbody>
          </table>
        </div>
        <div class="inbox-item-actions">
          <button class="btn-inline btn-complete" onclick="confirmScheduleCard(${item.id}, this)">Confirm ${events.length} Event${events.length !== 1 ? 's' : ''} →</button>
          <button class="btn-inline btn-dismiss" onclick="dismissScheduleConfirm(${item.id}, this)">Dismiss</button>
        </div>
      </div>`;
  }).join('');
}

async function confirmScheduleCard(itemId, btn) {
  const card = btn.closest('.sched-confirm-card');
  if (!card) return;

  const clientId = parseInt(card.dataset.clientId);
  const rows = card.querySelectorAll('.sched-confirm-row');
  const events = [];

  rows.forEach(row => {
    const event_name = row.querySelector('.sched-event-name')?.value?.trim();
    const event_date = row.querySelector('.sched-event-date')?.value?.trim();
    const location   = row.querySelector('.sched-event-location')?.value?.trim();
    const circuit    = row.querySelector('.sched-event-circuit')?.value?.trim();
    if (event_name && event_date) events.push({ event_name, event_date, location, circuit });
  });

  if (!events.length) {
    alert('No events to confirm — add at least one event name and date.');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Saving\u2026';

  try {
    const result = await api('/competition-intel/confirm-schedule', {
      method: 'POST',
      body: JSON.stringify({ inbox_item_id: itemId, client_id: clientId, events })
    });
    card.innerHTML = `<div class="inbox-item-summary" style="padding:12px;color:#2ecc71">\u2713 ${result.confirmed} event${result.confirmed !== 1 ? 's' : ''} added to competition schedule.</div>`;
    setTimeout(() => {
      card.closest('.inbox-item')?.remove();
      const remaining = document.querySelectorAll('.sched-confirm-card').length;
      const panel = document.getElementById('schedule-confirm-panel');
      if (!remaining && panel) panel.style.display = 'none';
      const countEl = document.getElementById('schedule-confirm-count');
      if (countEl) countEl.textContent = remaining;
    }, 1800);
  } catch (err) {
    btn.disabled = false;
    btn.textContent = 'Confirm Events \u2192';
    alert('Error confirming schedule: ' + err.message);
  }
}

async function dismissScheduleConfirm(itemId, btn) {
  try {
    await api(`/intake/inbox/${itemId}/seen`, { method: 'POST' });
    const card = btn.closest('.inbox-item');
    if (card) card.remove();
    const remaining = document.querySelectorAll('#schedule-confirm-items .inbox-item').length;
    const panel = document.getElementById('schedule-confirm-panel');
    if (!remaining && panel) panel.style.display = 'none';
    const countEl = document.getElementById('schedule-confirm-count');
    if (countEl) countEl.textContent = remaining;
  } catch (err) {
    console.error('dismissScheduleConfirm:', err.message);
  }
}

// ── Recap Parse handler (delegated from btn-parse-recap) ─────────────────────
document.getElementById('schedule-confirm-items')?.addEventListener('click', async e => {
  const btn = e.target.closest('.btn-parse-recap');
  if (!btn) return;
  const card = btn.closest('.recap-confirm-card');
  if (!card) return;

  const inboxItemId = btn.dataset.id;
  const clientId = btn.dataset.clientId || '';
  const eventName = card.querySelector('.recap-event-name')?.value?.trim();
  const eventDate = card.querySelector('.recap-event-date')?.value?.trim();
  const circuit = card.querySelector('.recap-circuit')?.value?.trim();
  const fileInput = card.querySelector('.recap-pdf-input');
  const file = fileInput?.files?.[0] || null;

  if (!eventName || !eventDate || !circuit) {
    alert('Fill in event name, date, and circuit before parsing.');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Parsing…';

  try {
    const form = new FormData();
    form.append('inbox_item_id', inboxItemId);
    form.append('client_id', clientId);
    form.append('circuit', circuit);
    form.append('event_name', eventName);
    form.append('event_date', eventDate);
    if (file) form.append('file', file);

    const res = await fetch(`${API}/competition-intel/confirm-recap`, { method: 'POST', body: form });
    const data = await res.json();
    if (data.error) throw new Error(data.error);

    card.innerHTML = `<div style="padding:12px;color:#4caf50">
      ✓ Parsed — ${data.bands_saved} band${data.bands_saved !== 1 ? 's' : ''} saved
      (${data.captions_saved} caption scores). Card dismissed.
    </div>`;
    setTimeout(() => {
      card.remove();
      const remaining = document.querySelectorAll('#schedule-confirm-items .inbox-item').length;
      const countEl = document.getElementById('schedule-confirm-count');
      if (countEl) countEl.textContent = remaining;
    }, 2500);
  } catch (err) {
    btn.disabled = false;
    btn.textContent = 'Parse & Save';
    alert('Parse failed: ' + err.message);
  }
});

// ── Results Tab ───────────────────────────────────────────────────────────────

const CAPTION_LABELS = {
  ge_music:       'GE Music',
  ge_visual:      'GE Visual',
  ensemble_music: 'Ensemble Music',
  ensemble_visual:'Ensemble Visual',
  field_music:    'Field Music',
  field_visual:   'Field Visual',
  visual_analysis:'Visual Analysis',
  percussion:     'Percussion',
  colorguard:     'Color Guard'
};

const SEASON_COLORS = {
  '-1': '#666666',
  2019: '#4a4080', 2020: '#5a50a0', 2021: '#6a60b0',
  2022: '#4a90d9', 2023: '#7b5ea7', 2024: '#c0392b',
  2025: '#e67e22', 2026: '#00b4d8'
};

const STATUS_LABELS = {
  maxed: { label: 'Near ceiling', color: '#f39c12' },
  closing: { label: 'Closing well', color: '#2ecc71' },
  plateau: { label: 'Plateaued', color: '#95a5a6' },
  widening: { label: 'Gap widening', color: '#e74c3c' },
  insufficient_data: { label: 'Need more data', color: '#666' }
};

const TIER_LABELS = {
  any_given_night: { label: 'Any given night', color: '#f39c12' },
  competitive:     { label: 'Competitive',      color: '#e67e22' },
  clear_separation:{ label: 'Clear separation', color: '#e74c3c' },
  different_tier:  { label: 'Different tier',   color: '#95a5a6' },
  unknown:         { label: '—',                color: '#555' }
};

// ── Client Chat Tab (Portal Management) ───────────────────────────────────────

async function loadClientChatTab(client, shows) {
  const el = document.getElementById('tab-client-chat');
  if (!el) return;

  // Use the show for the currently selected year, falling back to first show
  const show = shows.find(s => parseInt(s.season_year) === state.clientDetailYear) || shows[0];
  if (!show) {
    el.innerHTML = '<div class="empty-state">No show on file for this season.</div>';
    return;
  }

  let data, collabs;
  try {
    [data, collabs] = await Promise.all([
      api(`/portal/show/${show.id}`),
      api(`/collaborators/client/${client.id}?year=${show.season_year}`).catch(() => [])
    ]);
  } catch (err) {
    el.innerHTML = `<div class="empty-state">Failed to load portal data: ${escapeHTML(err.message)}</div>`;
    return;
  }

  // Build a deduplicated people list: director first, then collaborators
  const people = [];
  const seenEmails = new Set();
  const directorName  = show.director_name  || client.name  || '';
  const directorEmail = show.director_email || client.email || '';
  if (directorName) {
    people.push({ name: directorName, email: directorEmail, role: 'Director' });
    if (directorEmail) seenEmails.add(directorEmail.toLowerCase());
  }
  for (const c of collabs) {
    if (!c.name) continue;
    const emailKey = (c.email || '').toLowerCase();
    if (emailKey && seenEmails.has(emailKey)) continue;
    people.push({ name: c.name, email: c.email || '', role: c.role || '' });
    if (emailKey) seenEmails.add(emailKey);
  }

  el.innerHTML = renderClientChatTab(data, show, people);
  bindClientChatEvents(data, show, client, shows);
}

function renderClientChatTab(data, show, people = []) {
  const portalUrl = data.portal_url || '';

  // Portal link section
  const linkSection = data.portal_token
    ? `<div class="portal-link-row">
         <span class="portal-url-display" id="portal-url-display">${escapeHTML(portalUrl)}</span>
         <button class="btn btn-ghost btn-xs" id="btn-copy-portal-url" title="Copy link">&#128203;</button>
         <button class="btn btn-ghost btn-xs btn-danger-ghost" id="btn-regen-token" title="Regenerate link (invalidates old link)">&#8635; Regenerate</button>
       </div>`
    : `<button class="btn btn-primary btn-sm" id="btn-gen-token">&#128279; Generate Portal Link</button>`;

  // Audio slot
  const audioRow = data.audio_url
    ? `<div class="portal-media-row">
         <span class="portal-media-value">${escapeHTML(data.audio_url)}</span>
         <button class="btn btn-ghost btn-xs btn-danger-ghost" data-clear-field="audio_url">&#215; Clear</button>
       </div>`
    : `<div class="portal-media-row">
         <input type="text" class="portal-url-input" id="portal-audio-input" placeholder="Paste audio share link…">
         <button class="btn btn-primary btn-xs" id="btn-save-audio">Save</button>
       </div>`;

  // PDF slot
  const pdfRow = data.pdf_url
    ? `<div class="portal-media-row">
         <span class="portal-media-value">${escapeHTML(data.pdf_url)}</span>
         <button class="btn btn-ghost btn-xs btn-danger-ghost" data-clear-field="pdf_url">&#215; Clear</button>
       </div>`
    : `<div class="portal-media-row">
         <input type="text" class="portal-url-input" id="portal-pdf-input" placeholder="Paste PDF share link…">
         <button class="btn btn-primary btn-xs" id="btn-save-pdf">Save</button>
       </div>`;

  // Merged access list: all known people + any orphan pin holders
  const pinsByName = new Map(data.pins.map(p => [p.name.toLowerCase(), p]));
  const seenInList = new Set();
  const accessRows = [];
  for (const p of people) {
    const key = p.name.toLowerCase();
    seenInList.add(key);
    accessRows.push({ name: p.name, email: p.email, pin: pinsByName.get(key) || null });
  }
  // Any pin holders not in the collaborator/director list (manually added before)
  for (const p of data.pins) {
    if (!seenInList.has(p.name.toLowerCase())) {
      accessRows.push({ name: p.name, email: p.email, pin: p });
    }
  }

  const hasAnyUngrantedWithEmail = accessRows.some(r => !r.pin && r.email);
  const hasGranted = accessRows.some(r => r.pin);
  const grantedCount = accessRows.filter(r => r.pin).length;
  const totalCount   = accessRows.length;

  const accessListHtml = accessRows.length ? `
    <table class="portal-access-table">
      <thead>
        <tr>
          <th><input type="checkbox" id="portal-check-all" title="Check all ungrantd"></th>
          <th>Name</th>
          <th>Email</th>
          <th>PIN</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        ${accessRows.map(r => {
          if (r.pin) {
            return `<tr class="portal-access-row portal-access-granted" data-pin-id="${r.pin.id}">
              <td></td>
              <td class="pac-name">${escapeHTML(r.name)}</td>
              <td class="pac-email">${escapeHTML(r.email || '—')}</td>
              <td><span class="pin-code">${escapeHTML(r.pin.pin)}</span></td>
              <td class="pin-actions">
                ${r.pin.email ? `<button class="btn btn-ghost btn-sm" data-pin-invite="${r.pin.id}" title="Send invite email">&#9993;</button>` : ''}
                <button class="btn btn-ghost btn-sm" data-pin-copy="${r.pin.id}" data-copy-name="${escapeHTML(r.name)}" data-copy-pin="${escapeHTML(r.pin.pin)}" title="Copy invite text to clipboard">&#128203;</button>
                <button class="btn btn-ghost btn-sm" data-pin-reset="${r.pin.id}" title="Reset PIN">&#8635;</button>
                <button class="btn btn-ghost btn-sm btn-danger-ghost" data-pin-delete="${r.pin.id}" title="Revoke">&#215;</button>
              </td>
            </tr>`;
          } else {
            return `<tr class="portal-access-row portal-access-ungrant">
              <td><input type="checkbox" class="portal-access-cb" data-name="${escapeHTML(r.name)}" data-email="${escapeHTML(r.email || '')}"></td>
              <td class="pac-name">${escapeHTML(r.name)}</td>
              <td class="pac-email pac-muted">${escapeHTML(r.email || '—')}</td>
              <td><span class="pac-no-access">No access</span></td>
              <td></td>
            </tr>`;
          }
        }).join('')}
      </tbody>
    </table>
    <div class="portal-access-footer">
      <button class="btn btn-primary btn-sm" id="btn-grant-selected">+ Grant Access to Selected</button>
      ${data.pins.some(p => p.email) ? `<button class="btn btn-ghost btn-sm" id="btn-notify-all">&#128276; Notify All</button>` : ''}
    </div>` : `<p class="portal-empty-pins">No collaborators on file for this season.</p>`;

  // Messages thread (Ryan's view)
  const msgsHtml = renderCrmPortalMessages(data.messages);

  return `
    <div class="client-chat-wrap">

      <!-- Portal Link -->
      <div class="portal-section">
        <div class="portal-section-header">
          <span class="portal-section-title">Portal Link</span>
        </div>
        <div class="portal-section-body" id="portal-link-section">
          ${linkSection}
        </div>
      </div>

      <!-- Media (side-by-side) -->
      <div class="portal-media-pair">
        <div class="portal-section" style="flex:1">
          <div class="portal-section-header">
            <span class="portal-section-title">Audio</span>
          </div>
          <div class="portal-section-body" id="portal-audio-section">${audioRow}</div>
        </div>
        <div class="portal-section" style="flex:1">
          <div class="portal-section-header">
            <span class="portal-section-title">Score / PDF</span>
          </div>
          <div class="portal-section-body" id="portal-pdf-section">${pdfRow}</div>
        </div>
      </div>

      <!-- Access (PINs) — collapsed by default -->
      <div class="portal-section">
        <div class="portal-section-header portal-access-toggle" id="portal-access-toggle" style="cursor:pointer;" title="Click to expand">
          <span class="portal-section-title">
            Access
            <span class="portal-access-summary">${grantedCount} of ${totalCount} granted</span>
          </span>
          <span class="portal-toggle-arrow" id="portal-access-arrow">▶</span>
        </div>
        <div class="portal-section-body" id="portal-access-body" style="display:none;padding:0;">
          ${accessListHtml}
        </div>
      </div>

      <!-- Discussion Thread -->
      <div class="portal-section">
        <div class="portal-section-header">
          <span class="portal-section-title">Discussion</span>
          <span class="portal-msg-count" id="portal-msg-count"></span>
        </div>
        <div class="portal-section-body">
          <div class="portal-compose-row">
            <textarea id="portal-compose" class="portal-compose-ta" placeholder="Post a message to this portal…"></textarea>
            <button class="btn btn-primary btn-sm" id="btn-portal-post">Post</button>
          </div>
          <div id="portal-messages-list">${msgsHtml}</div>
        </div>
      </div>

    </div>`;
}

function renderCrmPortalMessages(messages) {
  if (!messages.length) return '<p class="portal-empty-pins">No messages yet.</p>';

  function fmtTime(dt) {
    return new Date(dt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) +
      ' ' + new Date(dt).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }

  // Fully recursive — depth 0=OP, 1=reply, 2=sub-reply (no further nesting)
  function msgHtml(m, depth) {
    const isRyan   = m.author_type === 'ryan';
    const badge    = isRyan
      ? `<span class="portal-badge portal-badge-ryan">Ryan</span>`
      : `<span class="portal-badge portal-badge-client">${escapeHTML(m.author_name)}</span>`;
    const canReply = depth < 2;
    const replyBtn = canReply
      ? `<button class="btn-portal-reply-toggle btn btn-sm" data-msg-id="${m.id}" style="background:rgba(124,106,247,0.18);color:#c4b5fd;border:1px solid rgba(124,106,247,0.4);font-size:11px;padding:3px 10px;">↩ Reply</button>`
      : '';
    const repliesHtml = m.replies && m.replies.length
      ? `<div class="portal-replies">${m.replies.map(r => msgHtml(r, depth + 1)).join('')}</div>`
      : '';
    const replyCompose = canReply
      ? `<div class="portal-reply-compose" id="portal-reply-compose-${m.id}" style="display:none;">
           <textarea class="portal-compose-ta portal-reply-ta" id="portal-reply-ta-${m.id}" placeholder="Reply…"></textarea>
           <div style="display:flex;gap:6px;justify-content:flex-end;margin-top:6px;">
             <button class="btn btn-ghost btn-xs" onclick="document.getElementById('portal-reply-compose-${m.id}').style.display='none'">Cancel</button>
             <button class="btn btn-primary btn-xs" data-reply-submit="${m.id}">Reply</button>
           </div>
         </div>`
      : '';

    return `
      <div class="portal-msg${depth > 0 ? ' portal-msg-reply' : ''}" data-msg-id="${m.id}" style="${depth > 0 ? 'margin-left:' + (depth * 20) + 'px;' : ''}">
        <div class="portal-msg-meta">${badge} <span class="portal-msg-time">${fmtTime(m.created_at)}</span></div>
        <div class="portal-msg-body">${escapeHTML(m.body)}</div>
        <div class="portal-msg-actions">${replyBtn}</div>
        ${repliesHtml}
        ${replyCompose}
      </div>`;
  }

  function countDeep(msgs) {
    return (msgs || []).reduce((n, m) => n + 1 + countDeep(m.replies), 0);
  }
  const total = countDeep(messages);
  document.getElementById && setTimeout(() => {
    const el = document.getElementById('portal-msg-count');
    if (el) el.textContent = total + ' message' + (total === 1 ? '' : 's');
  }, 0);

  return messages.map(m => msgHtml(m, 0)).join('');
}

function bindClientChatEvents(data, show, client, shows) {
  const el = document.getElementById('tab-client-chat');
  if (!el) return;

  async function reload() {
    try {
      const fresh = await api(`/portal/show/${show.id}`);
      const msgEl = document.getElementById('portal-messages-list');
      if (msgEl) msgEl.innerHTML = renderCrmPortalMessages(fresh.messages);
      // count is updated inside renderCrmPortalMessages via setTimeout
    } catch {}
  }

  // Bind toggle directly so it can't stack or conflict with delegated handler
  const toggleEl = document.getElementById('portal-access-toggle');
  if (toggleEl) {
    toggleEl.onclick = () => {
      const body  = document.getElementById('portal-access-body');
      const arrow = document.getElementById('portal-access-arrow');
      if (!body) return;
      const open = body.style.display !== 'none';
      body.style.display  = open ? 'none' : 'block';
      if (arrow) arrow.textContent = open ? '▶' : '▼';
    };
  }

  // Use .onclick (not addEventListener) so reloads replace rather than stack the handler
  el.onclick = async e => {
    // Ignore clicks on the access panel toggle — handled by its own direct listener
    if (e.target.closest('#portal-access-toggle')) return;
    // Generate token
    if (e.target.id === 'btn-gen-token' || e.target.id === 'btn-regen-token') {
      if (e.target.id === 'btn-regen-token') {
        if (!confirm('This will invalidate the old portal link. Anyone with the old link will need the new one. Continue?')) return;
      }
      try {
        const r = await api(`/portal/show/${show.id}/token`, { method: 'POST' });
        loadClientChatTab(client, shows);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Copy portal URL
    if (e.target.id === 'btn-copy-portal-url') {
      const url = document.getElementById('portal-url-display')?.textContent;
      if (url) { navigator.clipboard.writeText(url); e.target.textContent = '✓'; setTimeout(() => e.target.innerHTML = '&#128203;', 1500); }
    }

    // Clear media field
    if (e.target.dataset.clearField) {
      const field = e.target.dataset.clearField;
      try {
        await api(`/portal/show/${show.id}/media/${field}`, { method: 'DELETE' });
        loadClientChatTab(client, shows);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Save audio
    if (e.target.id === 'btn-save-audio') {
      const url = document.getElementById('portal-audio-input')?.value.trim();
      if (!url) return;
      try {
        await api(`/portal/show/${show.id}/media`, { method: 'PATCH', body: { audio_url: url } });
        loadClientChatTab(client, shows);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Save PDF
    if (e.target.id === 'btn-save-pdf') {
      const url = document.getElementById('portal-pdf-input')?.value.trim();
      if (!url) return;
      try {
        await api(`/portal/show/${show.id}/media`, { method: 'PATCH', body: { pdf_url: url } });
        loadClientChatTab(client, shows);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Check All
    if (e.target.id === 'portal-check-all') {
      const checked = e.target.checked;
      document.querySelectorAll('.portal-access-cb').forEach(cb => cb.checked = checked);
      return;
    }

    // Grant access to all selected checkboxes + auto-send invite emails
    if (e.target.id === 'btn-grant-selected') {
      const checked = [...document.querySelectorAll('.portal-access-cb:checked')];
      if (!checked.length) { alert('Check at least one person to grant access.'); return; }
      e.target.disabled = true;
      e.target.textContent = 'Granting…';
      const results = [];
      for (const cb of checked) {
        try {
          const p = await api(`/portal/show/${show.id}/pins`, {
            method: 'POST',
            body: { name: cb.dataset.name, email: cb.dataset.email || undefined }
          });
          let line = `${p.name} — PIN: ${p.pin}`;
          // Auto-send invite email if they have an address
          if (p.email) {
            try {
              await api(`/portal/show/${show.id}/pins/${p.id}/invite`, { method: 'POST' });
              line += ' (invite sent)';
            } catch {
              line += ' (invite failed — check email address)';
            }
          } else {
            line += ' (no email on file)';
          }
          results.push(line);
        } catch (err) {
          results.push(`${cb.dataset.name} — Error: ${err.message}`);
        }
      }
      alert('Done:\n\n' + results.join('\n'));
      await loadClientChatTab(client, shows);
      // Re-open the access panel so the user can see the new PINs
      const body  = document.getElementById('portal-access-body');
      const arrow = document.getElementById('portal-access-arrow');
      if (body)  body.style.display = 'block';
      if (arrow) arrow.textContent  = '▼';
    }

    // Copy invite text to clipboard
    if (e.target.dataset.pinCopy) {
      const name = e.target.dataset.copyName || '';
      const pin  = e.target.dataset.copyPin  || '';
      const portalUrl = data.portal_url || '';
      const showLabel = show.title ? `${show.title} (${show.season_year})` : (client.org_name || '');
      const firstName = name.split(' ')[0];
      const text = `${firstName} --\n\nRyan asked me to get you set up on the White Mage Music client portal for ${showLabel}. This is the private hub where everything for your show lives -- shared files from the Google Drive folder, the score PDF, audio for the ensemble, and a running discussion thread where you can leave notes or questions and Ryan will respond directly. No app to download, no account to create. It just lives at a link in your browser, and it stays current as the season moves along.\n\nHere's how to log in:\n\n  Link:  ${portalUrl}\n  Name:  ${name}\n  PIN:   ${pin}\n\nGo to the link above, enter your name exactly as it appears here, type in your PIN, and you're in. That's the whole process. Bookmark it -- you'll want easy access as things develop.\n\nIf anything doesn't work right, reply to this email and I'll sort it out quickly.\n\nDavid Thorne\nAdvisor, White Mage Music`;
      try {
        await navigator.clipboard.writeText(text);
        e.target.textContent = '✓ Copied';
        setTimeout(() => { e.target.innerHTML = '&#128203;'; }, 2000);
      } catch (err) { alert('Copy failed: ' + err.message); }
    }

    // Send invite email
    if (e.target.dataset.pinInvite) {
      const pinId = e.target.dataset.pinInvite;
      try {
        await api(`/portal/show/${show.id}/pins/${pinId}/invite`, { method: 'POST' });
        e.target.textContent = '✓ Sent';
        setTimeout(() => e.target.innerHTML = '&#9993;', 2000);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Reset PIN
    if (e.target.dataset.pinReset) {
      const pinId = e.target.dataset.pinReset;
      try {
        const p = await api(`/portal/show/${show.id}/pins/${pinId}`, { method: 'PATCH' });
        alert(`PIN reset.\n\nName: ${p.name}\nNew PIN: ${p.pin}`);
        loadClientChatTab(client, shows);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Delete PIN
    if (e.target.dataset.pinDelete) {
      const pinId = e.target.dataset.pinDelete;
      const row   = e.target.closest('.portal-pin-row');
      const name  = row?.querySelector('.pin-name')?.textContent || 'this person';
      if (!confirm(`Remove portal access for ${name}?`)) return;
      try {
        await api(`/portal/show/${show.id}/pins/${pinId}`, { method: 'DELETE' });
        loadClientChatTab(client, shows);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Notify All
    if (e.target.id === 'btn-notify-all') {
      try {
        const r = await api(`/portal/show/${show.id}/notify`, { method: 'POST', body: {} });
        alert(`Notification sent to ${r.sent} recipient${r.sent === 1 ? '' : 's'}.`);
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Reply toggle
    if (e.target.classList.contains('btn-portal-reply-toggle')) {
      const msgId  = e.target.dataset.msgId;
      const compose = document.getElementById(`portal-reply-compose-${msgId}`);
      if (compose) {
        const visible = compose.style.display !== 'none';
        compose.style.display = visible ? 'none' : 'block';
        if (!visible) document.getElementById(`portal-reply-ta-${msgId}`)?.focus();
      }
    }

    // Submit reply
    if (e.target.dataset.replySubmit) {
      const msgId = e.target.dataset.replySubmit;
      const ta    = document.getElementById(`portal-reply-ta-${msgId}`);
      const body  = ta?.value.trim();
      if (!body) return;
      try {
        await api(`/portal/show/${show.id}/message/${msgId}/reply`, { method: 'POST', body: { body } });
        if (ta) ta.value = '';
        await reload();
      } catch (err) { alert('Error: ' + err.message); }
    }

    // Post new message
    if (e.target.id === 'btn-portal-post') {
      const ta   = document.getElementById('portal-compose');
      const body = ta?.value.trim();
      if (!body) return;
      const btn = e.target;
      btn.disabled = true;
      try {
        await api(`/portal/show/${show.id}/message`, { method: 'POST', body: { body } });
        if (ta) ta.value = '';
        await reload();
      } catch (err) { alert('Error: ' + err.message); }
      btn.disabled = false;
      e.target.disabled = false;
    }
  };
}

async function loadResultsTab(clientId) {
  const container = document.getElementById('results-tab-inner');
  if (!container) return;
  container.innerHTML = '<div class="loading-msg">Loading competitive data…</div>';

  try {
    const currentYear = new Date().getFullYear();
    const seasons = [currentYear, currentYear-1, currentYear-2, currentYear-3].join(',');

    const [arc, vel] = await Promise.all([
      api(`/analytics/client/${clientId}/arc?seasons=${seasons}`),
      api(`/analytics/client/${clientId}/velocity?season=${currentYear}`)
    ]);

    if (!arc.events || !arc.events.length) {
      container.innerHTML = `<div class="empty-state" style="padding:32px">No competition results on record yet. Once the scrapers run and aliases are set, this tab will populate automatically.</div>`;
      return;
    }

    container.innerHTML = renderResultsLayout(clientId, arc, vel, currentYear);
    bindResultsEvents(clientId, arc, vel, currentYear);
  } catch (err) {
    container.innerHTML = `<div class="empty-state" style="padding:32px;color:#e74c3c">Error loading results: ${escapeHTML(err.message)}</div>`;
  }
}

function renderResultsLayout(clientId, arc, vel, currentYear) {
  const seasonOptions = arc.seasons.map(s => {
    const label = (arc.year1 && s === arc.year1 - 1) ? `${s} (Pre-WMM)` : s.toString();
    return `<option value="${s}" ${s === currentYear ? 'selected' : ''}>${label}</option>`;
  }).join('');

  const captionOptions = [
    `<option value="__total__">Total Score</option>`,
    ...arc.caption_keys.map(k => `<option value="${k}">${CAPTION_LABELS[k] || k}</option>`)
  ].join('');

  // Summary row from most recent event
  const currentSeasonEvents = arc.events.filter(e => e.season_year === currentYear);
  const latestEvent = currentSeasonEvents[currentSeasonEvents.length - 1];

  return `
    <div class="results-header-row">
      <div class="results-season-controls">
        <label style="opacity:.7;font-size:12px">Season</label>
        <select id="results-season-select">${seasonOptions}</select>
        <label style="opacity:.7;font-size:12px;margin-left:12px">Caption</label>
        <select id="results-caption-select">${captionOptions}</select>
      </div>
      ${latestEvent ? `<div class="results-latest-badge">
        Last competed: <strong>${escapeHTML(latestEvent.event_name)}</strong>
        &nbsp;·&nbsp; Score: <strong>${latestEvent.total_score ?? '—'}</strong>
        &nbsp;·&nbsp; Placement: <strong>${latestEvent.placement ?? '—'}</strong> of ${latestEvent.class_size ?? '?'}
      </div>` : ''}
    </div>

    <!-- Placement History -->
    <div class="results-section">
      <div class="results-section-title">Placement History</div>
      <div id="placement-history-panel">
        ${renderPlacementHistory(arc.events)}
      </div>
    </div>

    <!-- Arc Chart -->
    <div class="results-section">
      <div class="results-section-title">Performance Arc
        <span style="font-size:11px;opacity:.6;margin-left:8px">Content (solid) · Achievement (dashed) · shaded gap</span>
      </div>
      <div id="arc-chart-container" style="width:100%;overflow-x:auto"></div>
      <div class="arc-legend" id="arc-legend"></div>
    </div>

    <!-- Caption Velocity Cards -->
    <div class="results-section">
      <div class="results-section-title">Caption Velocity — ${currentYear}</div>
      <div class="velocity-cards" id="velocity-cards">
        ${renderVelocityCards(vel)}
      </div>
    </div>

    <!-- Same-Week Historical -->
    <div class="results-section">
      <div class="results-section-title">Same-Week Historical
        <span style="font-size:11px;opacity:.6;margin-left:8px">Week</span>
        <select id="results-week-select" style="margin-left:6px;font-size:12px">
          ${[1,2,3,4,5,6,7,8,9,10].map(w => `<option value="${w}" ${w===4?'selected':''}>Week ${w}</option>`).join('')}
        </select>
        <button class="btn-inline" id="btn-load-same-week" style="margin-left:6px">Load</button>
      </div>
      <div id="same-week-panel">—</div>
    </div>

    <!-- Competitive Distance (most recent event) -->
    <div class="results-section">
      <div class="results-section-title">Field — ${latestEvent ? escapeHTML(latestEvent.event_name) : 'Most Recent Event'}</div>
      <div id="competitors-panel">${latestEvent ? '<div class="loading-msg">Loading field…</div>' : '<div style="opacity:.6">No events this season</div>'}</div>
    </div>

    <!-- Claude Briefing -->
    <div class="results-section">
      <div class="results-section-title">Arc Briefing
        <button class="btn-inline" id="btn-arc-briefing" style="margin-left:10px">Generate</button>
      </div>
      <div id="arc-briefing-panel" style="opacity:.6;font-size:13px">Hit Generate to get an interpretation of this season's arc.</div>
    </div>
  `;
}

function renderPlacementHistory(events) {
  if (!events || !events.length) return '<div style="opacity:.6;font-size:13px">No results yet.</div>';

  const sorted = [...events].sort((a, b) => new Date(b.event_date) - new Date(a.event_date));

  let html = `<table class="results-field-table"><thead><tr>
    <th>Season</th><th>Date</th><th>Event</th><th>Class</th><th>Placement</th><th>Score</th>
  </tr></thead><tbody>`;

  for (const e of sorted) {
    let placementCell;
    if (e.placement === 1) {
      placementCell = `<span class="medal-badge medal-gold">1st</span>`;
    } else if (e.placement === 2) {
      placementCell = `<span class="medal-badge medal-silver">2nd</span>`;
    } else if (e.placement === 3) {
      placementCell = `<span class="medal-badge medal-bronze">3rd</span>`;
    } else if (e.placement) {
      placementCell = `${e.placement}${e.class_size ? ' / ' + e.class_size : ''}`;
    } else {
      placementCell = '—';
    }
    const preLabel = e.is_year_minus_1 ? ` <span style="opacity:.5">(pre)</span>` : '';
    const dateStr = e.event_date ? new Date(e.event_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '—';
    html += `<tr>
      <td>${e.season_year}${preLabel}</td>
      <td style="white-space:nowrap">${dateStr}</td>
      <td>${escapeHTML(e.event_name || '—')}</td>
      <td>${escapeHTML(e.class || '—')}</td>
      <td>${placementCell}</td>
      <td>${e.total_score != null ? e.total_score.toFixed(2) : '—'}</td>
    </tr>`;
  }

  html += '</tbody></table>';
  return html;
}

function renderVelocityCards(vel) {
  if (!vel.captions || !vel.captions.length) {
    return '<div style="opacity:.6;font-size:13px">Caption detail not yet available — backfill scrape pending.</div>';
  }
  return vel.captions.map(c => {
    const st = STATUS_LABELS[c.status] || STATUS_LABELS.plateau;
    const gapDir = c.gap_velocity < -0.02 ? '▼' : c.gap_velocity > 0.02 ? '▲' : '—';
    const gapColor = c.gap_velocity < -0.02 ? '#2ecc71' : c.gap_velocity > 0.02 ? '#e74c3c' : '#95a5a6';
    return `
      <div class="velocity-card">
        <div class="vel-caption-name">${CAPTION_LABELS[c.caption_key] || c.caption_key}</div>
        <div class="vel-scores">
          <span class="vel-score-label">Content</span>
          <span class="vel-score-val">${c.latest_content?.toFixed(2) ?? '—'}</span>
          <span class="vel-vel">${c.content_velocity >= 0 ? '+' : ''}${c.content_velocity?.toFixed(2)}/wk</span>
        </div>
        <div class="vel-scores">
          <span class="vel-score-label">Achieve</span>
          <span class="vel-score-val">${c.latest_achievement?.toFixed(2) ?? '—'}</span>
          <span class="vel-vel">${c.achievement_velocity >= 0 ? '+' : ''}${c.achievement_velocity?.toFixed(2)}/wk</span>
        </div>
        <div class="vel-gap">Gap: <strong>${c.latest_gap?.toFixed(2)}</strong>
          <span style="color:${gapColor};margin-left:4px">${gapDir} ${Math.abs(c.gap_velocity).toFixed(2)}/wk</span>
        </div>
        <div class="vel-status" style="color:${st.color}">${st.label}</div>
        ${c.points.length > 0 ? renderSparkline(c.points) : ''}
      </div>`;
  }).join('');
}

function renderSparkline(points) {
  if (points.length < 2) return '';
  const W = 120, H = 32;
  const maxW = Math.max(...points.map(p => p.week));
  const minW = Math.min(...points.map(p => p.week));
  const allVals = points.flatMap(p => [p.content, p.achievement]);
  const minV = Math.min(...allVals) - 0.5;
  const maxV = Math.max(...allVals) + 0.5;
  const x = w => ((w - minW) / Math.max(maxW - minW, 1)) * (W - 10) + 5;
  const y = v => H - ((v - minV) / (maxV - minV)) * (H - 6) - 3;

  const cPath = points.map((p,i) => `${i===0?'M':'L'}${x(p.week).toFixed(1)},${y(p.content).toFixed(1)}`).join(' ');
  const aPath = points.map((p,i) => `${i===0?'M':'L'}${x(p.week).toFixed(1)},${y(p.achievement).toFixed(1)}`).join(' ');
  const gapFill = points.map((p,i) => `${i===0?'M':'L'}${x(p.week).toFixed(1)},${y(p.content).toFixed(1)}`).join(' ')
    + ' ' + [...points].reverse().map((p,i) => `${i===0?'M':'L'}${x(p.week).toFixed(1)},${y(p.achievement).toFixed(1)}`).join(' ') + ' Z';

  return `<svg width="${W}" height="${H}" style="display:block;margin-top:6px">
    <path d="${gapFill}" fill="rgba(0,180,216,0.12)" />
    <path d="${cPath}" fill="none" stroke="#00b4d8" stroke-width="1.5"/>
    <path d="${aPath}" fill="none" stroke="#00b4d8" stroke-width="1.5" stroke-dasharray="3,2"/>
  </svg>`;
}

function drawArcChart(containerId, arc, captionKey, seasons) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const W = Math.min(container.offsetWidth || 700, 900);
  const H = 220;
  const M = { top: 20, right: 20, bottom: 40, left: 44 };
  const cW = W - M.left - M.right;
  const cH = H - M.top - M.bottom;

  const isTotalMode = captionKey === '__total__';

  // Collect all data points for selected seasons + caption
  const seriesData = {};
  for (const season of seasons) {
    const events = arc.events
      .filter(e => e.season_year === season && (isTotalMode ? e.total_score != null : e.captions[captionKey]))
      .sort((a, b) => a.week_of_season - b.week_of_season);
    if (events.length) seriesData[season] = events;
  }

  if (!Object.keys(seriesData).length) {
    container.innerHTML = `<div style="padding:20px;opacity:.6">No ${isTotalMode ? 'total score' : (CAPTION_LABELS[captionKey]||captionKey)} data in selected seasons.</div>`;
    return;
  }

  const allWeeks = Object.values(seriesData).flatMap(evs => evs.map(e => e.week_of_season));
  const allScores = Object.values(seriesData).flatMap(evs =>
    isTotalMode
      ? evs.map(e => e.total_score).filter(Boolean)
      : evs.flatMap(e => [e.captions[captionKey]?.content, e.captions[captionKey]?.achievement, e.captions[captionKey]?.subtotal].filter(Boolean))
  );
  if (!allScores.length) { container.innerHTML = '<div style="padding:20px;opacity:.6">No caption scores available yet.</div>'; return; }

  const maxWeek = Math.max(...allWeeks, 1);
  const minScore = Math.min(...allScores) - 1;
  const maxScore = Math.max(...allScores) + 1;

  const xS = w => ((w - 1) / Math.max(maxWeek - 1, 1)) * cW;
  const yS = v => cH - ((v - minScore) / (maxScore - minScore)) * cH;

  let svg = `<svg width="${W}" height="${H}" style="font-family:inherit;overflow:visible">
    <g transform="translate(${M.left},${M.top})">`;

  // Grid lines
  for (let w = 1; w <= maxWeek; w++) {
    const px = xS(w);
    svg += `<line x1="${px}" y1="0" x2="${px}" y2="${cH}" stroke="#ffffff18" stroke-width="1"/>
            <text x="${px}" y="${cH+14}" text-anchor="middle" fill="#ffffff55" font-size="10">W${w}</text>`;
  }
  for (let tick = 0; tick < 5; tick++) {
    const v = minScore + (maxScore - minScore) * (tick / 4);
    const py = yS(v);
    svg += `<line x1="0" y1="${py}" x2="${cW}" y2="${py}" stroke="#ffffff18" stroke-width="1"/>
            <text x="-6" y="${py+4}" text-anchor="end" fill="#ffffff55" font-size="10">${v.toFixed(1)}</text>`;
  }

  // Per season: content line, achievement line, shaded gap
  for (const [season, events] of Object.entries(seriesData)) {
    const color = SEASON_COLORS[season] || SEASON_COLORS[2026];
    const isDimmed = arc.year1 && parseInt(season) === arc.year1 - 1;
    const opacity = isDimmed ? '0.5' : '1';

    if (isTotalMode) {
      // Total score mode — single line
      const pts = events.map(e => ({ wx: xS(e.week_of_season), ty: yS(e.total_score) }));
      const tPath = pts.map((p, i) => `${i===0?'M':'L'}${p.wx.toFixed(1)},${p.ty.toFixed(1)}`).join(' ');
      svg += `<path d="${tPath}" fill="none" stroke="${color}" stroke-width="${isDimmed?1.5:2.5}" stroke-dasharray="${isDimmed?'5,3':''}" opacity="${opacity}"/>`;
      pts.forEach(p => {
        svg += `<circle cx="${p.wx.toFixed(1)}" cy="${p.ty.toFixed(1)}" r="3" fill="${color}" opacity="${opacity}"/>`;
      });
    } else {
      const pts = events.map(e => ({
        wx: xS(e.week_of_season),
        cy: yS(e.captions[captionKey]?.content ?? e.captions[captionKey]?.subtotal),
        ay: yS(e.captions[captionKey]?.achievement ?? e.captions[captionKey]?.subtotal),
        hasGap: e.captions[captionKey]?.content != null && e.captions[captionKey]?.achievement != null
      }));

      // Shaded gap
      const gapPath = pts.filter(p => p.hasGap).map((p, i) => `${i===0?'M':'L'}${p.wx.toFixed(1)},${p.cy.toFixed(1)}`).join(' ')
        + ' ' + [...pts.filter(p => p.hasGap)].reverse().map((p, i) => `${i===0?'M':'L'}${p.wx.toFixed(1)},${p.ay.toFixed(1)}`).join(' ') + ' Z';
      if (pts.some(p => p.hasGap)) {
        svg += `<path d="${gapPath}" fill="${color}" fill-opacity="0.12" opacity="${opacity}"/>`;
      }

      // Content line (solid)
      const cPath = pts.map((p, i) => `${i===0?'M':'L'}${p.wx.toFixed(1)},${p.cy.toFixed(1)}`).join(' ');
      svg += `<path d="${cPath}" fill="none" stroke="${color}" stroke-width="${isDimmed?1.5:2.5}" stroke-dasharray="${isDimmed?'5,3':''}" opacity="${opacity}"/>`;

      // Achievement line (dashed)
      const aPath = pts.map((p, i) => `${i===0?'M':'L'}${p.wx.toFixed(1)},${p.ay.toFixed(1)}`).join(' ');
      svg += `<path d="${aPath}" fill="none" stroke="${color}" stroke-width="${isDimmed?1:2}" stroke-dasharray="4,3" opacity="${opacity}"/>`;

      // Event dots on content line
      pts.forEach(p => {
        svg += `<circle cx="${p.wx.toFixed(1)}" cy="${p.cy.toFixed(1)}" r="3" fill="${color}" opacity="${opacity}"/>`;
      });
    }
  }

  svg += `</g></svg>`;
  container.innerHTML = svg;

  // Legend
  const legend = document.getElementById('arc-legend');
  if (legend) {
    legend.innerHTML = Object.entries(seriesData).map(([season]) => {
      const color = SEASON_COLORS[season] || '#aaa';
      const label = (arc.year1 && parseInt(season) === arc.year1 - 1) ? `${season} (Pre-WMM)` : season;
      return `<span class="arc-legend-item"><svg width="20" height="10"><line x1="0" y1="5" x2="20" y2="5" stroke="${color}" stroke-width="2.5"/></svg> ${label}</span>`;
    }).join('');
  }
}

async function loadCompetitors(clientId, event) {
  const panel = document.getElementById('competitors-panel');
  if (!panel || !event) return;
  try {
    const data = await api(`/analytics/client/${clientId}/competitors?event_date=${event.event_date}&event_name=${encodeURIComponent(event.event_name)}`);
    if (!data.competitors?.length) {
      panel.innerHTML = '<div style="opacity:.6">No other bands in class at this event.</div>';
      return;
    }

    // Sort: closest first (within our range), then those ahead, then those behind
    const sorted = [...data.competitors].sort((a, b) => Math.abs(a.total_delta) - Math.abs(b.total_delta));
    const captionKeys = sorted.length ? Object.keys(sorted[0].captions) : [];

    let html = `<table class="results-field-table">
      <thead><tr>
        <th>Band</th><th>Score</th><th>Gap</th><th>Tier</th>
        ${captionKeys.map(k => `<th>${CAPTION_LABELS[k]||k}</th>`).join('')}
      </tr></thead><tbody>`;

    for (const comp of sorted) {
      const tierInfo = TIER_LABELS[comp.tier] || TIER_LABELS.unknown;
      const deltaStr = comp.total_delta != null
        ? `${comp.total_delta > 0 ? '+' : ''}${comp.total_delta.toFixed(2)}`
        : '—';

      html += `<tr class="${comp.is_wmm_client ? 'field-row-wmm' : ''}">
        <td>${escapeHTML(comp.band_name)}${comp.is_wmm_client ? ' <span class="wmm-badge">WMM</span>' : ''}</td>
        <td>${comp.total_score?.toFixed(2) ?? '—'}</td>
        <td style="color:${comp.total_delta > 0 ? '#2ecc71' : '#e74c3c'}">${deltaStr}</td>
        <td><span class="tier-badge" style="color:${tierInfo.color}">${tierInfo.label}</span></td>
        ${captionKeys.map(k => {
          const cap = comp.captions[k];
          if (!cap) return '<td>—</td>';
          const cd = cap.content_delta;
          const color = cd == null ? '#666' : cd > 0 ? '#2ecc71' : cd < 0 ? '#e74c3c' : '#f39c12';
          const capTier = TIER_LABELS[cap.tier] || TIER_LABELS.unknown;
          return `<td style="color:${color}" title="${capTier.label}${cap.gap_diff ? ' · gap diff: '+(cap.gap_diff>0?'+':'')+cap.gap_diff : ''}">${cd != null ? (cd>0?'+':'')+cd.toFixed(2) : '—'}</td>`;
        }).join('')}
      </tr>`;
    }

    html += '</tbody></table>';
    panel.innerHTML = html;
  } catch (err) {
    panel.innerHTML = `<div style="color:#e74c3c">Error: ${escapeHTML(err.message)}</div>`;
  }
}

async function loadSameWeek(clientId, week) {
  const panel = document.getElementById('same-week-panel');
  if (!panel) return;
  panel.innerHTML = '<div class="loading-msg">Loading…</div>';
  try {
    const data = await api(`/analytics/client/${clientId}/same-week?week=${week}`);
    if (!data.data?.length) {
      panel.innerHTML = '<div style="opacity:.6">No data at this week across recorded seasons.</div>';
      return;
    }
    const captionKeys = [...new Set(data.data.flatMap(d => Object.keys(d.captions)))];
    let html = `<table class="results-field-table"><thead><tr>
      <th>Season</th><th>Event</th><th>Score</th><th>Placement</th>
      ${captionKeys.map(k => `<th>${CAPTION_LABELS[k]||k}</th>`).join('')}
    </tr></thead><tbody>`;
    for (const row of data.data) {
      const label = (data.year1 && row.season_year === data.year1 - 1) ? `${row.season_year} <span style="opacity:.6">(pre)</span>` : row.season_year;
      html += `<tr ${row.is_year_minus_1 ? 'style="opacity:.6"' : ''}>
        <td>${label}</td>
        <td>${escapeHTML(row.event_name)}</td>
        <td>${row.total_score?.toFixed(2) ?? '—'}</td>
        <td>${row.placement ?? '—'}</td>
        ${captionKeys.map(k => {
          const cap = row.captions[k];
          if (!cap) return '<td>—</td>';
          const gap = cap.gap != null ? ` <span style="opacity:.5">(Δ${cap.gap.toFixed(2)})</span>` : '';
          return `<td>${cap.content?.toFixed(2) ?? '—'} / ${cap.achievement?.toFixed(2) ?? '—'}${gap}</td>`;
        }).join('')}
      </tr>`;
    }
    html += '</tbody></table>';
    panel.innerHTML = html;
  } catch (err) {
    panel.innerHTML = `<div style="color:#e74c3c">Error: ${escapeHTML(err.message)}</div>`;
  }
}

function bindResultsEvents(clientId, arc, vel, currentYear) {
  // Draw initial arc chart — default to total score if no caption detail yet
  const firstCaption = arc.caption_keys[0] || '__total__';
  drawArcChart('arc-chart-container', arc, firstCaption, arc.seasons.slice(-3));

  // Load initial competitors
  const currentEvents = arc.events.filter(e => e.season_year === currentYear);
  const latestEvent = currentEvents[currentEvents.length - 1];
  if (latestEvent) loadCompetitors(clientId, latestEvent);

  // Caption selector changes arc chart
  document.getElementById('results-caption-select')?.addEventListener('change', e => {
    const captionKey = e.target.value;
    const selectedSeason = parseInt(document.getElementById('results-season-select')?.value || currentYear);
    const seasonsToShow = arc.seasons.filter(s => Math.abs(s - selectedSeason) <= 2);
    drawArcChart('arc-chart-container', arc, captionKey, seasonsToShow);
  });

  // Season selector changes chart context
  document.getElementById('results-season-select')?.addEventListener('change', e => {
    const selectedSeason = parseInt(e.target.value);
    const captionKey = document.getElementById('results-caption-select')?.value || firstCaption;
    const seasonsToShow = arc.seasons.filter(s => Math.abs(s - selectedSeason) <= 2);
    drawArcChart('arc-chart-container', arc, captionKey, seasonsToShow);

    // Also reload competitors for most recent event of selected season
    const events = arc.events.filter(ev => ev.season_year === selectedSeason);
    const latest = events[events.length - 1];
    if (latest) loadCompetitors(clientId, latest);
  });

  // Same-week loader
  document.getElementById('btn-load-same-week')?.addEventListener('click', () => {
    const week = parseInt(document.getElementById('results-week-select')?.value || 4);
    loadSameWeek(clientId, week);
  });
  // Load default week 4
  loadSameWeek(clientId, 4);

  // Claude briefing
  document.getElementById('btn-arc-briefing')?.addEventListener('click', async () => {
    const panel = document.getElementById('arc-briefing-panel');
    const btn = document.getElementById('btn-arc-briefing');
    panel.style.opacity = '0.6';
    panel.textContent = 'Generating briefing…';
    btn.disabled = true;
    try {
      const season = parseInt(document.getElementById('results-season-select')?.value || currentYear);
      const res = await api(`/analytics/client/${clientId}/briefing?season=${season}`, { method: 'POST' });
      panel.style.opacity = '1';
      panel.style.fontStyle = 'italic';
      panel.textContent = res.briefing;
    } catch (err) {
      panel.textContent = 'Error: ' + err.message;
    }
    btn.disabled = false;
  });
}

// ─── V4 MODULE SHIM ───────────────────────────────────────────────────────────
// Expose functions called from inline HTML handlers onto window.
// V3's app.js was a plain script (no module), so all functions were global.
// In V4's ES module bundle these must be explicitly exported to window.
window.openDavidChat   = typeof openDavidChat   !== 'undefined' ? openDavidChat   : () => {};
window.closeDavidChat  = typeof closeDavidChat  !== 'undefined' ? closeDavidChat  : () => {};
window.sendDavidMessage = typeof sendDavidMessage !== 'undefined' ? sendDavidMessage : () => {};

// Expose legacy state to V4 modules (state.js proxies these)
window.__wmmLegacyState = state;
